var regionData = [{
  "children": [{
    "children": [{
      "value": "东城区",
      "label": "东城区",
      "code": "100009"
    }, {
      "value": "西城区",
      "label": "西城区",
      "code": "100035"
    }, {
      "value": "朝阳区",
      "label": "朝阳区",
      "code": "100102"
    }, {
      "value": "丰台区",
      "label": "丰台区",
      "code": "100076"
    }, {
      "value": "石景山区",
      "label": "石景山区",
      "code": "100041"
    }, {
      "value": "海淀区",
      "label": "海淀区",
      "code": "100039"
    }, {
      "value": "门头沟区",
      "label": "门头沟区",
      "code": "102301"
    }, {
      "value": "房山区",
      "label": "房山区",
      "code": "102401"
    }, {
      "value": "通州区",
      "label": "通州区",
      "code": "101103"
    }, {
      "value": "顺义区",
      "label": "顺义区",
      "code": "101301"
    }, {
      "value": "昌平区",
      "label": "昌平区",
      "code": "102211"
    }, {
      "value": "大兴区",
      "label": "大兴区",
      "code": "102615"
    }, {
      "value": "怀柔区",
      "label": "怀柔区",
      "code": "101405"
    }, {
      "value": "平谷区",
      "label": "平谷区",
      "code": "101201"
    }, {
      "value": "密云区",
      "label": "密云区",
      "code": "101501"
    }, {
      "value": "延庆区",
      "label": "延庆区",
      "code": "102101"
    }],
    "value": "市辖区",
    "label": "市辖区"
  }],
  "value": "北京市",
  "label": "北京市"
}, {
  "children": [{
    "children": [{
      "value": "和平区",
      "label": "和平区",
      "code": "300021"
    }, {
      "value": "河东区",
      "label": "河东区",
      "code": "300161"
    }, {
      "value": "河西区",
      "label": "河西区",
      "code": "300211"
    }, {
      "value": "南开区",
      "label": "南开区",
      "code": "300191"
    }, {
      "value": "河北区",
      "label": "河北区",
      "code": "300241"
    }, {
      "value": "红桥区",
      "label": "红桥区",
      "code": "300131"
    }, {
      "value": "东丽区",
      "label": "东丽区",
      "code": "300163"
    }, {
      "value": "西青区",
      "label": "西青区",
      "code": "300381"
    }, {
      "value": "津南区",
      "label": "津南区",
      "code": "300353"
    }, {
      "value": "北辰区",
      "label": "北辰区",
      "code": "300402"
    }, {
      "value": "武清区",
      "label": "武清区",
      "code": "301732"
    }, {
      "value": "宝坻区",
      "label": "宝坻区",
      "code": "301831"
    }, {
      "value": "滨海新区",
      "label": "滨海新区",
      "code": "300457 "
    }, {
      "value": "宁河区",
      "label": "宁河区",
      "code": "301501"
    }, {
      "value": "静海区",
      "label": "静海区",
      "code": "301601"
    }],
    "value": "市辖区",
    "label": "市辖区"
  }, {
    "children": [{
      "value": "蓟县",
      "label": "蓟县",
      "code": "301906"
    }],
    "value": "辖县",
    "label": "辖县"
  }],
  "value": "天津市",
  "label": "天津市"
}, {
  "children": [{
    "children": [{
      "value": "长安区",
      "label": "长安区",
      "code": "050049"
    }, {
      "value": "桥西区",
      "label": "桥西区",
      "code": "050051"
    }, {
      "value": "新华区",
      "label": "新华区",
      "code": "050061"
    }, {
      "value": "井陉矿区",
      "label": "井陉矿区",
      "code": "050101"
    }, {
      "value": "裕华区",
      "label": "裕华区",
      "code": "050035"
    }, {
      "value": "藁城区",
      "label": "藁城区",
      "code": "052161"
    }, {
      "value": "鹿泉区",
      "label": "鹿泉区",
      "code": "050201"
    }, {
      "value": "栾城区",
      "label": "栾城区",
      "code": "051431"
    }, {
      "value": "井陉县",
      "label": "井陉县",
      "code": "050301"
    }, {
      "value": "正定县",
      "label": "正定县",
      "code": "050801"
    }, {
      "value": "行唐县",
      "label": "行唐县",
      "code": "050601"
    }, {
      "value": "灵寿县",
      "label": "灵寿县",
      "code": "050502"
    }, {
      "value": "高邑县",
      "label": "高邑县",
      "code": "051331"
    }, {
      "value": "深泽县",
      "label": "深泽县",
      "code": "052561"
    }, {
      "value": "赞皇县",
      "label": "赞皇县",
      "code": "051231"
    }, {
      "value": "无极县",
      "label": "无极县",
      "code": "052461"
    }, {
      "value": "平山县",
      "label": "平山县",
      "code": "050404"
    }, {
      "value": "元氏县",
      "label": "元氏县",
      "code": "051134"
    }, {
      "value": "赵县",
      "label": "赵县",
      "code": "051531"
    }, {
      "value": "辛集市",
      "label": "辛集市",
      "code": "052361"
    }, {
      "value": "晋州市",
      "label": "晋州市",
      "code": "052263"
    }, {
      "value": "新乐市",
      "label": "新乐市",
      "code": "050701"
    }],
    "value": "石家庄市",
    "label": "石家庄市"
  }, {
    "children": [{
      "value": "路南区",
      "label": "路南区",
      "code": "063001"
    }, {
      "value": "路北区",
      "label": "路北区",
      "code": "063001"
    }, {
      "value": "古冶区",
      "label": "古冶区",
      "code": "063101"
    }, {
      "value": "开平区",
      "label": "开平区",
      "code": "063022"
    }, {
      "value": "丰南区",
      "label": "丰南区",
      "code": "063301"
    }, {
      "value": "丰润区",
      "label": "丰润区",
      "code": "064002"
    }, {
      "value": "曹妃甸区",
      "label": "曹妃甸区",
      "code": "063201"
    }, {
      "value": "滦县",
      "label": "滦县",
      "code": "063703"
    }, {
      "value": "滦南县",
      "label": "滦南县",
      "code": "063504"
    }, {
      "value": "乐亭县",
      "label": "乐亭县",
      "code": "063601"
    }, {
      "value": "迁西县",
      "label": "迁西县",
      "code": "064301"
    }, {
      "value": "玉田县",
      "label": "玉田县",
      "code": "064103"
    }, {
      "value": "遵化市",
      "label": "遵化市",
      "code": "064203"
    }, {
      "value": "迁安市",
      "label": "迁安市",
      "code": "064411"
    }],
    "value": "唐山市",
    "label": "唐山市"
  }, {
    "children": [{
      "value": "海港区",
      "label": "海港区",
      "code": "066001"
    }, {
      "value": "山海关区",
      "label": "山海关区",
      "code": "066201"
    }, {
      "value": "北戴河区",
      "label": "北戴河区",
      "code": "066102"
    }, {
      "value": "抚宁区",
      "label": "抚宁区",
      "code": "066301"
    }, {
      "value": "青龙满族自治县",
      "label": "青龙满族自治县",
      "code": "066501"
    }, {
      "value": "昌黎县",
      "label": "昌黎县",
      "code": "066607"
    }, {
      "value": "卢龙县",
      "label": "卢龙县",
      "code": "066401"
    }],
    "value": "秦皇岛市",
    "label": "秦皇岛市"
  }, {
    "children": [{
      "value": "邯山区",
      "label": "邯山区",
      "code": "056001"
    }, {
      "value": "丛台区",
      "label": "丛台区",
      "code": "056002"
    }, {
      "value": "复兴区",
      "label": "复兴区",
      "code": "056003"
    }, {
      "value": "峰峰矿区",
      "label": "峰峰矿区",
      "code": "056201"
    }, {
      "value": "邯郸县",
      "label": "邯郸县",
      "code": "056105"
    }, {
      "value": "临漳县",
      "label": "临漳县",
      "code": "056601"
    }, {
      "value": "成安县",
      "label": "成安县",
      "code": "056701"
    }, {
      "value": "大名县",
      "label": "大名县",
      "code": "056903"
    }, {
      "value": "涉县",
      "label": "涉县",
      "code": "056401"
    }, {
      "value": "磁县",
      "label": "磁县",
      "code": "056501"
    }, {
      "value": "肥乡县",
      "label": "肥乡县",
      "code": "057551"
    }, {
      "value": "永年县",
      "label": "永年县",
      "code": "057151"
    }, {
      "value": "邱县",
      "label": "邱县",
      "code": "057451"
    }, {
      "value": "鸡泽县",
      "label": "鸡泽县",
      "code": "057351"
    }, {
      "value": "广平县",
      "label": "广平县",
      "code": "057651"
    }, {
      "value": "馆陶县",
      "label": "馆陶县",
      "code": "057753"
    }, {
      "value": "魏县",
      "label": "魏县",
      "code": "056801"
    }, {
      "value": "曲周县",
      "label": "曲周县",
      "code": "057251"
    }, {
      "value": "武安市",
      "label": "武安市",
      "code": "056301"
    }],
    "value": "邯郸市",
    "label": "邯郸市"
  }, {
    "children": [{
      "value": "桥东区",
      "label": "桥东区",
      "code": "054001"
    }, {
      "value": "桥西区",
      "label": "桥西区",
      "code": "054001"
    }, {
      "value": "邢台县",
      "label": "邢台县",
      "code": "054009"
    }, {
      "value": "临城县",
      "label": "临城县",
      "code": "054301"
    }, {
      "value": "内丘县",
      "label": "内丘县",
      "code": "054201"
    }, {
      "value": "柏乡县",
      "label": "柏乡县",
      "code": "055451"
    }, {
      "value": "隆尧县",
      "label": "隆尧县",
      "code": "055351"
    }, {
      "value": "任县",
      "label": "任县",
      "code": "055151"
    }, {
      "value": "南和县",
      "label": "南和县",
      "code": "054401"
    }, {
      "value": "宁晋县",
      "label": "宁晋县",
      "code": "055551"
    }, {
      "value": "巨鹿县",
      "label": "巨鹿县",
      "code": "055252"
    }, {
      "value": "新河县",
      "label": "新河县",
      "code": "055651"
    }, {
      "value": "广宗县",
      "label": "广宗县",
      "code": "054601"
    }, {
      "value": "平乡县",
      "label": "平乡县",
      "code": "054501"
    }, {
      "value": "威县",
      "label": "威县",
      "code": "054703"
    }, {
      "value": "清河县",
      "label": "清河县",
      "code": "054801"
    }, {
      "value": "临西县",
      "label": "临西县",
      "code": "054901"
    }, {
      "value": "南宫市",
      "label": "南宫市",
      "code": "055751"
    }, {
      "value": "沙河市",
      "label": "沙河市",
      "code": "054101"
    }],
    "value": "邢台市",
    "label": "邢台市"
  }, {
    "children": [{
      "value": "新市区",
      "label": "新市区",
      "code": "071052"
    }, {
      "value": "莲池区",
      "label": "莲池区",
      "code": "071001"
    }, {
      "value": "满城区",
      "label": "满城区",
      "code": "072151"
    }, {
      "value": "清苑区",
      "label": "清苑区",
      "code": "071101"
    }, {
      "value": "徐水区",
      "label": "徐水区",
      "code": "072551"
    }, {
      "value": "涞水县",
      "label": "涞水县",
      "code": "074101"
    }, {
      "value": "阜平县",
      "label": "阜平县",
      "code": "073201"
    }, {
      "value": "定兴县",
      "label": "定兴县",
      "code": "072652"
    }, {
      "value": "唐县",
      "label": "唐县",
      "code": "072351"
    }, {
      "value": "高阳县",
      "label": "高阳县",
      "code": "071504"
    }, {
      "value": "容城县",
      "label": "容城县",
      "code": "071701"
    }, {
      "value": "涞源县",
      "label": "涞源县",
      "code": "074301"
    }, {
      "value": "望都县",
      "label": "望都县",
      "code": "072451"
    }, {
      "value": "安新县",
      "label": "安新县",
      "code": "071603"
    }, {
      "value": "易县",
      "label": "易县",
      "code": "074206"
    }, {
      "value": "曲阳县",
      "label": "曲阳县",
      "code": "073103"
    }, {
      "value": "蠡县",
      "label": "蠡县",
      "code": "071401"
    }, {
      "value": "顺平县",
      "label": "顺平县",
      "code": "072254"
    }, {
      "value": "博野县",
      "label": "博野县",
      "code": "071301"
    }, {
      "value": "雄县",
      "label": "雄县",
      "code": "071802"
    }, {
      "value": "涿州市",
      "label": "涿州市",
      "code": "072751"
    }, {
      "value": "定州市",
      "label": "定州市",
      "code": "073001"
    }, {
      "value": "安国市",
      "label": "安国市",
      "code": "071201"
    }, {
      "value": "高碑店市",
      "label": "高碑店市",
      "code": "074002"
    }],
    "value": "保定市",
    "label": "保定市"
  }, {
    "children": [{
      "value": "桥东区",
      "label": "桥东区",
      "code": "075051"
    }, {
      "value": "桥西区",
      "label": "桥西区",
      "code": "075001"
    }, {
      "value": "宣化区",
      "label": "宣化区",
      "code": "075101"
    }, {
      "value": "下花园区",
      "label": "下花园区",
      "code": "075301"
    }, {
      "value": "宣化县",
      "label": "宣化县",
      "code": "075146"
    }, {
      "value": "张北县",
      "label": "张北县",
      "code": "076451"
    }, {
      "value": "康保县",
      "label": "康保县",
      "code": "076651"
    }, {
      "value": "沽源县",
      "label": "沽源县",
      "code": "076551"
    }, {
      "value": "尚义县",
      "label": "尚义县",
      "code": "076751"
    }, {
      "value": "蔚县",
      "label": "蔚县",
      "code": "075735"
    }, {
      "value": "阳原县",
      "label": "阳原县",
      "code": "075801"
    }, {
      "value": "怀安县",
      "label": "怀安县",
      "code": "076151"
    }, {
      "value": "万全县",
      "label": "万全县",
      "code": "076251"
    }, {
      "value": "怀来县",
      "label": "怀来县",
      "code": "075431"
    }, {
      "value": "涿鹿县",
      "label": "涿鹿县",
      "code": "075601"
    }, {
      "value": "赤城县",
      "label": "赤城县",
      "code": "075511"
    }, {
      "value": "崇礼县",
      "label": "崇礼县",
      "code": "076351"
    }],
    "value": "张家口市",
    "label": "张家口市"
  }, {
    "children": [{
      "value": "双桥区",
      "label": "双桥区",
      "code": "067001"
    }, {
      "value": "双滦区",
      "label": "双滦区",
      "code": "067001"
    }, {
      "value": "鹰手营子矿区",
      "label": "鹰手营子矿区",
      "code": "067101"
    }, {
      "value": "承德县",
      "label": "承德县",
      "code": "067401"
    }, {
      "value": "兴隆县",
      "label": "兴隆县",
      "code": "067301"
    }, {
      "value": "平泉县",
      "label": "平泉县",
      "code": "067503"
    }, {
      "value": "滦平县",
      "label": "滦平县",
      "code": "068252"
    }, {
      "value": "隆化县",
      "label": "隆化县",
      "code": "068151"
    }, {
      "value": "丰宁满族自治县",
      "label": "丰宁满族自治县",
      "code": "068351"
    }, {
      "value": "宽城满族自治县",
      "label": "宽城满族自治县",
      "code": "067603"
    }, {
      "value": "围场满族蒙古族自治县",
      "label": "围场满族蒙古族自治县",
      "code": "068467"
    }],
    "value": "承德市",
    "label": "承德市"
  }, {
    "children": [{
      "value": "新华区",
      "label": "新华区",
      "code": "061001"
    }, {
      "value": "运河区",
      "label": "运河区",
      "code": "061001"
    }, {
      "value": "沧县",
      "label": "沧县",
      "code": "061037"
    }, {
      "value": "青县",
      "label": "青县",
      "code": "062651"
    }, {
      "value": "东光县",
      "label": "东光县",
      "code": "061601"
    }, {
      "value": "海兴县",
      "label": "海兴县",
      "code": "061205"
    }, {
      "value": "盐山县",
      "label": "盐山县",
      "code": "061301"
    }, {
      "value": "肃宁县",
      "label": "肃宁县",
      "code": "062353"
    }, {
      "value": "南皮县",
      "label": "南皮县",
      "code": "061506"
    }, {
      "value": "吴桥县",
      "label": "吴桥县",
      "code": "061805"
    }, {
      "value": "献县",
      "label": "献县",
      "code": "062251"
    }, {
      "value": "孟村回族自治县",
      "label": "孟村回族自治县",
      "code": "061402"
    }, {
      "value": "泊头市",
      "label": "泊头市",
      "code": "062159"
    }, {
      "value": "任丘市",
      "label": "任丘市",
      "code": "062551"
    }, {
      "value": "黄骅市",
      "label": "黄骅市",
      "code": "061109"
    }, {
      "value": "河间市",
      "label": "河间市",
      "code": "062451"
    }],
    "value": "沧州市",
    "label": "沧州市"
  }, {
    "children": [{
      "value": "安次区",
      "label": "安次区",
      "code": "065001"
    }, {
      "value": "广阳区",
      "label": "广阳区",
      "code": "065001"
    }, {
      "value": "固安县",
      "label": "固安县",
      "code": "065501"
    }, {
      "value": "永清县",
      "label": "永清县",
      "code": "065601"
    }, {
      "value": "香河县",
      "label": "香河县",
      "code": "065401"
    }, {
      "value": "大城县",
      "label": "大城县",
      "code": "065901"
    }, {
      "value": "文安县",
      "label": "文安县",
      "code": "065801"
    }, {
      "value": "大厂回族自治县",
      "label": "大厂回族自治县",
      "code": "065701"
    }, {
      "value": "霸州市",
      "label": "霸州市",
      "code": "065701"
    }, {
      "value": "三河市",
      "label": "三河市",
      "code": "065201"
    }],
    "value": "廊坊市",
    "label": "廊坊市"
  }, {
    "children": [{
      "value": "桃城区",
      "label": "桃城区",
      "code": "053001"
    }, {
      "value": "枣强县",
      "label": "枣强县",
      "code": "053101"
    }, {
      "value": "武邑县",
      "label": "武邑县",
      "code": "053401"
    }, {
      "value": "武强县",
      "label": "武强县",
      "code": "053311"
    }, {
      "value": "饶阳县",
      "label": "饶阳县",
      "code": "053901"
    }, {
      "value": "安平县",
      "label": "安平县",
      "code": "053601"
    }, {
      "value": "故城县",
      "label": "故城县",
      "code": "253801"
    }, {
      "value": "景县",
      "label": "景县",
      "code": "053501"
    }, {
      "value": "阜城县",
      "label": "阜城县",
      "code": "053701"
    }, {
      "value": "冀州市",
      "label": "冀州市",
      "code": "053202"
    }, {
      "value": "深州市",
      "label": "深州市",
      "code": "053801"
    }],
    "value": "衡水市",
    "label": "衡水市"
  }],
  "value": "河北省",
  "label": "河北省"
}, {
  "children": [{
    "children": [{
      "value": "小店区",
      "label": "小店区",
      "code": "030012"
    }, {
      "value": "迎泽区",
      "label": "迎泽区",
      "code": "030012"
    }, {
      "value": "杏花岭区",
      "label": "杏花岭区",
      "code": "030001"
    }, {
      "value": "尖草坪区",
      "label": "尖草坪区",
      "code": "030008"
    }, {
      "value": "万柏林区",
      "label": "万柏林区",
      "code": "030024"
    }, {
      "value": "晋源区",
      "label": "晋源区",
      "code": "030054"
    }, {
      "value": "清徐县",
      "label": "清徐县",
      "code": "030401"
    }, {
      "value": "阳曲县",
      "label": "阳曲县",
      "code": "030101"
    }, {
      "value": "娄烦县",
      "label": "娄烦县",
      "code": "030301"
    }, {
      "value": "古交市",
      "label": "古交市",
      "code": "030201"
    }],
    "value": "太原市",
    "label": "太原市"
  }, {
    "children": [{
      "value": "矿区",
      "label": "矿区",
      "code": "037039"
    }, {
      "value": "南郊区",
      "label": "南郊区",
      "code": "037001"
    }, {
      "value": "新荣区",
      "label": "新荣区",
      "code": "037002"
    }, {
      "value": "阳高县",
      "label": "阳高县",
      "code": "038101"
    }, {
      "value": "天镇县",
      "label": "天镇县",
      "code": "038203"
    }, {
      "value": "广灵县",
      "label": "广灵县",
      "code": "037506"
    }, {
      "value": "灵丘县",
      "label": "灵丘县",
      "code": "034401"
    }, {
      "value": "浑源县",
      "label": "浑源县",
      "code": "037403"
    }, {
      "value": "左云县",
      "label": "左云县",
      "code": "037101"
    }, {
      "value": "大同县",
      "label": "大同县",
      "code": "037301"
    }],
    "value": "大同市",
    "label": "大同市"
  }, {
    "children": [{
      "value": "矿区",
      "label": "矿区",
      "code": "045008"
    }, {
      "value": "平定县",
      "label": "平定县",
      "code": "045201"
    }, {
      "value": "盂县",
      "label": "盂县",
      "code": "045101"
    }],
    "value": "阳泉市",
    "label": "阳泉市"
  }, {
    "children": [{
      "value": "长治县",
      "label": "长治县",
      "code": "047101"
    }, {
      "value": "襄垣县",
      "label": "襄垣县",
      "code": "046201"
    }, {
      "value": "屯留县",
      "label": "屯留县",
      "code": "046101"
    }, {
      "value": "平顺县",
      "label": "平顺县",
      "code": "047401"
    }, {
      "value": "黎城县",
      "label": "黎城县",
      "code": "047601"
    }, {
      "value": "壶关县",
      "label": "壶关县",
      "code": "047306"
    }, {
      "value": "长子县",
      "label": "长子县",
      "code": "046601"
    }, {
      "value": "武乡县",
      "label": "武乡县",
      "code": "046301"
    }, {
      "value": "沁县",
      "label": "沁县",
      "code": "046401"
    }, {
      "value": "沁源县",
      "label": "沁源县",
      "code": "046501"
    }, {
      "value": "潞城市",
      "label": "潞城市",
      "code": "047501"
    }],
    "value": "长治市",
    "label": "长治市"
  }, {
    "children": [{
      "value": "沁水县",
      "label": "沁水县",
      "code": "048201"
    }, {
      "value": "阳城县",
      "label": "阳城县",
      "code": "048103"
    }, {
      "value": "陵川县",
      "label": "陵川县",
      "code": "048304"
    }, {
      "value": "泽州县",
      "label": "泽州县",
      "code": "048014"
    }, {
      "value": "高平市",
      "label": "高平市",
      "code": "048403"
    }],
    "value": "晋城市",
    "label": "晋城市"
  }, {
    "children": [{
      "value": "朔城区",
      "label": "朔城区",
      "code": "036005"
    }, {
      "value": "平鲁区",
      "label": "平鲁区",
      "code": "036801"
    }, {
      "value": "山阴县",
      "label": "山阴县",
      "code": "036901"
    }, {
      "value": "应县",
      "label": "应县",
      "code": "037601"
    }, {
      "value": "右玉县",
      "label": "右玉县",
      "code": "037201"
    }, {
      "value": "怀仁县",
      "label": "怀仁县",
      "code": "038301"
    }],
    "value": "朔州市",
    "label": "朔州市"
  }, {
    "children": [{
      "value": "榆次区",
      "label": "榆次区",
      "code": "030601"
    }, {
      "value": "榆社县",
      "label": "榆社县",
      "code": "031807"
    }, {
      "value": "左权县",
      "label": "左权县",
      "code": "032601"
    }, {
      "value": "和顺县",
      "label": "和顺县",
      "code": "032702"
    }, {
      "value": "昔阳县",
      "label": "昔阳县",
      "code": "045301"
    }, {
      "value": "寿阳县",
      "label": "寿阳县",
      "code": "045401"
    }, {
      "value": "太谷县",
      "label": "太谷县",
      "code": "030801"
    }, {
      "value": "祁县",
      "label": "祁县",
      "code": "030901"
    }, {
      "value": "平遥县",
      "label": "平遥县",
      "code": "031101"
    }, {
      "value": "灵石县",
      "label": "灵石县",
      "code": "031301"
    }, {
      "value": "介休市",
      "label": "介休市",
      "code": "032001"
    }],
    "value": "晋中市",
    "label": "晋中市"
  }, {
    "children": [{
      "value": "盐湖区",
      "label": "盐湖区",
      "code": "044001"
    }, {
      "value": "临猗县",
      "label": "临猗县",
      "code": "044105"
    }, {
      "value": "万荣县",
      "label": "万荣县",
      "code": "044201"
    }, {
      "value": "闻喜县",
      "label": "闻喜县",
      "code": "043801"
    }, {
      "value": "稷山县",
      "label": "稷山县",
      "code": "043201"
    }, {
      "value": "新绛县",
      "label": "新绛县",
      "code": "043101"
    }, {
      "value": "绛县",
      "label": "绛县",
      "code": "043601"
    }, {
      "value": "垣曲县",
      "label": "垣曲县",
      "code": "043701"
    }, {
      "value": "夏县",
      "label": "夏县",
      "code": "044401"
    }, {
      "value": "平陆县",
      "label": "平陆县",
      "code": "044301"
    }, {
      "value": "芮城县",
      "label": "芮城县",
      "code": "044601"
    }, {
      "value": "永济市",
      "label": "永济市",
      "code": "044501"
    }, {
      "value": "河津市",
      "label": "河津市",
      "code": "043301"
    }],
    "value": "运城市",
    "label": "运城市"
  }, {
    "children": [{
      "value": "忻府区",
      "label": "忻府区",
      "code": "034026"
    }, {
      "value": "定襄县",
      "label": "定襄县",
      "code": "035401"
    }, {
      "value": "五台县",
      "label": "五台县",
      "code": "035506"
    }, {
      "value": "代县",
      "label": "代县",
      "code": "034201"
    }, {
      "value": "繁峙县",
      "label": "繁峙县",
      "code": "034301"
    }, {
      "value": "宁武县",
      "label": "宁武县",
      "code": "036707"
    }, {
      "value": "静乐县",
      "label": "静乐县",
      "code": "035101"
    }, {
      "value": "神池县",
      "label": "神池县",
      "code": "036105"
    }, {
      "value": "五寨县",
      "label": "五寨县",
      "code": "036201"
    }, {
      "value": "岢岚县",
      "label": "岢岚县",
      "code": "036301"
    }, {
      "value": "河曲县",
      "label": "河曲县",
      "code": "036501"
    }, {
      "value": "保德县",
      "label": "保德县",
      "code": "036605"
    }, {
      "value": "偏关县",
      "label": "偏关县",
      "code": "036406"
    }, {
      "value": "原平市",
      "label": "原平市",
      "code": "034101"
    }],
    "value": "忻州市",
    "label": "忻州市"
  }, {
    "children": [{
      "value": "尧都区",
      "label": "尧都区",
      "code": "041001"
    }, {
      "value": "曲沃县",
      "label": "曲沃县",
      "code": "043403"
    }, {
      "value": "翼城县",
      "label": "翼城县",
      "code": "043501"
    }, {
      "value": "襄汾县",
      "label": "襄汾县",
      "code": "041501"
    }, {
      "value": "洪洞县",
      "label": "洪洞县",
      "code": "041601"
    }, {
      "value": "古县",
      "label": "古县",
      "code": "042401"
    }, {
      "value": "安泽县",
      "label": "安泽县",
      "code": "042501"
    }, {
      "value": "浮山县",
      "label": "浮山县",
      "code": "042601"
    }, {
      "value": "吉县",
      "label": "吉县",
      "code": "042201"
    }, {
      "value": "乡宁县",
      "label": "乡宁县",
      "code": "042101"
    }, {
      "value": "大宁县",
      "label": "大宁县",
      "code": "042301"
    }, {
      "value": "隰县",
      "label": "隰县",
      "code": "041301"
    }, {
      "value": "永和县",
      "label": "永和县",
      "code": "041401"
    }, {
      "value": "蒲县",
      "label": "蒲县",
      "code": "041203"
    }, {
      "value": "汾西县",
      "label": "汾西县",
      "code": "031501"
    }, {
      "value": "侯马市",
      "label": "侯马市",
      "code": "043001"
    }, {
      "value": "霍州市",
      "label": "霍州市",
      "code": "031401"
    }],
    "value": "临汾市",
    "label": "临汾市"
  }, {
    "children": [{
      "value": "离石区",
      "label": "离石区",
      "code": "033001"
    }, {
      "value": "文水县",
      "label": "文水县",
      "code": "032101"
    }, {
      "value": "交城县",
      "label": "交城县",
      "code": "030501"
    }, {
      "value": "兴县",
      "label": "兴县",
      "code": "033601"
    }, {
      "value": "临县",
      "label": "临县",
      "code": "033201"
    }, {
      "value": "柳林县",
      "label": "柳林县",
      "code": "033301"
    }, {
      "value": "石楼县",
      "label": "石楼县",
      "code": "032501"
    }, {
      "value": "岚县",
      "label": "岚县",
      "code": "033501"
    }, {
      "value": "方山县",
      "label": "方山县",
      "code": "033101"
    }, {
      "value": "中阳县",
      "label": "中阳县",
      "code": "033401"
    }, {
      "value": "交口县",
      "label": "交口县",
      "code": "032401"
    }, {
      "value": "孝义市",
      "label": "孝义市",
      "code": "032301"
    }, {
      "value": "汾阳市",
      "label": "汾阳市",
      "code": "032201"
    }],
    "value": "吕梁市",
    "label": "吕梁市"
  }],
  "value": "山西省",
  "label": "山西省"
}, {
  "children": [{
    "children": [{
      "value": "新城区",
      "label": "新城区",
      "code": "010051"
    }, {
      "value": "回民区",
      "label": "回民区",
      "code": "010051"
    }, {
      "value": "玉泉区",
      "label": "玉泉区",
      "code": "010031"
    }, {
      "value": "赛罕区",
      "label": "赛罕区",
      "code": "010071"
    }, {
      "value": "土默特左旗",
      "label": "土默特左旗",
      "code": "010108"
    }, {
      "value": "托克托县",
      "label": "托克托县",
      "code": "010205"
    }, {
      "value": "和林格尔县",
      "label": "和林格尔县",
      "code": "011505"
    }, {
      "value": "清水河县",
      "label": "清水河县",
      "code": "011601"
    }, {
      "value": "武川县",
      "label": "武川县",
      "code": "011705"
    }],
    "value": "呼和浩特市",
    "label": "呼和浩特市"
  }, {
    "children": [{
      "value": "东河区",
      "label": "东河区",
      "code": "014041"
    }, {
      "value": "昆都仑区",
      "label": "昆都仑区",
      "code": "014011"
    }, {
      "value": "青山区",
      "label": "青山区",
      "code": "014031"
    }, {
      "value": "石拐区",
      "label": "石拐区",
      "code": "014071"
    }, {
      "value": "白云鄂博矿区",
      "label": "白云鄂博矿区",
      "code": "014081"
    }, {
      "value": "九原区",
      "label": "九原区",
      "code": "014061"
    }, {
      "value": "土默特右旗",
      "label": "土默特右旗",
      "code": "014101"
    }, {
      "value": "固阳县",
      "label": "固阳县",
      "code": "014201"
    }, {
      "value": "达尔罕茂明安联合旗",
      "label": "达尔罕茂明安联合旗",
      "code": "014501"
    }],
    "value": "包头市",
    "label": "包头市"
  }, {
    "children": [{
      "value": "海勃湾区",
      "label": "海勃湾区",
      "code": "016001"
    }, {
      "value": "海南区",
      "label": "海南区",
      "code": "016035"
    }, {
      "value": "乌达区",
      "label": "乌达区",
      "code": "016041"
    }],
    "value": "乌海市",
    "label": "乌海市"
  }, {
    "children": [{
      "value": "红山区",
      "label": "红山区",
      "code": "024001"
    }, {
      "value": "元宝山区",
      "label": "元宝山区",
      "code": "024076"
    }, {
      "value": "松山区",
      "label": "松山区",
      "code": "024005"
    }, {
      "value": "阿鲁科尔沁旗",
      "label": "阿鲁科尔沁旗",
      "code": "025562"
    }, {
      "value": "巴林左旗",
      "label": "巴林左旗",
      "code": "025472"
    }, {
      "value": "巴林右旗",
      "label": "巴林右旗",
      "code": "025172"
    }, {
      "value": "林西县",
      "label": "林西县",
      "code": "025265"
    }, {
      "value": "克什克腾旗",
      "label": "克什克腾旗",
      "code": "025358"
    }, {
      "value": "翁牛特旗",
      "label": "翁牛特旗",
      "code": "024509"
    }, {
      "value": "喀喇沁旗",
      "label": "喀喇沁旗",
      "code": "024411"
    }, {
      "value": "宁城县",
      "label": "宁城县",
      "code": "024216"
    }, {
      "value": "敖汉旗",
      "label": "敖汉旗",
      "code": "024301"
    }],
    "value": "赤峰市",
    "label": "赤峰市"
  }, {
    "children": [{
      "value": "科尔沁区",
      "label": "科尔沁区",
      "code": "028036"
    }, {
      "value": "科尔沁左翼中旗",
      "label": "科尔沁左翼中旗",
      "code": "029301"
    }, {
      "value": "科尔沁左翼后旗",
      "label": "科尔沁左翼后旗",
      "code": "028101"
    }, {
      "value": "开鲁县",
      "label": "开鲁县",
      "code": "028408"
    }, {
      "value": "库伦旗",
      "label": "库伦旗",
      "code": "028201"
    }, {
      "value": "奈曼旗",
      "label": "奈曼旗",
      "code": "028311"
    }, {
      "value": "扎鲁特旗",
      "label": "扎鲁特旗",
      "code": "029101"
    }, {
      "value": "霍林郭勒市",
      "label": "霍林郭勒市",
      "code": "029201"
    }],
    "value": "通辽市",
    "label": "通辽市"
  }, {
    "children": [{
      "value": "东胜区",
      "label": "东胜区",
      "code": "017001"
    }, {
      "value": "达拉特旗",
      "label": "达拉特旗",
      "code": "014301"
    }, {
      "value": "准格尔旗",
      "label": "准格尔旗",
      "code": "010301"
    }, {
      "value": "鄂托克前旗",
      "label": "鄂托克前旗",
      "code": "016201"
    }, {
      "value": "鄂托克旗",
      "label": "鄂托克旗",
      "code": "016101"
    }, {
      "value": "杭锦旗",
      "label": "杭锦旗",
      "code": "017401"
    }, {
      "value": "乌审旗",
      "label": "乌审旗",
      "code": "017301"
    }, {
      "value": "伊金霍洛旗",
      "label": "伊金霍洛旗",
      "code": "017201"
    }],
    "value": "鄂尔多斯市",
    "label": "鄂尔多斯市"
  }, {
    "children": [{
      "value": "海拉尔区",
      "label": "海拉尔区",
      "code": "021001"
    }, {
      "value": "扎赉诺尔区",
      "label": "扎赉诺尔区",
      "code": "021411"
    }, {
      "value": "阿荣旗",
      "label": "阿荣旗",
      "code": "162751"
    }, {
      "value": "莫力达瓦达斡尔族自治旗",
      "label": "莫力达瓦达斡尔族自治旗",
      "code": "162851"
    }, {
      "value": "鄂伦春自治旗",
      "label": "鄂伦春自治旗",
      "code": "165451"
    }, {
      "value": "鄂温克族自治旗",
      "label": "鄂温克族自治旗",
      "code": "021101"
    }, {
      "value": "陈巴尔虎旗",
      "label": "陈巴尔虎旗",
      "code": "021501"
    }, {
      "value": "新巴尔虎左旗",
      "label": "新巴尔虎左旗",
      "code": "021216"
    }, {
      "value": "新巴尔虎右旗",
      "label": "新巴尔虎右旗",
      "code": "021301"
    }, {
      "value": "满洲里市",
      "label": "满洲里市",
      "code": "021411"
    }, {
      "value": "牙克石市",
      "label": "牙克石市",
      "code": "022151"
    }, {
      "value": "扎兰屯市",
      "label": "扎兰屯市",
      "code": "162674"
    }, {
      "value": "额尔古纳市",
      "label": "额尔古纳市",
      "code": "022251"
    }, {
      "value": "根河市",
      "label": "根河市",
      "code": "022359"
    }],
    "value": "呼伦贝尔市",
    "label": "呼伦贝尔市"
  }, {
    "children": [{
      "value": "临河区",
      "label": "临河区",
      "code": "015001"
    }, {
      "value": "五原县",
      "label": "五原县",
      "code": "015101"
    }, {
      "value": "磴口县",
      "label": "磴口县",
      "code": "015215"
    }, {
      "value": "乌拉特前旗",
      "label": "乌拉特前旗",
      "code": "014428"
    }, {
      "value": "乌拉特中旗",
      "label": "乌拉特中旗",
      "code": "015321"
    }, {
      "value": "乌拉特后旗",
      "label": "乌拉特后旗",
      "code": "015543"
    }, {
      "value": "杭锦后旗",
      "label": "杭锦后旗",
      "code": "015401"
    }],
    "value": "巴彦淖尔市",
    "label": "巴彦淖尔市"
  }, {
    "children": [{
      "value": "集宁区",
      "label": "集宁区",
      "code": "012001"
    }, {
      "value": "卓资县",
      "label": "卓资县",
      "code": "012306"
    }, {
      "value": "化德县",
      "label": "化德县",
      "code": "013351"
    }, {
      "value": "商都县",
      "label": "商都县",
      "code": "013451"
    }, {
      "value": "兴和县",
      "label": "兴和县",
      "code": "013651"
    }, {
      "value": "凉城县",
      "label": "凉城县",
      "code": "013761"
    }, {
      "value": "察哈尔右翼前旗",
      "label": "察哈尔右翼前旗",
      "code": "012201"
    }, {
      "value": "察哈尔右翼中旗",
      "label": "察哈尔右翼中旗",
      "code": "013558"
    }, {
      "value": "察哈尔右翼后旗",
      "label": "察哈尔右翼后旗",
      "code": "012408"
    }, {
      "value": "四子王旗",
      "label": "四子王旗",
      "code": "011801"
    }, {
      "value": "丰镇市",
      "label": "丰镇市",
      "code": "012101"
    }],
    "value": "乌兰察布市",
    "label": "乌兰察布市"
  }, {
    "children": [{
      "value": "乌兰浩特市",
      "label": "乌兰浩特市",
      "code": "137401"
    }, {
      "value": "阿尔山市",
      "label": "阿尔山市",
      "code": "137801"
    }, {
      "value": "科尔沁右翼前旗",
      "label": "科尔沁右翼前旗",
      "code": "137725"
    }, {
      "value": "科尔沁右翼中旗",
      "label": "科尔沁右翼中旗",
      "code": "029422"
    }, {
      "value": "扎赉特旗",
      "label": "扎赉特旗",
      "code": "137623"
    }, {
      "value": "突泉县",
      "label": "突泉县",
      "code": "137617"
    }],
    "value": "兴安盟",
    "label": "兴安盟"
  }, {
    "children": [{
      "value": "二连浩特市",
      "label": "二连浩特市",
      "code": "011101"
    }, {
      "value": "锡林浩特市",
      "label": "锡林浩特市",
      "code": "026001"
    }, {
      "value": "阿巴嘎旗",
      "label": "阿巴嘎旗",
      "code": "011413"
    }, {
      "value": "苏尼特左旗",
      "label": "苏尼特左旗",
      "code": "011367"
    }, {
      "value": "苏尼特右旗",
      "label": "苏尼特右旗",
      "code": "011218"
    }, {
      "value": "东乌珠穆沁旗",
      "label": "东乌珠穆沁旗",
      "code": "026301"
    }, {
      "value": "西乌珠穆沁旗",
      "label": "西乌珠穆沁旗",
      "code": "026201"
    }, {
      "value": "太仆寺旗",
      "label": "太仆寺旗",
      "code": "027015"
    }, {
      "value": "镶黄旗",
      "label": "镶黄旗",
      "code": "013251"
    }, {
      "value": "正镶白旗",
      "label": "正镶白旗",
      "code": "013801"
    }, {
      "value": "正蓝旗",
      "label": "正蓝旗",
      "code": "027201"
    }, {
      "value": "多伦县",
      "label": "多伦县",
      "code": "027301"
    }],
    "value": "锡林郭勒盟",
    "label": "锡林郭勒盟"
  }, {
    "children": [{
      "value": "阿拉善左旗",
      "label": "阿拉善左旗",
      "code": "750301"
    }, {
      "value": "阿拉善右旗",
      "label": "阿拉善右旗",
      "code": "737301"
    }, {
      "value": "额济纳旗",
      "label": "额济纳旗",
      "code": "735401"
    }],
    "value": "阿拉善盟",
    "label": "阿拉善盟"
  }],
  "value": "内蒙古自治区",
  "label": "内蒙古自治区"
}, {
  "children": [{
    "children": [{
      "value": "和平区",
      "label": "和平区",
      "code": "110002"
    }, {
      "value": "沈河区",
      "label": "沈河区",
      "code": "110011"
    }, {
      "value": "大东区",
      "label": "大东区",
      "code": "110042"
    }, {
      "value": "皇姑区",
      "label": "皇姑区",
      "code": "110036"
    }, {
      "value": "铁西区",
      "label": "铁西区",
      "code": "110027"
    }, {
      "value": "苏家屯区",
      "label": "苏家屯区",
      "code": "110181"
    }, {
      "value": "东陵区",
      "label": "东陵区",
      "code": "110174"
    }, {
      "value": "沈北新区",
      "label": "沈北新区",
      "code": "110123"
    }, {
      "value": "于洪区",
      "label": "于洪区",
      "code": "110141"
    }, {
      "value": "辽中县",
      "label": "辽中县",
      "code": "110201"
    }, {
      "value": "康平县",
      "label": "康平县",
      "code": "110513"
    }, {
      "value": "法库县",
      "label": "法库县",
      "code": "110416"
    }, {
      "value": "新民市",
      "label": "新民市",
      "code": "110301"
    }],
    "value": "沈阳市",
    "label": "沈阳市"
  }, {
    "children": [{
      "value": "中山区",
      "label": "中山区",
      "code": "116013"
    }, {
      "value": "西岗区",
      "label": "西岗区",
      "code": "116013"
    }, {
      "value": "沙河口区",
      "label": "沙河口区",
      "code": "116033"
    }, {
      "value": "甘井子区",
      "label": "甘井子区",
      "code": "116036"
    }, {
      "value": "旅顺口区",
      "label": "旅顺口区",
      "code": "116051"
    }, {
      "value": "金州区",
      "label": "金州区",
      "code": "116101"
    }, {
      "value": "普兰店区",
      "label": "普兰店区",
      "code": ""
    }, {
      "value": "长海县",
      "label": "长海县",
      "code": "116501"
    }, {
      "value": "瓦房店市",
      "label": "瓦房店市",
      "code": "116301"
    }, {
      "value": "庄河市",
      "label": "庄河市",
      "code": "116401"
    }],
    "value": "大连市",
    "label": "大连市"
  }, {
    "children": [{
      "value": "铁东区",
      "label": "铁东区",
      "code": "114005"
    }, {
      "value": "铁西区",
      "label": "铁西区",
      "code": "114012"
    }, {
      "value": "立山区",
      "label": "立山区",
      "code": "114033"
    }, {
      "value": "千山区",
      "label": "千山区",
      "code": "114016"
    }, {
      "value": "台安县",
      "label": "台安县",
      "code": "114107"
    }, {
      "value": "岫岩满族自治县",
      "label": "岫岩满族自治县",
      "code": "114301"
    }, {
      "value": "海城市",
      "label": "海城市",
      "code": "114201"
    }],
    "value": "鞍山市",
    "label": "鞍山市"
  }, {
    "children": [{
      "value": "新抚区",
      "label": "新抚区",
      "code": "113008"
    }, {
      "value": "东洲区",
      "label": "东洲区",
      "code": "113008"
    }, {
      "value": "望花区",
      "label": "望花区",
      "code": "113123"
    }, {
      "value": "顺城区",
      "label": "顺城区",
      "code": "113006"
    }, {
      "value": "抚顺县",
      "label": "抚顺县",
      "code": "113113"
    }, {
      "value": "新宾满族自治县",
      "label": "新宾满族自治县",
      "code": "113201"
    }, {
      "value": "清原满族自治县",
      "label": "清原满族自治县",
      "code": "113301"
    }],
    "value": "抚顺市",
    "label": "抚顺市"
  }, {
    "children": [{
      "value": "平山区",
      "label": "平山区",
      "code": "117001"
    }, {
      "value": "溪湖区",
      "label": "溪湖区",
      "code": "117019"
    }, {
      "value": "明山区",
      "label": "明山区",
      "code": "117008"
    }, {
      "value": "南芬区",
      "label": "南芬区",
      "code": "117014"
    }, {
      "value": "本溪满族自治县",
      "label": "本溪满族自治县",
      "code": "117114"
    }, {
      "value": "桓仁满族自治县",
      "label": "桓仁满族自治县",
      "code": "117213"
    }],
    "value": "本溪市",
    "label": "本溪市"
  }, {
    "children": [{
      "value": "元宝区",
      "label": "元宝区",
      "code": "118001"
    }, {
      "value": "振兴区",
      "label": "振兴区",
      "code": "118001"
    }, {
      "value": "振安区",
      "label": "振安区",
      "code": "118011"
    }, {
      "value": "宽甸满族自治县",
      "label": "宽甸满族自治县",
      "code": "118201"
    }, {
      "value": "东港市",
      "label": "东港市",
      "code": "118301"
    }, {
      "value": "凤城市",
      "label": "凤城市",
      "code": "118101"
    }],
    "value": "丹东市",
    "label": "丹东市"
  }, {
    "children": [{
      "value": "古塔区",
      "label": "古塔区",
      "code": "121001"
    }, {
      "value": "凌河区",
      "label": "凌河区",
      "code": "121017"
    }, {
      "value": "太和区",
      "label": "太和区",
      "code": "121007"
    }, {
      "value": "黑山县",
      "label": "黑山县",
      "code": "121413"
    }, {
      "value": "义县",
      "label": "义县",
      "code": "121117"
    }, {
      "value": "凌海市",
      "label": "凌海市",
      "code": "121206"
    }, {
      "value": "北镇市",
      "label": "北镇市",
      "code": "121301"
    }],
    "value": "锦州市",
    "label": "锦州市"
  }, {
    "children": [{
      "value": "站前区",
      "label": "站前区",
      "code": "115002"
    }, {
      "value": "西市区",
      "label": "西市区",
      "code": "115004"
    }, {
      "value": "鲅鱼圈区",
      "label": "鲅鱼圈区",
      "code": "115009"
    }, {
      "value": "老边区",
      "label": "老边区",
      "code": "115005"
    }, {
      "value": "盖州市",
      "label": "盖州市",
      "code": "115201"
    }, {
      "value": "大石桥市",
      "label": "大石桥市",
      "code": "115101"
    }],
    "value": "营口市",
    "label": "营口市"
  }, {
    "children": [{
      "value": "海州区",
      "label": "海州区",
      "code": "123001"
    }, {
      "value": "新邱区",
      "label": "新邱区",
      "code": "123005"
    }, {
      "value": "太平区",
      "label": "太平区",
      "code": "123003"
    }, {
      "value": "清河门区",
      "label": "清河门区",
      "code": "123006"
    }, {
      "value": "细河区",
      "label": "细河区",
      "code": "123101"
    }, {
      "value": "阜新蒙古族自治县",
      "label": "阜新蒙古族自治县",
      "code": "123111"
    }, {
      "value": "彰武县",
      "label": "彰武县",
      "code": "123211"
    }],
    "value": "阜新市",
    "label": "阜新市"
  }, {
    "children": [{
      "value": "白塔区",
      "label": "白塔区",
      "code": "111001"
    }, {
      "value": "文圣区",
      "label": "文圣区",
      "code": "111001"
    }, {
      "value": "宏伟区",
      "label": "宏伟区",
      "code": "111005"
    }, {
      "value": "弓长岭区",
      "label": "弓长岭区",
      "code": "111008"
    }, {
      "value": "太子河区",
      "label": "太子河区",
      "code": "111004"
    }, {
      "value": "辽阳县",
      "label": "辽阳县",
      "code": "111216"
    }, {
      "value": "灯塔市",
      "label": "灯塔市",
      "code": "111308"
    }],
    "value": "辽阳市",
    "label": "辽阳市"
  }, {
    "children": [{
      "value": "双台子区",
      "label": "双台子区",
      "code": "124001"
    }, {
      "value": "兴隆台区",
      "label": "兴隆台区",
      "code": "124011"
    }, {
      "value": "大洼县",
      "label": "大洼县",
      "code": "124201"
    }, {
      "value": "盘山县",
      "label": "盘山县",
      "code": "124125"
    }],
    "value": "盘锦市",
    "label": "盘锦市"
  }, {
    "children": [{
      "value": "银州区",
      "label": "银州区",
      "code": "112002"
    }, {
      "value": "清河区",
      "label": "清河区",
      "code": "112003"
    }, {
      "value": "铁岭县",
      "label": "铁岭县",
      "code": "112616"
    }, {
      "value": "西丰县",
      "label": "西丰县",
      "code": "112401"
    }, {
      "value": "昌图县",
      "label": "昌图县",
      "code": "112518"
    }, {
      "value": "调兵山市",
      "label": "调兵山市",
      "code": "112701"
    }, {
      "value": "开原市",
      "label": "开原市",
      "code": "112301"
    }],
    "value": "铁岭市",
    "label": "铁岭市"
  }, {
    "children": [{
      "value": "双塔区",
      "label": "双塔区",
      "code": "122001"
    }, {
      "value": "龙城区",
      "label": "龙城区",
      "code": "122005"
    }, {
      "value": "朝阳县",
      "label": "朝阳县",
      "code": "122606"
    }, {
      "value": "建平县",
      "label": "建平县",
      "code": "122412"
    }, {
      "value": "喀喇沁左翼蒙古族自治县",
      "label": "喀喇沁左翼蒙古族自治县",
      "code": "122301"
    }, {
      "value": "北票市",
      "label": "北票市",
      "code": "122101"
    }, {
      "value": "凌源市",
      "label": "凌源市",
      "code": "122501"
    }],
    "value": "朝阳市",
    "label": "朝阳市"
  }, {
    "children": [{
      "value": "连山区",
      "label": "连山区",
      "code": "125001"
    }, {
      "value": "龙港区",
      "label": "龙港区",
      "code": "125001"
    }, {
      "value": "南票区",
      "label": "南票区",
      "code": "125031"
    }, {
      "value": "绥中县",
      "label": "绥中县",
      "code": "125214"
    }, {
      "value": "建昌县",
      "label": "建昌县",
      "code": "125311"
    }, {
      "value": "兴城市",
      "label": "兴城市",
      "code": "125101"
    }],
    "value": "葫芦岛市",
    "label": "葫芦岛市"
  }],
  "value": "辽宁省",
  "label": "辽宁省"
}, {
  "children": [{
    "children": [{
      "value": "南关区",
      "label": "南关区",
      "code": "130022"
    }, {
      "value": "宽城区",
      "label": "宽城区",
      "code": "130052"
    }, {
      "value": "朝阳区",
      "label": "朝阳区",
      "code": "130021"
    }, {
      "value": "二道区",
      "label": "二道区",
      "code": "130031"
    }, {
      "value": "绿园区",
      "label": "绿园区",
      "code": "130062"
    }, {
      "value": "双阳区",
      "label": "双阳区",
      "code": "130605"
    }, {
      "value": "九台区",
      "label": "九台区",
      "code": "130501"
    }, {
      "value": "农安县",
      "label": "农安县",
      "code": "130205"
    }, {
      "value": "榆树市",
      "label": "榆树市",
      "code": "130401"
    }, {
      "value": "德惠市",
      "label": "德惠市",
      "code": "130301"
    }],
    "value": "长春市",
    "label": "长春市"
  }, {
    "children": [{
      "value": "昌邑区",
      "label": "昌邑区",
      "code": "132001"
    }, {
      "value": "龙潭区",
      "label": "龙潭区",
      "code": "132226"
    }, {
      "value": "船营区",
      "label": "船营区",
      "code": "132011"
    }, {
      "value": "丰满区",
      "label": "丰满区",
      "code": "132013"
    }, {
      "value": "永吉县",
      "label": "永吉县",
      "code": "132201"
    }, {
      "value": "蛟河市",
      "label": "蛟河市",
      "code": "132503"
    }, {
      "value": "桦甸市",
      "label": "桦甸市",
      "code": "132401"
    }, {
      "value": "舒兰市",
      "label": "舒兰市",
      "code": "132616"
    }, {
      "value": "磐石市",
      "label": "磐石市",
      "code": "132301"
    }],
    "value": "吉林市",
    "label": "吉林市"
  }, {
    "children": [{
      "value": "铁西区",
      "label": "铁西区",
      "code": "136001"
    }, {
      "value": "铁东区",
      "label": "铁东区",
      "code": "136001"
    }, {
      "value": "梨树县",
      "label": "梨树县",
      "code": "136512"
    }, {
      "value": "伊通满族自治县",
      "label": "伊通满族自治县",
      "code": "130708"
    }, {
      "value": "公主岭市",
      "label": "公主岭市",
      "code": "136129"
    }, {
      "value": "双辽市",
      "label": "双辽市",
      "code": "136412"
    }],
    "value": "四平市",
    "label": "四平市"
  }, {
    "children": [{
      "value": "龙山区",
      "label": "龙山区",
      "code": "136201"
    }, {
      "value": "西安区",
      "label": "西安区",
      "code": "136614"
    }, {
      "value": "东丰县",
      "label": "东丰县",
      "code": "136317"
    }, {
      "value": "东辽县",
      "label": "东辽县",
      "code": "136601"
    }],
    "value": "辽源市",
    "label": "辽源市"
  }, {
    "children": [{
      "value": "东昌区",
      "label": "东昌区",
      "code": "134001"
    }, {
      "value": "二道江区",
      "label": "二道江区",
      "code": "134006"
    }, {
      "value": "通化县",
      "label": "通化县",
      "code": "134114"
    }, {
      "value": "辉南县",
      "label": "辉南县",
      "code": "135115"
    }, {
      "value": "柳河县",
      "label": "柳河县",
      "code": "135301"
    }, {
      "value": "梅河口市",
      "label": "梅河口市",
      "code": "135022"
    }, {
      "value": "集安市",
      "label": "集安市",
      "code": "134201"
    }],
    "value": "通化市",
    "label": "通化市"
  }, {
    "children": [{
      "value": "浑江区",
      "label": "浑江区",
      "code": "134301"
    }, {
      "value": "江源区",
      "label": "江源区",
      "code": "134704"
    }, {
      "value": "抚松县",
      "label": "抚松县",
      "code": "134525"
    }, {
      "value": "靖宇县",
      "label": "靖宇县",
      "code": "135203"
    }, {
      "value": "长白朝鲜族自治县",
      "label": "长白朝鲜族自治县",
      "code": "134401"
    }, {
      "value": "临江市",
      "label": "临江市",
      "code": "134605"
    }],
    "value": "白山市",
    "label": "白山市"
  }, {
    "children": [{
      "value": "宁江区",
      "label": "宁江区",
      "code": "138012"
    }, {
      "value": "前郭尔罗斯蒙古族自治县",
      "label": "前郭尔罗斯蒙古族自治县",
      "code": "131107"
    }, {
      "value": "长岭县",
      "label": "长岭县",
      "code": "131513"
    }, {
      "value": "乾安县",
      "label": "乾安县",
      "code": "131401"
    }, {
      "value": "扶余市",
      "label": "扶余市",
      "code": "131201"
    }],
    "value": "松原市",
    "label": "松原市"
  }, {
    "children": [{
      "value": "洮北区",
      "label": "洮北区",
      "code": "137001"
    }, {
      "value": "镇赉县",
      "label": "镇赉县",
      "code": "137301"
    }, {
      "value": "通榆县",
      "label": "通榆县",
      "code": "137201"
    }, {
      "value": "洮南市",
      "label": "洮南市",
      "code": "137101"
    }, {
      "value": "大安市",
      "label": "大安市",
      "code": "131301"
    }],
    "value": "白城市",
    "label": "白城市"
  }, {
    "children": [{
      "value": "延吉市",
      "label": "延吉市",
      "code": "133001"
    }, {
      "value": "图们市",
      "label": "图们市",
      "code": "133102"
    }, {
      "value": "敦化市",
      "label": "敦化市",
      "code": "133701"
    }, {
      "value": "珲春市",
      "label": "珲春市",
      "code": "133307"
    }, {
      "value": "龙井市",
      "label": "龙井市",
      "code": "133423"
    }, {
      "value": "和龙市",
      "label": "和龙市",
      "code": "133501"
    }, {
      "value": "汪清县",
      "label": "汪清县",
      "code": "133201"
    }, {
      "value": "安图县",
      "label": "安图县",
      "code": "133601"
    }],
    "value": "延边朝鲜族自治州",
    "label": "延边朝鲜族自治州"
  }],
  "value": "吉林省",
  "label": "吉林省"
}, {
  "children": [{
    "children": [{
      "value": "道里区",
      "label": "道里区",
      "code": "150071"
    }, {
      "value": "南岗区",
      "label": "南岗区",
      "code": "150081"
    }, {
      "value": "道外区",
      "label": "道外区",
      "code": "150021"
    }, {
      "value": "平房区",
      "label": "平房区",
      "code": "150061"
    }, {
      "value": "松北区",
      "label": "松北区",
      "code": "150027"
    }, {
      "value": "香坊区",
      "label": "香坊区",
      "code": "150031"
    }, {
      "value": "呼兰区",
      "label": "呼兰区",
      "code": "150501"
    }, {
      "value": "阿城区",
      "label": "阿城区",
      "code": "150323"
    }, {
      "value": "双城区",
      "label": "双城区",
      "code": "150101"
    }, {
      "value": "依兰县",
      "label": "依兰县",
      "code": "154801"
    }, {
      "value": "方正县",
      "label": "方正县",
      "code": "150801"
    }, {
      "value": "宾县",
      "label": "宾县",
      "code": "150401"
    }, {
      "value": "巴彦县",
      "label": "巴彦县",
      "code": "151813"
    }, {
      "value": "木兰县",
      "label": "木兰县",
      "code": "151925"
    }, {
      "value": "通河县",
      "label": "通河县",
      "code": "150901"
    }, {
      "value": "延寿县",
      "label": "延寿县",
      "code": "150701"
    }, {
      "value": "尚志市",
      "label": "尚志市",
      "code": "150609"
    }, {
      "value": "五常市",
      "label": "五常市",
      "code": "150226"
    }],
    "value": "哈尔滨市",
    "label": "哈尔滨市"
  }, {
    "children": [{
      "value": "龙沙区",
      "label": "龙沙区",
      "code": "161005"
    }, {
      "value": "建华区",
      "label": "建华区",
      "code": "161006"
    }, {
      "value": "铁锋区",
      "label": "铁锋区",
      "code": "161001"
    }, {
      "value": "昂昂溪区",
      "label": "昂昂溪区",
      "code": "161033"
    }, {
      "value": "富拉尔基区",
      "label": "富拉尔基区",
      "code": "161041"
    }, {
      "value": "碾子山区",
      "label": "碾子山区",
      "code": "161046"
    }, {
      "value": "梅里斯达斡尔族区",
      "label": "梅里斯达斡尔族区",
      "code": "161021"
    }, {
      "value": "龙江县",
      "label": "龙江县",
      "code": "161102"
    }, {
      "value": "依安县",
      "label": "依安县",
      "code": "161501"
    }, {
      "value": "泰来县",
      "label": "泰来县",
      "code": "162401"
    }, {
      "value": "甘南县",
      "label": "甘南县",
      "code": "162101"
    }, {
      "value": "富裕县",
      "label": "富裕县",
      "code": "161242"
    }, {
      "value": "克山县",
      "label": "克山县",
      "code": "161632"
    }, {
      "value": "克东县",
      "label": "克东县",
      "code": "164801"
    }, {
      "value": "拜泉县",
      "label": "拜泉县",
      "code": "164731"
    }, {
      "value": "讷河市",
      "label": "讷河市",
      "code": "161301"
    }],
    "value": "齐齐哈尔市",
    "label": "齐齐哈尔市"
  }, {
    "children": [{
      "value": "鸡冠区",
      "label": "鸡冠区",
      "code": "158101"
    }, {
      "value": "恒山区",
      "label": "恒山区",
      "code": "158131"
    }, {
      "value": "滴道区",
      "label": "滴道区",
      "code": "158154"
    }, {
      "value": "梨树区",
      "label": "梨树区",
      "code": "158167"
    }, {
      "value": "城子河区",
      "label": "城子河区",
      "code": "158171"
    }, {
      "value": "麻山区",
      "label": "麻山区",
      "code": "158181"
    }, {
      "value": "鸡东县",
      "label": "鸡东县",
      "code": "158201"
    }, {
      "value": "虎林市",
      "label": "虎林市",
      "code": "158421"
    }, {
      "value": "密山市",
      "label": "密山市",
      "code": "158327"
    }],
    "value": "鸡西市",
    "label": "鸡西市"
  }, {
    "children": [{
      "value": "向阳区",
      "label": "向阳区",
      "code": "154101"
    }, {
      "value": "工农区",
      "label": "工农区",
      "code": "154101"
    }, {
      "value": "南山区",
      "label": "南山区",
      "code": "154104"
    }, {
      "value": "兴安区",
      "label": "兴安区",
      "code": "154111"
    }, {
      "value": "东山区",
      "label": "东山区",
      "code": "154106"
    }, {
      "value": "兴山区",
      "label": "兴山区",
      "code": "154105"
    }, {
      "value": "萝北县",
      "label": "萝北县",
      "code": "154244"
    }, {
      "value": "绥滨县",
      "label": "绥滨县",
      "code": "156204"
    }],
    "value": "鹤岗市",
    "label": "鹤岗市"
  }, {
    "children": [{
      "value": "尖山区",
      "label": "尖山区",
      "code": "155101"
    }, {
      "value": "岭东区",
      "label": "岭东区",
      "code": "155124"
    }, {
      "value": "四方台区",
      "label": "四方台区",
      "code": "155113"
    }, {
      "value": "宝山区",
      "label": "宝山区",
      "code": "155136"
    }, {
      "value": "集贤县",
      "label": "集贤县",
      "code": "155912"
    }, {
      "value": "友谊县",
      "label": "友谊县",
      "code": "155801"
    }, {
      "value": "宝清县",
      "label": "宝清县",
      "code": "155614"
    }, {
      "value": "饶河县",
      "label": "饶河县",
      "code": "155701"
    }],
    "value": "双鸭山市",
    "label": "双鸭山市"
  }, {
    "children": [{
      "value": "萨尔图区",
      "label": "萨尔图区",
      "code": "163316"
    }, {
      "value": "龙凤区",
      "label": "龙凤区",
      "code": "163711"
    }, {
      "value": "让胡路区",
      "label": "让胡路区",
      "code": "163713"
    }, {
      "value": "红岗区",
      "label": "红岗区",
      "code": "163511"
    }, {
      "value": "大同区",
      "label": "大同区",
      "code": "163813"
    }, {
      "value": "肇州县",
      "label": "肇州县",
      "code": "166401"
    }, {
      "value": "肇源县",
      "label": "肇源县",
      "code": "166544"
    }, {
      "value": "林甸县",
      "label": "林甸县",
      "code": "166331"
    }, {
      "value": "杜尔伯特蒙古族自治县",
      "label": "杜尔伯特蒙古族自治县",
      "code": "166201"
    }],
    "value": "大庆市",
    "label": "大庆市"
  }, {
    "children": [{
      "value": "伊春区",
      "label": "伊春区",
      "code": "153001"
    }, {
      "value": "南岔区",
      "label": "南岔区",
      "code": "153102"
    }, {
      "value": "友好区",
      "label": "友好区",
      "code": "153031"
    }, {
      "value": "西林区",
      "label": "西林区",
      "code": "153025"
    }, {
      "value": "翠峦区",
      "label": "翠峦区",
      "code": "153013"
    }, {
      "value": "新青区",
      "label": "新青区",
      "code": "153036"
    }, {
      "value": "美溪区",
      "label": "美溪区",
      "code": "153021"
    }, {
      "value": "金山屯区",
      "label": "金山屯区",
      "code": "153026"
    }, {
      "value": "五营区",
      "label": "五营区",
      "code": "153034"
    }, {
      "value": "乌马河区",
      "label": "乌马河区",
      "code": "153011"
    }, {
      "value": "汤旺河区",
      "label": "汤旺河区",
      "code": "153037"
    }, {
      "value": "带岭区",
      "label": "带岭区",
      "code": "153106"
    }, {
      "value": "乌伊岭区",
      "label": "乌伊岭区",
      "code": "153038"
    }, {
      "value": "红星区",
      "label": "红星区",
      "code": "153035"
    }, {
      "value": "上甘岭区",
      "label": "上甘岭区",
      "code": "153032"
    }, {
      "value": "嘉荫县",
      "label": "嘉荫县",
      "code": "153214"
    }, {
      "value": "铁力市",
      "label": "铁力市",
      "code": "152501"
    }],
    "value": "伊春市",
    "label": "伊春市"
  }, {
    "children": [{
      "value": "向阳区",
      "label": "向阳区",
      "code": "154003"
    }, {
      "value": "前进区",
      "label": "前进区",
      "code": "154002"
    }, {
      "value": "东风区",
      "label": "东风区",
      "code": "154005"
    }, {
      "value": "桦南县",
      "label": "桦南县",
      "code": "154401"
    }, {
      "value": "桦川县",
      "label": "桦川县",
      "code": "154332"
    }, {
      "value": "汤原县",
      "label": "汤原县",
      "code": "154701"
    }, {
      "value": "抚远县",
      "label": "抚远县",
      "code": "156501"
    }, {
      "value": "同江市",
      "label": "同江市",
      "code": "156401"
    }, {
      "value": "富锦市",
      "label": "富锦市",
      "code": "156301"
    }],
    "value": "佳木斯市",
    "label": "佳木斯市"
  }, {
    "children": [{
      "value": "新兴区",
      "label": "新兴区",
      "code": "154604"
    }, {
      "value": "桃山区",
      "label": "桃山区",
      "code": "154601"
    }, {
      "value": "茄子河区",
      "label": "茄子河区",
      "code": "154626"
    }, {
      "value": "勃利县",
      "label": "勃利县",
      "code": "154501"
    }],
    "value": "七台河市",
    "label": "七台河市"
  }, {
    "children": [{
      "value": "东安区",
      "label": "东安区",
      "code": "157021"
    }, {
      "value": "阳明区",
      "label": "阳明区",
      "code": "157014"
    }, {
      "value": "爱民区",
      "label": "爱民区",
      "code": "157011"
    }, {
      "value": "西安区",
      "label": "西安区",
      "code": "157003"
    }, {
      "value": "林口县",
      "label": "林口县",
      "code": "157631"
    }, {
      "value": "绥芬河市",
      "label": "绥芬河市",
      "code": "157301"
    }, {
      "value": "海林市",
      "label": "海林市",
      "code": "157101"
    }, {
      "value": "宁安市",
      "label": "宁安市",
      "code": "157401"
    }, {
      "value": "穆棱市",
      "label": "穆棱市",
      "code": "157501"
    }, {
      "value": "东宁市",
      "label": "东宁市",
      "code": "157201"
    }],
    "value": "牡丹江市",
    "label": "牡丹江市"
  }, {
    "children": [{
      "value": "爱辉区",
      "label": "爱辉区",
      "code": "164301"
    }, {
      "value": "嫩江县",
      "label": "嫩江县",
      "code": "161401"
    }, {
      "value": "逊克县",
      "label": "逊克县",
      "code": "164401"
    }, {
      "value": "孙吴县",
      "label": "孙吴县",
      "code": "164201"
    }, {
      "value": "北安市",
      "label": "北安市",
      "code": "164037"
    }, {
      "value": "五大连池市",
      "label": "五大连池市",
      "code": "164143"
    }],
    "value": "黑河市",
    "label": "黑河市"
  }, {
    "children": [{
      "value": "北林区",
      "label": "北林区",
      "code": "152001"
    }, {
      "value": "望奎县",
      "label": "望奎县",
      "code": "152181"
    }, {
      "value": "兰西县",
      "label": "兰西县",
      "code": "151501"
    }, {
      "value": "青冈县",
      "label": "青冈县",
      "code": "151611"
    }, {
      "value": "庆安县",
      "label": "庆安县",
      "code": "152401"
    }, {
      "value": "明水县",
      "label": "明水县",
      "code": "151771"
    }, {
      "value": "绥棱县",
      "label": "绥棱县",
      "code": "152201"
    }, {
      "value": "安达市",
      "label": "安达市",
      "code": "151401"
    }, {
      "value": "肇东市",
      "label": "肇东市",
      "code": "151101"
    }, {
      "value": "海伦市",
      "label": "海伦市",
      "code": "152301"
    }],
    "value": "绥化市",
    "label": "绥化市"
  }, {
    "children": [{
      "value": "呼玛县",
      "label": "呼玛县",
      "code": "165101"
    }, {
      "value": "塔河县",
      "label": "塔河县",
      "code": "165201"
    }, {
      "value": "漠河县",
      "label": "漠河县",
      "code": "165301"
    }],
    "value": "大兴安岭地区",
    "label": "大兴安岭地区"
  }],
  "value": "黑龙江省",
  "label": "黑龙江省"
}, {
  "children": [{
    "children": [{
      "value": "黄浦区",
      "label": "黄浦区",
      "code": "200001"
    }, {
      "value": "徐汇区",
      "label": "徐汇区",
      "code": "200232"
    }, {
      "value": "长宁区",
      "label": "长宁区",
      "code": "200335"
    }, {
      "value": "静安区",
      "label": "静安区",
      "code": "200041"
    }, {
      "value": "普陀区",
      "label": "普陀区",
      "code": "200333"
    }, {
      "value": "虹口区",
      "label": "虹口区",
      "code": "200081"
    }, {
      "value": "杨浦区",
      "label": "杨浦区",
      "code": "200438"
    }, {
      "value": "闵行区",
      "label": "闵行区",
      "code": "201108"
    }, {
      "value": "宝山区",
      "label": "宝山区",
      "code": "201908"
    }, {
      "value": "嘉定区",
      "label": "嘉定区",
      "code": "201822"
    }, {
      "value": "浦东新区",
      "label": "浦东新区",
      "code": "201209"
    }, {
      "value": "金山区",
      "label": "金山区",
      "code": "201507"
    }, {
      "value": "松江区",
      "label": "松江区",
      "code": "201602"
    }, {
      "value": "青浦区",
      "label": "青浦区",
      "code": "201707"
    }, {
      "value": "奉贤区",
      "label": "奉贤区",
      "code": "201414"
    }],
    "value": "市辖区",
    "label": "市辖区"
  }, {
    "children": [{
      "value": "崇明县",
      "label": "崇明县",
      "code": "202155"
    }],
    "value": "辖县",
    "label": "辖县"
  }],
  "value": "上海市",
  "label": "上海市"
}, {
  "children": [{
    "children": [{
      "value": "玄武区",
      "label": "玄武区",
      "code": "210018"
    }, {
      "value": "秦淮区",
      "label": "秦淮区",
      "code": "210006"
    }, {
      "value": "建邺区",
      "label": "建邺区",
      "code": "210017"
    }, {
      "value": "鼓楼区",
      "label": "鼓楼区",
      "code": "210009"
    }, {
      "value": "浦口区",
      "label": "浦口区",
      "code": "210031"
    }, {
      "value": "栖霞区",
      "label": "栖霞区",
      "code": "210059"
    }, {
      "value": "雨花台区",
      "label": "雨花台区",
      "code": "210039"
    }, {
      "value": "江宁区",
      "label": "江宁区",
      "code": "211101"
    }, {
      "value": "六合区",
      "label": "六合区",
      "code": "211501"
    }, {
      "value": "溧水区",
      "label": "溧水区",
      "code": "211201"
    }, {
      "value": "高淳区",
      "label": "高淳区",
      "code": "211301"
    }],
    "value": "南京市",
    "label": "南京市"
  }, {
    "children": [{
      "value": "锡山区",
      "label": "锡山区",
      "code": "214106"
    }, {
      "value": "惠山区",
      "label": "惠山区",
      "code": "214184"
    }, {
      "value": "滨湖区",
      "label": "滨湖区",
      "code": "214146"
    }, {
      "value": "梁溪区",
      "label": "梁溪区",
      "code": "214001"
    }, {
      "value": "新吴区",
      "label": "新吴区",
      "code": "214028"
    }, {
      "value": "江阴市",
      "label": "江阴市",
      "code": "214404"
    }, {
      "value": "宜兴市",
      "label": "宜兴市",
      "code": "214239"
    }],
    "value": "无锡市",
    "label": "无锡市"
  }, {
    "children": [{
      "value": "鼓楼区",
      "label": "鼓楼区",
      "code": "221007"
    }, {
      "value": "云龙区",
      "label": "云龙区",
      "code": "221003"
    }, {
      "value": "贾汪区",
      "label": "贾汪区",
      "code": "221133"
    }, {
      "value": "泉山区",
      "label": "泉山区",
      "code": "221006"
    }, {
      "value": "铜山区",
      "label": "铜山区",
      "code": "221101"
    }, {
      "value": "丰县",
      "label": "丰县",
      "code": "221734"
    }, {
      "value": "沛县",
      "label": "沛县",
      "code": "221601"
    }, {
      "value": "睢宁县",
      "label": "睢宁县",
      "code": "221201"
    }, {
      "value": "新沂市",
      "label": "新沂市",
      "code": "221401"
    }, {
      "value": "邳州市",
      "label": "邳州市",
      "code": "221327"
    }],
    "value": "徐州市",
    "label": "徐州市"
  }, {
    "children": [{
      "value": "天宁区",
      "label": "天宁区",
      "code": "213002"
    }, {
      "value": "钟楼区",
      "label": "钟楼区",
      "code": "213001"
    }, {
      "value": "新北区",
      "label": "新北区",
      "code": "213125"
    }, {
      "value": "武进区",
      "label": "武进区",
      "code": "213153"
    }, {
      "value": "金坛区",
      "label": "金坛区",
      "code": "213201"
    }, {
      "value": "溧阳市",
      "label": "溧阳市",
      "code": "213301"
    }],
    "value": "常州市",
    "label": "常州市"
  }, {
    "children": [{
      "value": "虎丘区",
      "label": "虎丘区",
      "code": "215129"
    }, {
      "value": "吴中区",
      "label": "吴中区",
      "code": "215128"
    }, {
      "value": "相城区",
      "label": "相城区",
      "code": "215031"
    }, {
      "value": "姑苏区",
      "label": "姑苏区",
      "code": "215008"
    }, {
      "value": "吴江区",
      "label": "吴江区",
      "code": "215201"
    }, {
      "value": "常熟市",
      "label": "常熟市",
      "code": "215555"
    }, {
      "value": "张家港市",
      "label": "张家港市",
      "code": "215623"
    }, {
      "value": "昆山市",
      "label": "昆山市",
      "code": "215324"
    }, {
      "value": "太仓市",
      "label": "太仓市",
      "code": "215427"
    }],
    "value": "苏州市",
    "label": "苏州市"
  }, {
    "children": [{
      "value": "崇川区",
      "label": "崇川区",
      "code": "226008"
    }, {
      "value": "港闸区",
      "label": "港闸区",
      "code": "226003"
    }, {
      "value": "通州区",
      "label": "通州区",
      "code": "226301"
    }, {
      "value": "海安县",
      "label": "海安县",
      "code": "226601"
    }, {
      "value": "如东县",
      "label": "如东县",
      "code": "226409"
    }, {
      "value": "启东市",
      "label": "启东市",
      "code": "226232"
    }, {
      "value": "如皋市",
      "label": "如皋市",
      "code": "226533"
    }, {
      "value": "海门市",
      "label": "海门市",
      "code": "226121"
    }],
    "value": "南通市",
    "label": "南通市"
  }, {
    "children": [{
      "value": "连云区",
      "label": "连云区",
      "code": "222042"
    }, {
      "value": "海州区",
      "label": "海州区",
      "code": "222021"
    }, {
      "value": "赣榆区",
      "label": "赣榆区",
      "code": "222101"
    }, {
      "value": "东海县",
      "label": "东海县",
      "code": "222311"
    }, {
      "value": "灌云县",
      "label": "灌云县",
      "code": "222242"
    }, {
      "value": "灌南县",
      "label": "灌南县",
      "code": "222533"
    }],
    "value": "连云港市",
    "label": "连云港市"
  }, {
    "children": [{
      "value": "清河区",
      "label": "清河区",
      "code": "223001"
    }, {
      "value": "淮安区",
      "label": "淮安区",
      "code": "223201"
    }, {
      "value": "淮阴区",
      "label": "淮阴区",
      "code": "223343"
    }, {
      "value": "清浦区",
      "label": "清浦区",
      "code": "223002"
    }, {
      "value": "涟水县",
      "label": "涟水县",
      "code": "223401"
    }, {
      "value": "洪泽县",
      "label": "洪泽县",
      "code": "223114"
    }, {
      "value": "盱眙县",
      "label": "盱眙县",
      "code": "211701"
    }, {
      "value": "金湖县",
      "label": "金湖县",
      "code": "211601"
    }],
    "value": "淮安市",
    "label": "淮安市"
  }, {
    "children": [{
      "value": "亭湖区",
      "label": "亭湖区",
      "code": "224331"
    }, {
      "value": "盐都区",
      "label": "盐都区",
      "code": "224012"
    }, {
      "value": "大丰区",
      "label": "大丰区",
      "code": "224101"
    }, {
      "value": "响水县",
      "label": "响水县",
      "code": "224631"
    }, {
      "value": "滨海县",
      "label": "滨海县",
      "code": "224553"
    }, {
      "value": "阜宁县",
      "label": "阜宁县",
      "code": "224425"
    }, {
      "value": "射阳县",
      "label": "射阳县",
      "code": "224364"
    }, {
      "value": "建湖县",
      "label": "建湖县",
      "code": "224712"
    }, {
      "value": "东台市",
      "label": "东台市",
      "code": "224243"
    }],
    "value": "盐城市",
    "label": "盐城市"
  }, {
    "children": [{
      "value": "广陵区",
      "label": "广陵区",
      "code": "225001"
    }, {
      "value": "邗江区",
      "label": "邗江区",
      "code": "225128"
    }, {
      "value": "江都区",
      "label": "江都区",
      "code": "225201"
    }, {
      "value": "宝应县",
      "label": "宝应县",
      "code": "225828"
    }, {
      "value": "仪征市",
      "label": "仪征市",
      "code": "211401"
    }, {
      "value": "高邮市",
      "label": "高邮市",
      "code": "225632"
    }],
    "value": "扬州市",
    "label": "扬州市"
  }, {
    "children": [{
      "value": "京口区",
      "label": "京口区",
      "code": "212132"
    }, {
      "value": "润州区",
      "label": "润州区",
      "code": "212002"
    }, {
      "value": "丹徒区",
      "label": "丹徒区",
      "code": "212121"
    }, {
      "value": "丹阳市",
      "label": "丹阳市",
      "code": "212331"
    }, {
      "value": "扬中市",
      "label": "扬中市",
      "code": "212211"
    }, {
      "value": "句容市",
      "label": "句容市",
      "code": "212411"
    }],
    "value": "镇江市",
    "label": "镇江市"
  }, {
    "children": [{
      "value": "海陵区",
      "label": "海陵区",
      "code": "225301"
    }, {
      "value": "高港区",
      "label": "高港区",
      "code": "225326"
    }, {
      "value": "姜堰区",
      "label": "姜堰区",
      "code": "225501"
    }, {
      "value": "兴化市",
      "label": "兴化市",
      "code": "225701"
    }, {
      "value": "靖江市",
      "label": "靖江市",
      "code": "214504"
    }, {
      "value": "泰兴市",
      "label": "泰兴市",
      "code": "225401"
    }],
    "value": "泰州市",
    "label": "泰州市"
  }, {
    "children": [{
      "value": "宿城区",
      "label": "宿城区",
      "code": "223801"
    }, {
      "value": "宿豫区",
      "label": "宿豫区",
      "code": "223804"
    }, {
      "value": "沭阳县",
      "label": "沭阳县",
      "code": "223635"
    }, {
      "value": "泗阳县",
      "label": "泗阳县",
      "code": "223705"
    }, {
      "value": "泗洪县",
      "label": "泗洪县",
      "code": "223951"
    }],
    "value": "宿迁市",
    "label": "宿迁市"
  }],
  "value": "江苏省",
  "label": "江苏省"
}, {
  "children": [{
    "children": [{
      "value": "上城区",
      "label": "上城区",
      "code": "310008"
    }, {
      "value": "下城区",
      "label": "下城区",
      "code": "310003"
    }, {
      "value": "江干区",
      "label": "江干区",
      "code": "310021"
    }, {
      "value": "拱墅区",
      "label": "拱墅区",
      "code": "310015"
    }, {
      "value": "西湖区",
      "label": "西湖区",
      "code": "310007"
    }, {
      "value": "滨江区",
      "label": "滨江区",
      "code": "310051"
    }, {
      "value": "萧山区",
      "label": "萧山区",
      "code": "311202"
    }, {
      "value": "余杭区",
      "label": "余杭区",
      "code": "311101"
    }, {
      "value": "富阳区",
      "label": "富阳区",
      "code": "311401"
    }, {
      "value": "桐庐县",
      "label": "桐庐县",
      "code": "311501"
    }, {
      "value": "淳安县",
      "label": "淳安县",
      "code": "311703"
    }, {
      "value": "建德市",
      "label": "建德市",
      "code": "311601"
    }, {
      "value": "临安市",
      "label": "临安市",
      "code": "311312"
    }],
    "value": "杭州市",
    "label": "杭州市"
  }, {
    "children": [{
      "value": "海曙区",
      "label": "海曙区",
      "code": "315021"
    }, {
      "value": "江东区",
      "label": "江东区",
      "code": "315041"
    }, {
      "value": "江北区",
      "label": "江北区",
      "code": "315021"
    }, {
      "value": "北仑区",
      "label": "北仑区",
      "code": "315801"
    }, {
      "value": "镇海区",
      "label": "镇海区",
      "code": "315207"
    }, {
      "value": "鄞州区",
      "label": "鄞州区",
      "code": "315151"
    }, {
      "value": "象山县",
      "label": "象山县",
      "code": "315701"
    }, {
      "value": "宁海县",
      "label": "宁海县",
      "code": "315602"
    }, {
      "value": "余姚市",
      "label": "余姚市",
      "code": "315481"
    }, {
      "value": "慈溪市",
      "label": "慈溪市",
      "code": "315301"
    }, {
      "value": "奉化市",
      "label": "奉化市",
      "code": "315531"
    }],
    "value": "宁波市",
    "label": "宁波市"
  }, {
    "children": [{
      "value": "鹿城区",
      "label": "鹿城区",
      "code": "325007"
    }, {
      "value": "龙湾区",
      "label": "龙湾区",
      "code": "325025"
    }, {
      "value": "瓯海区",
      "label": "瓯海区",
      "code": "325025"
    }, {
      "value": "洞头区",
      "label": "洞头区",
      "code": "325701"
    }, {
      "value": "永嘉县",
      "label": "永嘉县",
      "code": "325105"
    }, {
      "value": "平阳县",
      "label": "平阳县",
      "code": "325403"
    }, {
      "value": "苍南县",
      "label": "苍南县",
      "code": "325805"
    }, {
      "value": "文成县",
      "label": "文成县",
      "code": "325301"
    }, {
      "value": "泰顺县",
      "label": "泰顺县",
      "code": "325501"
    }, {
      "value": "瑞安市",
      "label": "瑞安市",
      "code": "325201"
    }, {
      "value": "乐清市",
      "label": "乐清市",
      "code": "325604"
    }],
    "value": "温州市",
    "label": "温州市"
  }, {
    "children": [{
      "value": "南湖区",
      "label": "南湖区",
      "code": "314033"
    }, {
      "value": "秀洲区",
      "label": "秀洲区",
      "code": "314023"
    }, {
      "value": "嘉善县",
      "label": "嘉善县",
      "code": "314113"
    }, {
      "value": "海盐县",
      "label": "海盐县",
      "code": "314303"
    }, {
      "value": "海宁市",
      "label": "海宁市",
      "code": "314401"
    }, {
      "value": "平湖市",
      "label": "平湖市",
      "code": "314211"
    }, {
      "value": "桐乡市",
      "label": "桐乡市",
      "code": "314514"
    }],
    "value": "嘉兴市",
    "label": "嘉兴市"
  }, {
    "children": [{
      "value": "吴兴区",
      "label": "吴兴区",
      "code": "313001"
    }, {
      "value": "南浔区",
      "label": "南浔区",
      "code": "313009"
    }, {
      "value": "德清县",
      "label": "德清县",
      "code": "313206"
    }, {
      "value": "长兴县",
      "label": "长兴县",
      "code": "313119"
    }, {
      "value": "安吉县",
      "label": "安吉县",
      "code": "313301"
    }],
    "value": "湖州市",
    "label": "湖州市"
  }, {
    "children": [{
      "value": "越城区",
      "label": "越城区",
      "code": "312001"
    }, {
      "value": "柯桥区",
      "label": "柯桥区",
      "code": "312031"
    }, {
      "value": "上虞区",
      "label": "上虞区",
      "code": "312301"
    }, {
      "value": "新昌县",
      "label": "新昌县",
      "code": "312531"
    }, {
      "value": "诸暨市",
      "label": "诸暨市",
      "code": "311801"
    }, {
      "value": "嵊州市",
      "label": "嵊州市",
      "code": "312473"
    }],
    "value": "绍兴市",
    "label": "绍兴市"
  }, {
    "children": [{
      "value": "婺城区",
      "label": "婺城区",
      "code": "321001"
    }, {
      "value": "金东区",
      "label": "金东区",
      "code": "321041"
    }, {
      "value": "武义县",
      "label": "武义县",
      "code": "321201"
    }, {
      "value": "浦江县",
      "label": "浦江县",
      "code": "322201"
    }, {
      "value": "磐安县",
      "label": "磐安县",
      "code": "322301"
    }, {
      "value": "兰溪市",
      "label": "兰溪市",
      "code": "321102"
    }, {
      "value": "义乌市",
      "label": "义乌市",
      "code": "322001"
    }, {
      "value": "东阳市",
      "label": "东阳市",
      "code": "322121"
    }, {
      "value": "永康市",
      "label": "永康市",
      "code": "321302"
    }],
    "value": "金华市",
    "label": "金华市"
  }, {
    "children": [{
      "value": "柯城区",
      "label": "柯城区",
      "code": "324001"
    }, {
      "value": "衢江区",
      "label": "衢江区",
      "code": "324009"
    }, {
      "value": "常山县",
      "label": "常山县",
      "code": "324216"
    }, {
      "value": "开化县",
      "label": "开化县",
      "code": "324301"
    }, {
      "value": "龙游县",
      "label": "龙游县",
      "code": "324402"
    }, {
      "value": "江山市",
      "label": "江山市",
      "code": "324101"
    }],
    "value": "衢州市",
    "label": "衢州市"
  }, {
    "children": [{
      "value": "定海区",
      "label": "定海区",
      "code": "316004"
    }, {
      "value": "普陀区",
      "label": "普陀区",
      "code": "316105"
    }, {
      "value": "岱山县",
      "label": "岱山县",
      "code": "316201"
    }, {
      "value": "嵊泗县",
      "label": "嵊泗县",
      "code": "202451"
    }],
    "value": "舟山市",
    "label": "舟山市"
  }, {
    "children": [{
      "value": "椒江区",
      "label": "椒江区",
      "code": "318001"
    }, {
      "value": "黄岩区",
      "label": "黄岩区",
      "code": "318021"
    }, {
      "value": "路桥区",
      "label": "路桥区",
      "code": "318051"
    }, {
      "value": "玉环县",
      "label": "玉环县",
      "code": "317601"
    }, {
      "value": "三门县",
      "label": "三门县",
      "code": "317113"
    }, {
      "value": "天台县",
      "label": "天台县",
      "code": "317201"
    }, {
      "value": "仙居县",
      "label": "仙居县",
      "code": "317305"
    }, {
      "value": "温岭市",
      "label": "温岭市",
      "code": "317521"
    }, {
      "value": "临海市",
      "label": "临海市",
      "code": "317001"
    }],
    "value": "台州市",
    "label": "台州市"
  }, {
    "children": [{
      "value": "莲都区",
      "label": "莲都区",
      "code": "323005"
    }, {
      "value": "青田县",
      "label": "青田县",
      "code": "323911"
    }, {
      "value": "缙云县",
      "label": "缙云县",
      "code": "321408"
    }, {
      "value": "遂昌县",
      "label": "遂昌县",
      "code": "323309"
    }, {
      "value": "松阳县",
      "label": "松阳县",
      "code": "323401"
    }, {
      "value": "云和县",
      "label": "云和县",
      "code": "323601"
    }, {
      "value": "庆元县",
      "label": "庆元县",
      "code": "323801"
    }, {
      "value": "景宁畲族自治县",
      "label": "景宁畲族自治县",
      "code": "323508"
    }, {
      "value": "龙泉市",
      "label": "龙泉市",
      "code": "323701"
    }],
    "value": "丽水市",
    "label": "丽水市"
  }],
  "value": "浙江省",
  "label": "浙江省"
}, {
  "children": [{
    "children": [{
      "value": "瑶海区",
      "label": "瑶海区",
      "code": "230011"
    }, {
      "value": "庐阳区",
      "label": "庐阳区",
      "code": "230041"
    }, {
      "value": "蜀山区",
      "label": "蜀山区",
      "code": "230071"
    }, {
      "value": "包河区",
      "label": "包河区",
      "code": "230051"
    }, {
      "value": "长丰县",
      "label": "长丰县",
      "code": "231101"
    }, {
      "value": "肥东县",
      "label": "肥东县",
      "code": "231634"
    }, {
      "value": "肥西县",
      "label": "肥西县",
      "code": "231271"
    }, {
      "value": "庐江县",
      "label": "庐江县",
      "code": "231501"
    }, {
      "value": "巢湖市",
      "label": "巢湖市",
      "code": "238001"
    }],
    "value": "合肥市",
    "label": "合肥市"
  }, {
    "children": [{
      "value": "镜湖区",
      "label": "镜湖区",
      "code": "241004"
    }, {
      "value": "弋江区",
      "label": "弋江区",
      "code": "241071"
    }, {
      "value": "鸠江区",
      "label": "鸠江区",
      "code": "241006"
    }, {
      "value": "三山区",
      "label": "三山区",
      "code": "241081"
    }, {
      "value": "芜湖县",
      "label": "芜湖县",
      "code": "241101"
    }, {
      "value": "繁昌县",
      "label": "繁昌县",
      "code": "241201"
    }, {
      "value": "南陵县",
      "label": "南陵县",
      "code": "241319"
    }, {
      "value": "无为县",
      "label": "无为县",
      "code": "238301"
    }],
    "value": "芜湖市",
    "label": "芜湖市"
  }, {
    "children": [{
      "value": "龙子湖区",
      "label": "龙子湖区",
      "code": "233001"
    }, {
      "value": "蚌山区",
      "label": "蚌山区",
      "code": "233001"
    }, {
      "value": "禹会区",
      "label": "禹会区",
      "code": "233051"
    }, {
      "value": "淮上区",
      "label": "淮上区",
      "code": "233081"
    }, {
      "value": "怀远县",
      "label": "怀远县",
      "code": "233401"
    }, {
      "value": "五河县",
      "label": "五河县",
      "code": "233301"
    }, {
      "value": "固镇县",
      "label": "固镇县",
      "code": "233701"
    }],
    "value": "蚌埠市",
    "label": "蚌埠市"
  }, {
    "children": [{
      "value": "大通区",
      "label": "大通区",
      "code": "232035"
    }, {
      "value": "田家庵区",
      "label": "田家庵区",
      "code": "232001"
    }, {
      "value": "谢家集区",
      "label": "谢家集区",
      "code": "232052"
    }, {
      "value": "八公山区",
      "label": "八公山区",
      "code": "232073"
    }, {
      "value": "潘集区",
      "label": "潘集区",
      "code": "232095"
    }, {
      "value": "凤台县",
      "label": "凤台县",
      "code": "232181"
    }, {
      "value": "寿县",
      "label": "寿县",
      "code": "232201"
    }],
    "value": "淮南市",
    "label": "淮南市"
  }, {
    "children": [{
      "value": "花山区",
      "label": "花山区",
      "code": "243011"
    }, {
      "value": "雨山区",
      "label": "雨山区",
      "code": "243031"
    }, {
      "value": "博望区",
      "label": "博望区",
      "code": "243131"
    }, {
      "value": "当涂县",
      "label": "当涂县",
      "code": "243174"
    }, {
      "value": "含山县",
      "label": "含山县",
      "code": "238101"
    }, {
      "value": "和县",
      "label": "和县",
      "code": "238201"
    }],
    "value": "马鞍山市",
    "label": "马鞍山市"
  }, {
    "children": [{
      "value": "杜集区",
      "label": "杜集区",
      "code": "235058"
    }, {
      "value": "相山区",
      "label": "相山区",
      "code": "235001"
    }, {
      "value": "烈山区",
      "label": "烈山区",
      "code": "235026"
    }, {
      "value": "濉溪县",
      "label": "濉溪县",
      "code": "235101"
    }],
    "value": "淮北市",
    "label": "淮北市"
  }, {
    "children": [{
      "value": "铜官山区",
      "label": "铜官山区",
      "code": "244001"
    }, {
      "value": "义安区",
      "label": "义安区",
      "code": "244101"
    }, {
      "value": "枞阳县",
      "label": "枞阳县",
      "code": "246701"
    }],
    "value": "铜陵市",
    "label": "铜陵市"
  }, {
    "children": [{
      "value": "迎江区",
      "label": "迎江区",
      "code": "246008"
    }, {
      "value": "大观区",
      "label": "大观区",
      "code": "246009"
    }, {
      "value": "宜秀区",
      "label": "宜秀区",
      "code": "246001"
    }, {
      "value": "怀宁县",
      "label": "怀宁县",
      "code": "246141"
    }, {
      "value": "潜山县",
      "label": "潜山县",
      "code": "246306"
    }, {
      "value": "太湖县",
      "label": "太湖县",
      "code": "246411"
    }, {
      "value": "宿松县",
      "label": "宿松县",
      "code": "246501"
    }, {
      "value": "望江县",
      "label": "望江县",
      "code": "246255"
    }, {
      "value": "岳西县",
      "label": "岳西县",
      "code": "246601"
    }, {
      "value": "桐城市",
      "label": "桐城市",
      "code": "231401"
    }],
    "value": "安庆市",
    "label": "安庆市"
  }, {
    "children": [{
      "value": "屯溪区",
      "label": "屯溪区",
      "code": "245031"
    }, {
      "value": "黄山区",
      "label": "黄山区",
      "code": "245701"
    }, {
      "value": "徽州区",
      "label": "徽州区",
      "code": "245901"
    }, {
      "value": "歙县",
      "label": "歙县",
      "code": "245231"
    }, {
      "value": "休宁县",
      "label": "休宁县",
      "code": "245401"
    }, {
      "value": "黟县",
      "label": "黟县",
      "code": "245501"
    }, {
      "value": "祁门县",
      "label": "祁门县",
      "code": "245601"
    }],
    "value": "黄山市",
    "label": "黄山市"
  }, {
    "children": [{
      "value": "琅琊区",
      "label": "琅琊区",
      "code": "239001"
    }, {
      "value": "南谯区",
      "label": "南谯区",
      "code": "239065"
    }, {
      "value": "来安县",
      "label": "来安县",
      "code": "239212"
    }, {
      "value": "全椒县",
      "label": "全椒县",
      "code": "239535"
    }, {
      "value": "定远县",
      "label": "定远县",
      "code": "233281"
    }, {
      "value": "凤阳县",
      "label": "凤阳县",
      "code": "233102"
    }, {
      "value": "天长市",
      "label": "天长市",
      "code": "239331"
    }, {
      "value": "明光市",
      "label": "明光市",
      "code": "239441"
    }],
    "value": "滁州市",
    "label": "滁州市"
  }, {
    "children": [{
      "value": "颍州区",
      "label": "颍州区",
      "code": "236048"
    }, {
      "value": "颍东区",
      "label": "颍东区",
      "code": "236136"
    }, {
      "value": "颍泉区",
      "label": "颍泉区",
      "code": "236065"
    }, {
      "value": "临泉县",
      "label": "临泉县",
      "code": "236417"
    }, {
      "value": "太和县",
      "label": "太和县",
      "code": "236633"
    }, {
      "value": "阜南县",
      "label": "阜南县",
      "code": "236319"
    }, {
      "value": "颍上县",
      "label": "颍上县",
      "code": "236201"
    }, {
      "value": "界首市",
      "label": "界首市",
      "code": "236513"
    }],
    "value": "阜阳市",
    "label": "阜阳市"
  }, {
    "children": [{
      "value": "埇桥区",
      "label": "埇桥区",
      "code": "234102"
    }, {
      "value": "砀山县",
      "label": "砀山县",
      "code": "235308"
    }, {
      "value": "萧县",
      "label": "萧县",
      "code": "235281"
    }, {
      "value": "灵璧县",
      "label": "灵璧县",
      "code": "234221"
    }, {
      "value": "泗县",
      "label": "泗县",
      "code": "234333"
    }],
    "value": "宿州市",
    "label": "宿州市"
  }, {
    "children": [{
      "value": "金安区",
      "label": "金安区",
      "code": "237157"
    }, {
      "value": "裕安区",
      "label": "裕安区",
      "code": "237432"
    }, {
      "value": "叶集区",
      "label": "叶集区",
      "code": "237431"
    }, {
      "value": "霍邱县",
      "label": "霍邱县",
      "code": "237401"
    }, {
      "value": "舒城县",
      "label": "舒城县",
      "code": "231301"
    }, {
      "value": "金寨县",
      "label": "金寨县",
      "code": "237301"
    }, {
      "value": "霍山县",
      "label": "霍山县",
      "code": "237231"
    }],
    "value": "六安市",
    "label": "六安市"
  }, {
    "children": [{
      "value": "谯城区",
      "label": "谯城区",
      "code": "236831"
    }, {
      "value": "涡阳县",
      "label": "涡阳县",
      "code": "233671"
    }, {
      "value": "蒙城县",
      "label": "蒙城县",
      "code": "233527"
    }, {
      "value": "利辛县",
      "label": "利辛县",
      "code": "236725"
    }],
    "value": "亳州市",
    "label": "亳州市"
  }, {
    "children": [{
      "value": "贵池区",
      "label": "贵池区",
      "code": "247118"
    }, {
      "value": "东至县",
      "label": "东至县",
      "code": "247221"
    }, {
      "value": "石台县",
      "label": "石台县",
      "code": "245108"
    }, {
      "value": "青阳县",
      "label": "青阳县",
      "code": "242801"
    }],
    "value": "池州市",
    "label": "池州市"
  }, {
    "children": [{
      "value": "宣州区",
      "label": "宣州区",
      "code": "242001"
    }, {
      "value": "郎溪县",
      "label": "郎溪县",
      "code": "242127"
    }, {
      "value": "广德县",
      "label": "广德县",
      "code": "242211"
    }, {
      "value": "泾县",
      "label": "泾县",
      "code": "242501"
    }, {
      "value": "绩溪县",
      "label": "绩溪县",
      "code": "245301"
    }, {
      "value": "旌德县",
      "label": "旌德县",
      "code": "242606"
    }, {
      "value": "宁国市",
      "label": "宁国市",
      "code": "242301"
    }],
    "value": "宣城市",
    "label": "宣城市"
  }],
  "value": "安徽省",
  "label": "安徽省"
}, {
  "children": [{
    "children": [{
      "value": "鼓楼区",
      "label": "鼓楼区",
      "code": "350001"
    }, {
      "value": "台江区",
      "label": "台江区",
      "code": "350005"
    }, {
      "value": "仓山区",
      "label": "仓山区",
      "code": "350008"
    }, {
      "value": "马尾区",
      "label": "马尾区",
      "code": "350016"
    }, {
      "value": "晋安区",
      "label": "晋安区",
      "code": "350014"
    }, {
      "value": "闽侯县",
      "label": "闽侯县",
      "code": "350112"
    }, {
      "value": "连江县",
      "label": "连江县",
      "code": "350511"
    }, {
      "value": "罗源县",
      "label": "罗源县",
      "code": "350608"
    }, {
      "value": "闽清县",
      "label": "闽清县",
      "code": "350813"
    }, {
      "value": "永泰县",
      "label": "永泰县",
      "code": "350711"
    }, {
      "value": "平潭县",
      "label": "平潭县",
      "code": "350414"
    }, {
      "value": "福清市",
      "label": "福清市",
      "code": "350323"
    }, {
      "value": "长乐市",
      "label": "长乐市",
      "code": "350211"
    }],
    "value": "福州市",
    "label": "福州市"
  }, {
    "children": [{
      "value": "思明区",
      "label": "思明区",
      "code": "361001"
    }, {
      "value": "海沧区",
      "label": "海沧区",
      "code": "361028"
    }, {
      "value": "湖里区",
      "label": "湖里区",
      "code": "361006"
    }, {
      "value": "集美区",
      "label": "集美区",
      "code": "361022"
    }, {
      "value": "同安区",
      "label": "同安区",
      "code": "361101"
    }, {
      "value": "翔安区",
      "label": "翔安区",
      "code": "361111"
    }],
    "value": "厦门市",
    "label": "厦门市"
  }, {
    "children": [{
      "value": "城厢区",
      "label": "城厢区",
      "code": "351101"
    }, {
      "value": "涵江区",
      "label": "涵江区",
      "code": "351111"
    }, {
      "value": "荔城区",
      "label": "荔城区",
      "code": "351142"
    }, {
      "value": "秀屿区",
      "label": "秀屿区",
      "code": "351168"
    }, {
      "value": "仙游县",
      "label": "仙游县",
      "code": "351201"
    }],
    "value": "莆田市",
    "label": "莆田市"
  }, {
    "children": [{
      "value": "梅列区",
      "label": "梅列区",
      "code": "365001"
    }, {
      "value": "三元区",
      "label": "三元区",
      "code": "365003"
    }, {
      "value": "明溪县",
      "label": "明溪县",
      "code": "365201"
    }, {
      "value": "清流县",
      "label": "清流县",
      "code": "365301"
    }, {
      "value": "宁化县",
      "label": "宁化县",
      "code": "365406"
    }, {
      "value": "大田县",
      "label": "大田县",
      "code": "366101"
    }, {
      "value": "尤溪县",
      "label": "尤溪县",
      "code": "365114"
    }, {
      "value": "沙县",
      "label": "沙县",
      "code": "365504"
    }, {
      "value": "将乐县",
      "label": "将乐县",
      "code": "353301"
    }, {
      "value": "泰宁县",
      "label": "泰宁县",
      "code": "354401"
    }, {
      "value": "建宁县",
      "label": "建宁县",
      "code": "354503"
    }, {
      "value": "永安市",
      "label": "永安市",
      "code": "366001"
    }],
    "value": "三明市",
    "label": "三明市"
  }, {
    "children": [{
      "value": "鲤城区",
      "label": "鲤城区",
      "code": "362005"
    }, {
      "value": "丰泽区",
      "label": "丰泽区",
      "code": "362018"
    }, {
      "value": "洛江区",
      "label": "洛江区",
      "code": "362013"
    }, {
      "value": "泉港区",
      "label": "泉港区",
      "code": "362801"
    }, {
      "value": "惠安县",
      "label": "惠安县",
      "code": "362121"
    }, {
      "value": "安溪县",
      "label": "安溪县",
      "code": "362413"
    }, {
      "value": "永春县",
      "label": "永春县",
      "code": "362621"
    }, {
      "value": "德化县",
      "label": "德化县",
      "code": "362501"
    }, {
      "value": "金门县",
      "label": "金门县",
      "code": "362001"
    }, {
      "value": "石狮市",
      "label": "石狮市",
      "code": "362701"
    }, {
      "value": "晋江市",
      "label": "晋江市",
      "code": "362241"
    }, {
      "value": "南安市",
      "label": "南安市",
      "code": "362341"
    }],
    "value": "泉州市",
    "label": "泉州市"
  }, {
    "children": [{
      "value": "芗城区",
      "label": "芗城区",
      "code": "363004"
    }, {
      "value": "龙文区",
      "label": "龙文区",
      "code": "363006"
    }, {
      "value": "云霄县",
      "label": "云霄县",
      "code": "363305"
    }, {
      "value": "漳浦县",
      "label": "漳浦县",
      "code": "363215"
    }, {
      "value": "诏安县",
      "label": "诏安县",
      "code": "363501"
    }, {
      "value": "长泰县",
      "label": "长泰县",
      "code": "363903"
    }, {
      "value": "东山县",
      "label": "东山县",
      "code": "363401"
    }, {
      "value": "南靖县",
      "label": "南靖县",
      "code": "363608"
    }, {
      "value": "平和县",
      "label": "平和县",
      "code": "363708"
    }, {
      "value": "华安县",
      "label": "华安县",
      "code": "363806"
    }, {
      "value": "龙海市",
      "label": "龙海市",
      "code": "363101"
    }],
    "value": "漳州市",
    "label": "漳州市"
  }, {
    "children": [{
      "value": "延平区",
      "label": "延平区",
      "code": "353015"
    }, {
      "value": "建阳区",
      "label": "建阳区",
      "code": "354201"
    }, {
      "value": "顺昌县",
      "label": "顺昌县",
      "code": "353201"
    }, {
      "value": "浦城县",
      "label": "浦城县",
      "code": "353401"
    }, {
      "value": "光泽县",
      "label": "光泽县",
      "code": "354101"
    }, {
      "value": "松溪县",
      "label": "松溪县",
      "code": "353501"
    }, {
      "value": "政和县",
      "label": "政和县",
      "code": "353601"
    }, {
      "value": "邵武市",
      "label": "邵武市",
      "code": "354004"
    }, {
      "value": "武夷山市",
      "label": "武夷山市",
      "code": "354301"
    }, {
      "value": "建瓯市",
      "label": "建瓯市",
      "code": "353101"
    }],
    "value": "南平市",
    "label": "南平市"
  }, {
    "children": [{
      "value": "新罗区",
      "label": "新罗区",
      "code": "364001"
    }, {
      "value": "永定区",
      "label": "永定区",
      "code": "364101"
    }, {
      "value": "长汀县",
      "label": "长汀县",
      "code": "366301"
    }, {
      "value": "上杭县",
      "label": "上杭县",
      "code": "364201"
    }, {
      "value": "武平县",
      "label": "武平县",
      "code": "364315"
    }, {
      "value": "连城县",
      "label": "连城县",
      "code": "366203"
    }, {
      "value": "漳平市",
      "label": "漳平市",
      "code": "364413"
    }],
    "value": "龙岩市",
    "label": "龙岩市"
  }, {
    "children": [{
      "value": "蕉城区",
      "label": "蕉城区",
      "code": "352106"
    }, {
      "value": "霞浦县",
      "label": "霞浦县",
      "code": "355102"
    }, {
      "value": "古田县",
      "label": "古田县",
      "code": "352251"
    }, {
      "value": "屏南县",
      "label": "屏南县",
      "code": "352307"
    }, {
      "value": "寿宁县",
      "label": "寿宁县",
      "code": "355507"
    }, {
      "value": "周宁县",
      "label": "周宁县",
      "code": "355401"
    }, {
      "value": "柘荣县",
      "label": "柘荣县",
      "code": "355301"
    }, {
      "value": "福安市",
      "label": "福安市",
      "code": "355003"
    }, {
      "value": "福鼎市",
      "label": "福鼎市",
      "code": "355203"
    }],
    "value": "宁德市",
    "label": "宁德市"
  }],
  "value": "福建省",
  "label": "福建省"
}, {
  "children": [{
    "children": [{
      "value": "东湖区",
      "label": "东湖区",
      "code": "330039"
    }, {
      "value": "西湖区",
      "label": "西湖区",
      "code": "330009"
    }, {
      "value": "青云谱区",
      "label": "青云谱区",
      "code": "330001"
    }, {
      "value": "湾里区",
      "label": "湾里区",
      "code": "330004"
    }, {
      "value": "青山湖区",
      "label": "青山湖区",
      "code": "330029"
    }, {
      "value": "新建区",
      "label": "新建区",
      "code": "330101"
    }, {
      "value": "南昌县",
      "label": "南昌县",
      "code": "330052"
    }, {
      "value": "安义县",
      "label": "安义县",
      "code": "330512"
    }, {
      "value": "进贤县",
      "label": "进贤县",
      "code": "331713"
    }],
    "value": "南昌市",
    "label": "南昌市"
  }, {
    "children": [{
      "value": "昌江区",
      "label": "昌江区",
      "code": "333036"
    }, {
      "value": "珠山区",
      "label": "珠山区",
      "code": "333001"
    }, {
      "value": "浮梁县",
      "label": "浮梁县",
      "code": "333401"
    }, {
      "value": "乐平市",
      "label": "乐平市",
      "code": "333301"
    }],
    "value": "景德镇市",
    "label": "景德镇市"
  }, {
    "children": [{
      "value": "安源区",
      "label": "安源区",
      "code": "337001"
    }, {
      "value": "湘东区",
      "label": "湘东区",
      "code": "337029"
    }, {
      "value": "莲花县",
      "label": "莲花县",
      "code": "337103"
    }, {
      "value": "上栗县",
      "label": "上栗县",
      "code": "337004"
    }, {
      "value": "芦溪县",
      "label": "芦溪县",
      "code": "337251"
    }],
    "value": "萍乡市",
    "label": "萍乡市"
  }, {
    "children": [{
      "value": "庐山区",
      "label": "庐山区",
      "code": "332009"
    }, {
      "value": "浔阳区",
      "label": "浔阳区",
      "code": "332001"
    }, {
      "value": "九江县",
      "label": "九江县",
      "code": "332101"
    }, {
      "value": "武宁县",
      "label": "武宁县",
      "code": "332301"
    }, {
      "value": "修水县",
      "label": "修水县",
      "code": "332441"
    }, {
      "value": "永修县",
      "label": "永修县",
      "code": "330309"
    }, {
      "value": "德安县",
      "label": "德安县",
      "code": "330401"
    }, {
      "value": "星子县",
      "label": "星子县",
      "code": "332801"
    }, {
      "value": "都昌县",
      "label": "都昌县",
      "code": "332614"
    }, {
      "value": "湖口县",
      "label": "湖口县",
      "code": "332501"
    }, {
      "value": "彭泽县",
      "label": "彭泽县",
      "code": "332717"
    }, {
      "value": "瑞昌市",
      "label": "瑞昌市",
      "code": "332205"
    }, {
      "value": "共青城市",
      "label": "共青城市",
      "code": "332021"
    }],
    "value": "九江市",
    "label": "九江市"
  }, {
    "children": [{
      "value": "渝水区",
      "label": "渝水区",
      "code": "338025"
    }, {
      "value": "分宜县",
      "label": "分宜县",
      "code": "336601"
    }],
    "value": "新余市",
    "label": "新余市"
  }, {
    "children": [{
      "value": "月湖区",
      "label": "月湖区",
      "code": "335211"
    }, {
      "value": "余江县",
      "label": "余江县",
      "code": "335202"
    }, {
      "value": "贵溪市",
      "label": "贵溪市",
      "code": "335401"
    }],
    "value": "鹰潭市",
    "label": "鹰潭市"
  }, {
    "children": [{
      "value": "章贡区",
      "label": "章贡区",
      "code": "341001"
    }, {
      "value": "南康区",
      "label": "南康区",
      "code": "341401"
    }, {
      "value": "赣县",
      "label": "赣县",
      "code": "341101"
    }, {
      "value": "信丰县",
      "label": "信丰县",
      "code": "341601"
    }, {
      "value": "大余县",
      "label": "大余县",
      "code": "341516"
    }, {
      "value": "上犹县",
      "label": "上犹县",
      "code": "341204"
    }, {
      "value": "崇义县",
      "label": "崇义县",
      "code": "341301"
    }, {
      "value": "安远县",
      "label": "安远县",
      "code": "342101"
    }, {
      "value": "龙南县",
      "label": "龙南县",
      "code": "341701"
    }, {
      "value": "定南县",
      "label": "定南县",
      "code": "341901"
    }, {
      "value": "全南县",
      "label": "全南县",
      "code": "341812"
    }, {
      "value": "宁都县",
      "label": "宁都县",
      "code": "342821"
    }, {
      "value": "于都县",
      "label": "于都县",
      "code": "342322"
    }, {
      "value": "兴国县",
      "label": "兴国县",
      "code": "342403"
    }, {
      "value": "会昌县",
      "label": "会昌县",
      "code": "342601"
    }, {
      "value": "寻乌县",
      "label": "寻乌县",
      "code": "342215"
    }, {
      "value": "石城县",
      "label": "石城县",
      "code": "342703"
    }, {
      "value": "瑞金市",
      "label": "瑞金市",
      "code": "342513"
    }],
    "value": "赣州市",
    "label": "赣州市"
  }, {
    "children": [{
      "value": "吉州区",
      "label": "吉州区",
      "code": "343016"
    }, {
      "value": "青原区",
      "label": "青原区",
      "code": "343009"
    }, {
      "value": "吉安县",
      "label": "吉安县",
      "code": "343109"
    }, {
      "value": "吉水县",
      "label": "吉水县",
      "code": "331604"
    }, {
      "value": "峡江县",
      "label": "峡江县",
      "code": "331404"
    }, {
      "value": "新干县",
      "label": "新干县",
      "code": "331301"
    }, {
      "value": "永丰县",
      "label": "永丰县",
      "code": "331508"
    }, {
      "value": "泰和县",
      "label": "泰和县",
      "code": "343725"
    }, {
      "value": "遂川县",
      "label": "遂川县",
      "code": "343901"
    }, {
      "value": "万安县",
      "label": "万安县",
      "code": "343801"
    }, {
      "value": "安福县",
      "label": "安福县",
      "code": "343201"
    }, {
      "value": "永新县",
      "label": "永新县",
      "code": "343403"
    }, {
      "value": "井冈山市",
      "label": "井冈山市",
      "code": "343606"
    }],
    "value": "吉安市",
    "label": "吉安市"
  }, {
    "children": [{
      "value": "袁州区",
      "label": "袁州区",
      "code": "336001"
    }, {
      "value": "奉新县",
      "label": "奉新县",
      "code": "330701"
    }, {
      "value": "万载县",
      "label": "万载县",
      "code": "336108"
    }, {
      "value": "上高县",
      "label": "上高县",
      "code": "336404"
    }, {
      "value": "宜丰县",
      "label": "宜丰县",
      "code": "336301"
    }, {
      "value": "靖安县",
      "label": "靖安县",
      "code": "330601"
    }, {
      "value": "铜鼓县",
      "label": "铜鼓县",
      "code": "336201"
    }, {
      "value": "丰城市",
      "label": "丰城市",
      "code": "331101"
    }, {
      "value": "樟树市",
      "label": "樟树市",
      "code": "331208"
    }, {
      "value": "高安市",
      "label": "高安市",
      "code": "330819"
    }],
    "value": "宜春市",
    "label": "宜春市"
  }, {
    "children": [{
      "value": "临川区",
      "label": "临川区",
      "code": "344101"
    }, {
      "value": "南城县",
      "label": "南城县",
      "code": "344711"
    }, {
      "value": "黎川县",
      "label": "黎川县",
      "code": "344601"
    }, {
      "value": "南丰县",
      "label": "南丰县",
      "code": "344501"
    }, {
      "value": "崇仁县",
      "label": "崇仁县",
      "code": "344201"
    }, {
      "value": "乐安县",
      "label": "乐安县",
      "code": "344308"
    }, {
      "value": "宜黄县",
      "label": "宜黄县",
      "code": "344401"
    }, {
      "value": "金溪县",
      "label": "金溪县",
      "code": "344801"
    }, {
      "value": "资溪县",
      "label": "资溪县",
      "code": "335311"
    }, {
      "value": "东乡县",
      "label": "东乡县",
      "code": "331806"
    }, {
      "value": "广昌县",
      "label": "广昌县",
      "code": "344901"
    }],
    "value": "抚州市",
    "label": "抚州市"
  }, {
    "children": [{
      "value": "信州区",
      "label": "信州区",
      "code": "334001"
    }, {
      "value": "广丰区",
      "label": "广丰区",
      "code": "334601"
    }, {
      "value": "上饶县",
      "label": "上饶县",
      "code": "334101"
    }, {
      "value": "玉山县",
      "label": "玉山县",
      "code": "334708"
    }, {
      "value": "铅山县",
      "label": "铅山县",
      "code": "334518"
    }, {
      "value": "横峰县",
      "label": "横峰县",
      "code": "334306"
    }, {
      "value": "弋阳县",
      "label": "弋阳县",
      "code": "334401"
    }, {
      "value": "余干县",
      "label": "余干县",
      "code": "335116"
    }, {
      "value": "鄱阳县",
      "label": "鄱阳县",
      "code": "333101"
    }, {
      "value": "万年县",
      "label": "万年县",
      "code": "335503"
    }, {
      "value": "婺源县",
      "label": "婺源县",
      "code": "333215"
    }, {
      "value": "德兴市",
      "label": "德兴市",
      "code": "334201"
    }],
    "value": "上饶市",
    "label": "上饶市"
  }],
  "value": "江西省",
  "label": "江西省"
}, {
  "children": [{
    "children": [{
      "value": "历下区",
      "label": "历下区",
      "code": "250014"
    }, {
      "value": "市中区",
      "label": "市中区",
      "code": "250001"
    }, {
      "value": "槐荫区",
      "label": "槐荫区",
      "code": "250023"
    }, {
      "value": "天桥区",
      "label": "天桥区",
      "code": "250032"
    }, {
      "value": "历城区",
      "label": "历城区",
      "code": "250113"
    }, {
      "value": "长清区",
      "label": "长清区",
      "code": "250301"
    }, {
      "value": "平阴县",
      "label": "平阴县",
      "code": "250409"
    }, {
      "value": "济阳县",
      "label": "济阳县",
      "code": "251406"
    }, {
      "value": "商河县",
      "label": "商河县",
      "code": "251609"
    }, {
      "value": "章丘市",
      "label": "章丘市",
      "code": "250217"
    }],
    "value": "济南市",
    "label": "济南市"
  }, {
    "children": [{
      "value": "市南区",
      "label": "市南区",
      "code": "266071"
    }, {
      "value": "市北区",
      "label": "市北区",
      "code": "266023"
    }, {
      "value": "黄岛区",
      "label": "黄岛区",
      "code": "266511"
    }, {
      "value": "崂山区",
      "label": "崂山区",
      "code": "266101"
    }, {
      "value": "李沧区",
      "label": "李沧区",
      "code": "266043"
    }, {
      "value": "城阳区",
      "label": "城阳区",
      "code": "266108"
    }, {
      "value": "胶州市",
      "label": "胶州市",
      "code": "266324"
    }, {
      "value": "即墨市",
      "label": "即墨市",
      "code": "266201"
    }, {
      "value": "平度市",
      "label": "平度市",
      "code": "266701"
    }, {
      "value": "莱西市",
      "label": "莱西市",
      "code": "266615"
    }],
    "value": "青岛市",
    "label": "青岛市"
  }, {
    "children": [{
      "value": "淄川区",
      "label": "淄川区",
      "code": "255101"
    }, {
      "value": "张店区",
      "label": "张店区",
      "code": "255001"
    }, {
      "value": "博山区",
      "label": "博山区",
      "code": "255201"
    }, {
      "value": "临淄区",
      "label": "临淄区",
      "code": "255421"
    }, {
      "value": "周村区",
      "label": "周村区",
      "code": "255301"
    }, {
      "value": "桓台县",
      "label": "桓台县",
      "code": "256405"
    }, {
      "value": "高青县",
      "label": "高青县",
      "code": "256301"
    }, {
      "value": "沂源县",
      "label": "沂源县",
      "code": "256101"
    }],
    "value": "淄博市",
    "label": "淄博市"
  }, {
    "children": [{
      "value": "市中区",
      "label": "市中区",
      "code": "277101"
    }, {
      "value": "薛城区",
      "label": "薛城区",
      "code": "277001"
    }, {
      "value": "峄城区",
      "label": "峄城区",
      "code": "277324"
    }, {
      "value": "台儿庄区",
      "label": "台儿庄区",
      "code": "277412"
    }, {
      "value": "山亭区",
      "label": "山亭区",
      "code": "277215"
    }, {
      "value": "滕州市",
      "label": "滕州市",
      "code": "277501"
    }],
    "value": "枣庄市",
    "label": "枣庄市"
  }, {
    "children": [{
      "value": "东营区",
      "label": "东营区",
      "code": "257001"
    }, {
      "value": "河口区",
      "label": "河口区",
      "code": "257232"
    }, {
      "value": "垦利县",
      "label": "垦利县",
      "code": "257506"
    }, {
      "value": "利津县",
      "label": "利津县",
      "code": "257442"
    }, {
      "value": "广饶县",
      "label": "广饶县",
      "code": "257335"
    }],
    "value": "东营市",
    "label": "东营市"
  }, {
    "children": [{
      "value": "芝罘区",
      "label": "芝罘区",
      "code": "264001"
    }, {
      "value": "福山区",
      "label": "福山区",
      "code": "265504"
    }, {
      "value": "牟平区",
      "label": "牟平区",
      "code": "264106"
    }, {
      "value": "莱山区",
      "label": "莱山区",
      "code": "264003"
    }, {
      "value": "长岛县",
      "label": "长岛县",
      "code": "265812"
    }, {
      "value": "龙口市",
      "label": "龙口市",
      "code": "265709"
    }, {
      "value": "莱阳市",
      "label": "莱阳市",
      "code": "265201"
    }, {
      "value": "莱州市",
      "label": "莱州市",
      "code": "261413"
    }, {
      "value": "蓬莱市",
      "label": "蓬莱市",
      "code": "265602"
    }, {
      "value": "招远市",
      "label": "招远市",
      "code": "265401"
    }, {
      "value": "栖霞市",
      "label": "栖霞市",
      "code": "265301"
    }, {
      "value": "海阳市",
      "label": "海阳市",
      "code": "265101"
    }],
    "value": "烟台市",
    "label": "烟台市"
  }, {
    "children": [{
      "value": "潍城区",
      "label": "潍城区",
      "code": "261021"
    }, {
      "value": "寒亭区",
      "label": "寒亭区",
      "code": "261112"
    }, {
      "value": "坊子区",
      "label": "坊子区",
      "code": "261207"
    }, {
      "value": "奎文区",
      "label": "奎文区",
      "code": "261031"
    }, {
      "value": "临朐县",
      "label": "临朐县",
      "code": "262619"
    }, {
      "value": "昌乐县",
      "label": "昌乐县",
      "code": "262401"
    }, {
      "value": "青州市",
      "label": "青州市",
      "code": "262501"
    }, {
      "value": "诸城市",
      "label": "诸城市",
      "code": "262201"
    }, {
      "value": "寿光市",
      "label": "寿光市",
      "code": "262731"
    }, {
      "value": "安丘市",
      "label": "安丘市",
      "code": "262108"
    }, {
      "value": "高密市",
      "label": "高密市",
      "code": "261516"
    }, {
      "value": "昌邑市",
      "label": "昌邑市",
      "code": "261307"
    }],
    "value": "潍坊市",
    "label": "潍坊市"
  }, {
    "children": [{
      "value": "任城区",
      "label": "任城区",
      "code": "272103"
    }, {
      "value": "兖州区",
      "label": "兖州区",
      "code": "272101"
    }, {
      "value": "微山县",
      "label": "微山县",
      "code": "277605"
    }, {
      "value": "鱼台县",
      "label": "鱼台县",
      "code": "272342"
    }, {
      "value": "金乡县",
      "label": "金乡县",
      "code": "272201"
    }, {
      "value": "嘉祥县",
      "label": "嘉祥县",
      "code": "272415"
    }, {
      "value": "汶上县",
      "label": "汶上县",
      "code": "272507"
    }, {
      "value": "泗水县",
      "label": "泗水县",
      "code": "273201"
    }, {
      "value": "梁山县",
      "label": "梁山县",
      "code": "272601"
    }, {
      "value": "曲阜市",
      "label": "曲阜市",
      "code": "273101"
    }, {
      "value": "邹城市",
      "label": "邹城市",
      "code": "273501"
    }],
    "value": "济宁市",
    "label": "济宁市"
  }, {
    "children": [{
      "value": "泰山区",
      "label": "泰山区",
      "code": "271002"
    }, {
      "value": "岱岳区",
      "label": "岱岳区",
      "code": "271021"
    }, {
      "value": "宁阳县",
      "label": "宁阳县",
      "code": "271417"
    }, {
      "value": "东平县",
      "label": "东平县",
      "code": "271502"
    }, {
      "value": "新泰市",
      "label": "新泰市",
      "code": "271201"
    }, {
      "value": "肥城市",
      "label": "肥城市",
      "code": "271601"
    }],
    "value": "泰安市",
    "label": "泰安市"
  }, {
    "children": [{
      "value": "环翠区",
      "label": "环翠区",
      "code": "264203"
    }, {
      "value": "文登区",
      "label": "文登区",
      "code": "266441"
    }, {
      "value": "文登市",
      "label": "文登市",
      "code": "264402"
    }, {
      "value": "荣成市",
      "label": "荣成市",
      "code": "264309"
    }, {
      "value": "乳山市",
      "label": "乳山市",
      "code": "264515"
    }],
    "value": "威海市",
    "label": "威海市"
  }, {
    "children": [{
      "value": "东港区",
      "label": "东港区",
      "code": "276803"
    }, {
      "value": "岚山区",
      "label": "岚山区",
      "code": "276812"
    }, {
      "value": "五莲县",
      "label": "五莲县",
      "code": "262316"
    }, {
      "value": "莒县",
      "label": "莒县",
      "code": "276526"
    }],
    "value": "日照市",
    "label": "日照市"
  }, {
    "children": [{
      "value": "莱城区",
      "label": "莱城区",
      "code": "271116"
    }, {
      "value": "钢城区",
      "label": "钢城区",
      "code": "271108"
    }],
    "value": "莱芜市",
    "label": "莱芜市"
  }, {
    "children": [{
      "value": "兰山区",
      "label": "兰山区",
      "code": "276037"
    }, {
      "value": "罗庄区",
      "label": "罗庄区",
      "code": "276017"
    }, {
      "value": "河东区",
      "label": "河东区",
      "code": "276032"
    }, {
      "value": "沂南县",
      "label": "沂南县",
      "code": "276301"
    }, {
      "value": "郯城县",
      "label": "郯城县",
      "code": "276116"
    }, {
      "value": "沂水县",
      "label": "沂水县",
      "code": "276411"
    }, {
      "value": "苍山县",
      "label": "苍山县",
      "code": "277713"
    }, {
      "value": "费县",
      "label": "费县",
      "code": "273423"
    }, {
      "value": "平邑县",
      "label": "平邑县",
      "code": "273301"
    }, {
      "value": "莒南县",
      "label": "莒南县",
      "code": "276634"
    }, {
      "value": "蒙阴县",
      "label": "蒙阴县",
      "code": "276223"
    }, {
      "value": "临沭县",
      "label": "临沭县",
      "code": "276711"
    }],
    "value": "临沂市",
    "label": "临沂市"
  }, {
    "children": [{
      "value": "德城区",
      "label": "德城区",
      "code": "253029"
    }, {
      "value": "陵城区",
      "label": "陵城区",
      "code": "253501"
    }, {
      "value": "宁津县",
      "label": "宁津县",
      "code": "253413"
    }, {
      "value": "庆云县",
      "label": "庆云县",
      "code": "253701"
    }, {
      "value": "临邑县",
      "label": "临邑县",
      "code": "251514"
    }, {
      "value": "齐河县",
      "label": "齐河县",
      "code": "251114"
    }, {
      "value": "平原县",
      "label": "平原县",
      "code": "253116"
    }, {
      "value": "夏津县",
      "label": "夏津县",
      "code": "253219"
    }, {
      "value": "武城县",
      "label": "武城县",
      "code": "253315"
    }, {
      "value": "乐陵市",
      "label": "乐陵市",
      "code": "253601"
    }, {
      "value": "禹城市",
      "label": "禹城市",
      "code": "251201"
    }],
    "value": "德州市",
    "label": "德州市"
  }, {
    "children": [{
      "value": "东昌府区",
      "label": "东昌府区",
      "code": "252001"
    }, {
      "value": "阳谷县",
      "label": "阳谷县",
      "code": "252326"
    }, {
      "value": "莘县",
      "label": "莘县",
      "code": "252411"
    }, {
      "value": "茌平县",
      "label": "茌平县",
      "code": "252111"
    }, {
      "value": "东阿县",
      "label": "东阿县",
      "code": "252219"
    }, {
      "value": "冠县",
      "label": "冠县",
      "code": "252514"
    }, {
      "value": "高唐县",
      "label": "高唐县",
      "code": "252861"
    }, {
      "value": "临清市",
      "label": "临清市",
      "code": "252601"
    }],
    "value": "聊城市",
    "label": "聊城市"
  }, {
    "children": [{
      "value": "滨城区",
      "label": "滨城区",
      "code": "256601"
    }, {
      "value": "沾化区",
      "label": "沾化区",
      "code": "256801"
    }, {
      "value": "惠民县",
      "label": "惠民县",
      "code": "251713"
    }, {
      "value": "阳信县",
      "label": "阳信县",
      "code": "251801"
    }, {
      "value": "无棣县",
      "label": "无棣县",
      "code": "251906"
    }, {
      "value": "博兴县",
      "label": "博兴县",
      "code": "256501"
    }, {
      "value": "邹平县",
      "label": "邹平县",
      "code": "256201"
    }],
    "value": "滨州市",
    "label": "滨州市"
  }, {
    "children": [{
      "value": "牡丹区",
      "label": "牡丹区",
      "code": "274031"
    }, {
      "value": "曹县",
      "label": "曹县",
      "code": "274401"
    }, {
      "value": "单县",
      "label": "单县",
      "code": "274322"
    }, {
      "value": "成武县",
      "label": "成武县",
      "code": "274201"
    }, {
      "value": "巨野县",
      "label": "巨野县",
      "code": "274901"
    }, {
      "value": "郓城县",
      "label": "郓城县",
      "code": "274701"
    }, {
      "value": "鄄城县",
      "label": "鄄城县",
      "code": "274601"
    }, {
      "value": "定陶县",
      "label": "定陶县",
      "code": "274101"
    }, {
      "value": "东明县",
      "label": "东明县",
      "code": "274513"
    }],
    "value": "菏泽市",
    "label": "菏泽市"
  }],
  "value": "山东省",
  "label": "山东省"
}, {
  "children": [{
    "children": [{
      "value": "中原区",
      "label": "中原区",
      "code": "450006"
    }, {
      "value": "二七区",
      "label": "二七区",
      "code": "450015"
    }, {
      "value": "管城回族区",
      "label": "管城回族区",
      "code": "450046"
    }, {
      "value": "金水区",
      "label": "金水区",
      "code": "450004"
    }, {
      "value": "上街区",
      "label": "上街区",
      "code": "450041"
    }, {
      "value": "惠济区",
      "label": "惠济区",
      "code": "450044"
    }, {
      "value": "中牟县",
      "label": "中牟县",
      "code": "451451"
    }, {
      "value": "巩义市",
      "label": "巩义市",
      "code": "451272"
    }, {
      "value": "荥阳市",
      "label": "荥阳市",
      "code": "450101"
    }, {
      "value": "新密市",
      "label": "新密市",
      "code": "452371"
    }, {
      "value": "新郑市",
      "label": "新郑市",
      "code": "451101"
    }, {
      "value": "登封市",
      "label": "登封市",
      "code": "452483"
    }],
    "value": "郑州市",
    "label": "郑州市"
  }, {
    "children": [{
      "value": "龙亭区",
      "label": "龙亭区",
      "code": "475001"
    }, {
      "value": "顺河回族区",
      "label": "顺河回族区",
      "code": "475001"
    }, {
      "value": "鼓楼区",
      "label": "鼓楼区",
      "code": "475001"
    }, {
      "value": "禹王台区",
      "label": "禹王台区",
      "code": "475003"
    }, {
      "value": "祥符区",
      "label": "祥符区",
      "code": "475101"
    }, {
      "value": "杞县",
      "label": "杞县",
      "code": "475201"
    }, {
      "value": "通许县",
      "label": "通许县",
      "code": "475401"
    }, {
      "value": "尉氏县",
      "label": "尉氏县",
      "code": "475501"
    }, {
      "value": "兰考县",
      "label": "兰考县",
      "code": "475318"
    }],
    "value": "开封市",
    "label": "开封市"
  }, {
    "children": [{
      "value": "老城区",
      "label": "老城区",
      "code": "471002"
    }, {
      "value": "西工区",
      "label": "西工区",
      "code": "471001"
    }, {
      "value": "瀍河回族区",
      "label": "瀍河回族区",
      "code": "471002"
    }, {
      "value": "涧西区",
      "label": "涧西区",
      "code": "471003"
    }, {
      "value": "吉利区",
      "label": "吉利区",
      "code": "471012"
    }, {
      "value": "洛龙区",
      "label": "洛龙区",
      "code": "471023"
    }, {
      "value": "孟津县",
      "label": "孟津县",
      "code": "471111"
    }, {
      "value": "新安县",
      "label": "新安县",
      "code": "471801"
    }, {
      "value": "栾川县",
      "label": "栾川县",
      "code": "471501"
    }, {
      "value": "嵩县",
      "label": "嵩县",
      "code": "471401"
    }, {
      "value": "汝阳县",
      "label": "汝阳县",
      "code": "471201"
    }, {
      "value": "宜阳县",
      "label": "宜阳县",
      "code": "471631"
    }, {
      "value": "洛宁县",
      "label": "洛宁县",
      "code": "471716"
    }, {
      "value": "伊川县",
      "label": "伊川县",
      "code": "471301"
    }, {
      "value": "偃师市",
      "label": "偃师市",
      "code": "471934"
    }],
    "value": "洛阳市",
    "label": "洛阳市"
  }, {
    "children": [{
      "value": "新华区",
      "label": "新华区",
      "code": "467031"
    }, {
      "value": "卫东区",
      "label": "卫东区",
      "code": "467001"
    }, {
      "value": "石龙区",
      "label": "石龙区",
      "code": "467043"
    }, {
      "value": "湛河区",
      "label": "湛河区",
      "code": "467001"
    }, {
      "value": "宝丰县",
      "label": "宝丰县",
      "code": "467401"
    }, {
      "value": "叶县",
      "label": "叶县",
      "code": "467211"
    }, {
      "value": "鲁山县",
      "label": "鲁山县",
      "code": "467341"
    }, {
      "value": "郏县",
      "label": "郏县",
      "code": "467101"
    }, {
      "value": "舞钢市",
      "label": "舞钢市",
      "code": "462501"
    }, {
      "value": "汝州市",
      "label": "汝州市",
      "code": "467501"
    }],
    "value": "平顶山市",
    "label": "平顶山市"
  }, {
    "children": [{
      "value": "文峰区",
      "label": "文峰区",
      "code": "455001"
    }, {
      "value": "北关区",
      "label": "北关区",
      "code": "455001"
    }, {
      "value": "殷都区",
      "label": "殷都区",
      "code": "455004"
    }, {
      "value": "龙安区",
      "label": "龙安区",
      "code": "455003"
    }, {
      "value": "安阳县",
      "label": "安阳县",
      "code": "455133"
    }, {
      "value": "汤阴县",
      "label": "汤阴县",
      "code": "456151"
    }, {
      "value": "滑县",
      "label": "滑县",
      "code": "456477"
    }, {
      "value": "内黄县",
      "label": "内黄县",
      "code": "456361"
    }, {
      "value": "林州市",
      "label": "林州市",
      "code": "456572"
    }],
    "value": "安阳市",
    "label": "安阳市"
  }, {
    "children": [{
      "value": "鹤山区",
      "label": "鹤山区",
      "code": "458011"
    }, {
      "value": "山城区",
      "label": "山城区",
      "code": "458001"
    }, {
      "value": "淇滨区",
      "label": "淇滨区",
      "code": "458031"
    }, {
      "value": "浚县",
      "label": "浚县",
      "code": "456251"
    }, {
      "value": "淇县",
      "label": "淇县",
      "code": "456751"
    }],
    "value": "鹤壁市",
    "label": "鹤壁市"
  }, {
    "children": [{
      "value": "红旗区",
      "label": "红旗区",
      "code": "453003"
    }, {
      "value": "卫滨区",
      "label": "卫滨区",
      "code": "453001"
    }, {
      "value": "凤泉区",
      "label": "凤泉区",
      "code": "453011"
    }, {
      "value": "牧野区",
      "label": "牧野区",
      "code": "453002"
    }, {
      "value": "新乡县",
      "label": "新乡县",
      "code": "453701"
    }, {
      "value": "获嘉县",
      "label": "获嘉县",
      "code": "453836"
    }, {
      "value": "原阳县",
      "label": "原阳县",
      "code": "453506"
    }, {
      "value": "延津县",
      "label": "延津县",
      "code": "453201"
    }, {
      "value": "封丘县",
      "label": "封丘县",
      "code": "453315"
    }, {
      "value": "长垣县",
      "label": "长垣县",
      "code": "453401"
    }, {
      "value": "卫辉市",
      "label": "卫辉市",
      "code": "453144"
    }, {
      "value": "辉县市",
      "label": "辉县市",
      "code": "453601"
    }],
    "value": "新乡市",
    "label": "新乡市"
  }, {
    "children": [{
      "value": "解放区",
      "label": "解放区",
      "code": "454001"
    }, {
      "value": "中站区",
      "label": "中站区",
      "code": "454191"
    }, {
      "value": "马村区",
      "label": "马村区",
      "code": "454171"
    }, {
      "value": "山阳区",
      "label": "山阳区",
      "code": "454003"
    }, {
      "value": "修武县",
      "label": "修武县",
      "code": "454351"
    }, {
      "value": "博爱县",
      "label": "博爱县",
      "code": "454451"
    }, {
      "value": "武陟县",
      "label": "武陟县",
      "code": "454951"
    }, {
      "value": "温县",
      "label": "温县",
      "code": "454892"
    }, {
      "value": "沁阳市",
      "label": "沁阳市",
      "code": "454501"
    }, {
      "value": "孟州市",
      "label": "孟州市",
      "code": "454751"
    }],
    "value": "焦作市",
    "label": "焦作市"
  }, {
    "children": [{
      "value": "华龙区",
      "label": "华龙区",
      "code": "457006"
    }, {
      "value": "清丰县",
      "label": "清丰县",
      "code": "457301"
    }, {
      "value": "南乐县",
      "label": "南乐县",
      "code": "457401"
    }, {
      "value": "范县",
      "label": "范县",
      "code": "457512"
    }, {
      "value": "台前县",
      "label": "台前县",
      "code": "457631"
    }, {
      "value": "濮阳县",
      "label": "濮阳县",
      "code": "457181"
    }],
    "value": "濮阳市",
    "label": "濮阳市"
  }, {
    "children": [{
      "value": "魏都区",
      "label": "魏都区",
      "code": "461001"
    }, {
      "value": "许昌县",
      "label": "许昌县",
      "code": "461101"
    }, {
      "value": "鄢陵县",
      "label": "鄢陵县",
      "code": "461226"
    }, {
      "value": "襄城县",
      "label": "襄城县",
      "code": "461707"
    }, {
      "value": "禹州市",
      "label": "禹州市",
      "code": "461685"
    }, {
      "value": "长葛市",
      "label": "长葛市",
      "code": "461511"
    }],
    "value": "许昌市",
    "label": "许昌市"
  }, {
    "children": [{
      "value": "源汇区",
      "label": "源汇区",
      "code": "462001"
    }, {
      "value": "郾城区",
      "label": "郾城区",
      "code": "462301"
    }, {
      "value": "召陵区",
      "label": "召陵区",
      "code": "462301"
    }, {
      "value": "舞阳县",
      "label": "舞阳县",
      "code": "462401"
    }, {
      "value": "临颍县",
      "label": "临颍县",
      "code": "462609"
    }],
    "value": "漯河市",
    "label": "漯河市"
  }, {
    "children": [{
      "value": "湖滨区",
      "label": "湖滨区",
      "code": "472001"
    }, {
      "value": "陕州区",
      "label": "陕州区",
      "code": "472101"
    }, {
      "value": "渑池县",
      "label": "渑池县",
      "code": "472401"
    }, {
      "value": "卢氏县",
      "label": "卢氏县",
      "code": "472201"
    }, {
      "value": "义马市",
      "label": "义马市",
      "code": "472301"
    }, {
      "value": "灵宝市",
      "label": "灵宝市",
      "code": "472542"
    }],
    "value": "三门峡市",
    "label": "三门峡市"
  }, {
    "children": [{
      "value": "宛城区",
      "label": "宛城区",
      "code": "473125"
    }, {
      "value": "卧龙区",
      "label": "卧龙区",
      "code": "473006"
    }, {
      "value": "南召县",
      "label": "南召县",
      "code": "474663"
    }, {
      "value": "方城县",
      "label": "方城县",
      "code": "473254"
    }, {
      "value": "西峡县",
      "label": "西峡县",
      "code": "474501"
    }, {
      "value": "镇平县",
      "label": "镇平县",
      "code": "474285"
    }, {
      "value": "内乡县",
      "label": "内乡县",
      "code": "474351"
    }, {
      "value": "淅川县",
      "label": "淅川县",
      "code": "474485"
    }, {
      "value": "社旗县",
      "label": "社旗县",
      "code": "473301"
    }, {
      "value": "唐河县",
      "label": "唐河县",
      "code": "473414"
    }, {
      "value": "新野县",
      "label": "新野县",
      "code": "473525"
    }, {
      "value": "桐柏县",
      "label": "桐柏县",
      "code": "474715"
    }, {
      "value": "邓州市",
      "label": "邓州市",
      "code": "474171"
    }],
    "value": "南阳市",
    "label": "南阳市"
  }, {
    "children": [{
      "value": "梁园区",
      "label": "梁园区",
      "code": "476001"
    }, {
      "value": "睢阳区",
      "label": "睢阳区",
      "code": "476133"
    }, {
      "value": "民权县",
      "label": "民权县",
      "code": "476812"
    }, {
      "value": "睢县",
      "label": "睢县",
      "code": "476923"
    }, {
      "value": "宁陵县",
      "label": "宁陵县",
      "code": "476701"
    }, {
      "value": "柘城县",
      "label": "柘城县",
      "code": "476241"
    }, {
      "value": "虞城县",
      "label": "虞城县",
      "code": "476345"
    }, {
      "value": "夏邑县",
      "label": "夏邑县",
      "code": "476424"
    }, {
      "value": "永城市",
      "label": "永城市",
      "code": "476601"
    }],
    "value": "商丘市",
    "label": "商丘市"
  }, {
    "children": [{
      "value": "浉河区",
      "label": "浉河区",
      "code": "464001"
    }, {
      "value": "平桥区",
      "label": "平桥区",
      "code": "464192"
    }, {
      "value": "罗山县",
      "label": "罗山县",
      "code": "464201"
    }, {
      "value": "光山县",
      "label": "光山县",
      "code": "465401"
    }, {
      "value": "新县",
      "label": "新县",
      "code": "465545"
    }, {
      "value": "商城县",
      "label": "商城县",
      "code": "465333"
    }, {
      "value": "固始县",
      "label": "固始县",
      "code": "465201"
    }, {
      "value": "潢川县",
      "label": "潢川县",
      "code": "465131"
    }, {
      "value": "淮滨县",
      "label": "淮滨县",
      "code": "464401"
    }, {
      "value": "息县",
      "label": "息县",
      "code": "464314"
    }],
    "value": "信阳市",
    "label": "信阳市"
  }, {
    "children": [{
      "value": "川汇区",
      "label": "川汇区",
      "code": "466001"
    }, {
      "value": "扶沟县",
      "label": "扶沟县",
      "code": "461301"
    }, {
      "value": "西华县",
      "label": "西华县",
      "code": "466612"
    }, {
      "value": "商水县",
      "label": "商水县",
      "code": "466143"
    }, {
      "value": "沈丘县",
      "label": "沈丘县",
      "code": "466332"
    }, {
      "value": "郸城县",
      "label": "郸城县",
      "code": "477151"
    }, {
      "value": "淮阳县",
      "label": "淮阳县",
      "code": "466701"
    }, {
      "value": "太康县",
      "label": "太康县",
      "code": "461423"
    }, {
      "value": "鹿邑县",
      "label": "鹿邑县",
      "code": "477201"
    }, {
      "value": "项城市",
      "label": "项城市",
      "code": "466201"
    }],
    "value": "周口市",
    "label": "周口市"
  }, {
    "children": [{
      "value": "驿城区",
      "label": "驿城区",
      "code": "463341"
    }, {
      "value": "西平县",
      "label": "西平县",
      "code": "463901"
    }, {
      "value": "上蔡县",
      "label": "上蔡县",
      "code": "463811"
    }, {
      "value": "平舆县",
      "label": "平舆县",
      "code": "463412"
    }, {
      "value": "正阳县",
      "label": "正阳县",
      "code": "463603"
    }, {
      "value": "确山县",
      "label": "确山县",
      "code": "463206"
    }, {
      "value": "泌阳县",
      "label": "泌阳县",
      "code": "463701"
    }, {
      "value": "汝南县",
      "label": "汝南县",
      "code": "463335"
    }, {
      "value": "遂平县",
      "label": "遂平县",
      "code": "463134"
    }, {
      "value": "新蔡县",
      "label": "新蔡县",
      "code": "463503"
    }],
    "value": "驻马店市",
    "label": "驻马店市"
  }, {
    "children": [{
      "value": "济源市",
      "label": "济源市",
      "code": "454001"
    }],
    "value": "省直辖县",
    "label": "省直辖县"
  }],
  "value": "河南省",
  "label": "河南省"
}, {
  "children": [{
    "children": [{
      "value": "江岸区",
      "label": "江岸区",
      "code": "430012"
    }, {
      "value": "江汉区",
      "label": "江汉区",
      "code": "430023"
    }, {
      "value": "硚口区",
      "label": "硚口区",
      "code": "430032"
    }, {
      "value": "汉阳区",
      "label": "汉阳区",
      "code": "430051"
    }, {
      "value": "武昌区",
      "label": "武昌区",
      "code": "430064"
    }, {
      "value": "青山区",
      "label": "青山区",
      "code": "430085"
    }, {
      "value": "洪山区",
      "label": "洪山区",
      "code": "430071"
    }, {
      "value": "东西湖区",
      "label": "东西湖区",
      "code": "430041"
    }, {
      "value": "汉南区",
      "label": "汉南区",
      "code": "430091"
    }, {
      "value": "蔡甸区",
      "label": "蔡甸区",
      "code": "430101"
    }, {
      "value": "江夏区",
      "label": "江夏区",
      "code": "430208"
    }, {
      "value": "黄陂区",
      "label": "黄陂区",
      "code": "430346"
    }, {
      "value": "新洲区",
      "label": "新洲区",
      "code": "430401"
    }],
    "value": "武汉市",
    "label": "武汉市"
  }, {
    "children": [{
      "value": "黄石港区",
      "label": "黄石港区",
      "code": "435002"
    }, {
      "value": "西塞山区",
      "label": "西塞山区",
      "code": "435001"
    }, {
      "value": "下陆区",
      "label": "下陆区",
      "code": "435004"
    }, {
      "value": "铁山区",
      "label": "铁山区",
      "code": "435006"
    }, {
      "value": "阳新县",
      "label": "阳新县",
      "code": "435201"
    }, {
      "value": "大冶市",
      "label": "大冶市",
      "code": "435101"
    }],
    "value": "黄石市",
    "label": "黄石市"
  }, {
    "children": [{
      "value": "茅箭区",
      "label": "茅箭区",
      "code": "442013"
    }, {
      "value": "张湾区",
      "label": "张湾区",
      "code": "442002"
    }, {
      "value": "郧阳区",
      "label": "郧阳区",
      "code": "442501"
    }, {
      "value": "郧西县",
      "label": "郧西县",
      "code": "442634"
    }, {
      "value": "竹山县",
      "label": "竹山县",
      "code": "442201"
    }, {
      "value": "竹溪县",
      "label": "竹溪县",
      "code": "442318"
    }, {
      "value": "房县",
      "label": "房县",
      "code": "442108"
    }, {
      "value": "丹江口市",
      "label": "丹江口市",
      "code": "442716"
    }],
    "value": "十堰市",
    "label": "十堰市"
  }, {
    "children": [{
      "value": "西陵区",
      "label": "西陵区",
      "code": "443001"
    }, {
      "value": "伍家岗区",
      "label": "伍家岗区",
      "code": "443003"
    }, {
      "value": "点军区",
      "label": "点军区",
      "code": "443004"
    }, {
      "value": "猇亭区",
      "label": "猇亭区",
      "code": "443007"
    }, {
      "value": "夷陵区",
      "label": "夷陵区",
      "code": "443141"
    }, {
      "value": "远安县",
      "label": "远安县",
      "code": "444209"
    }, {
      "value": "兴山县",
      "label": "兴山县",
      "code": "443713"
    }, {
      "value": "秭归县",
      "label": "秭归县",
      "code": "443601"
    }, {
      "value": "长阳土家族自治县",
      "label": "长阳土家族自治县",
      "code": "443516"
    }, {
      "value": "五峰土家族自治县",
      "label": "五峰土家族自治县",
      "code": "443406"
    }, {
      "value": "宜都市",
      "label": "宜都市",
      "code": "443302"
    }, {
      "value": "当阳市",
      "label": "当阳市",
      "code": "444101"
    }, {
      "value": "枝江市",
      "label": "枝江市",
      "code": "443201"
    }],
    "value": "宜昌市",
    "label": "宜昌市"
  }, {
    "children": [{
      "value": "襄城区",
      "label": "襄城区",
      "code": "441101"
    }, {
      "value": "樊城区",
      "label": "樊城区",
      "code": "441003"
    }, {
      "value": "襄州区",
      "label": "襄州区",
      "code": "441101"
    }, {
      "value": "南漳县",
      "label": "南漳县",
      "code": "441501"
    }, {
      "value": "谷城县",
      "label": "谷城县",
      "code": "441705"
    }, {
      "value": "保康县",
      "label": "保康县",
      "code": "441616"
    }, {
      "value": "老河口市",
      "label": "老河口市",
      "code": "441801"
    }, {
      "value": "枣阳市",
      "label": "枣阳市",
      "code": "441201"
    }, {
      "value": "宜城市",
      "label": "宜城市",
      "code": "441400"
    }],
    "value": "襄阳市",
    "label": "襄阳市"
  }, {
    "children": [{
      "value": "梁子湖区",
      "label": "梁子湖区",
      "code": "436061"
    }, {
      "value": "华容区",
      "label": "华容区",
      "code": "436031"
    }, {
      "value": "鄂城区",
      "label": "鄂城区",
      "code": "436041"
    }],
    "value": "鄂州市",
    "label": "鄂州市"
  }, {
    "children": [{
      "value": "东宝区",
      "label": "东宝区",
      "code": "448153"
    }, {
      "value": "掇刀区",
      "label": "掇刀区",
      "code": "448126"
    }, {
      "value": "京山县",
      "label": "京山县",
      "code": "431801"
    }, {
      "value": "沙洋县",
      "label": "沙洋县",
      "code": "420822"
    }, {
      "value": "钟祥市",
      "label": "钟祥市",
      "code": "431911"
    }],
    "value": "荆门市",
    "label": "荆门市"
  }, {
    "children": [{
      "value": "孝南区",
      "label": "孝南区",
      "code": "432001"
    }, {
      "value": "孝昌县",
      "label": "孝昌县",
      "code": "432901"
    }, {
      "value": "大悟县",
      "label": "大悟县",
      "code": "432821"
    }, {
      "value": "云梦县",
      "label": "云梦县",
      "code": "432501"
    }, {
      "value": "应城市",
      "label": "应城市",
      "code": "432401"
    }, {
      "value": "安陆市",
      "label": "安陆市",
      "code": "432616"
    }, {
      "value": "汉川市",
      "label": "汉川市",
      "code": "431601"
    }],
    "value": "孝感市",
    "label": "孝感市"
  }, {
    "children": [{
      "value": "沙市区",
      "label": "沙市区",
      "code": "434001"
    }, {
      "value": "荆州区",
      "label": "荆州区",
      "code": "434021"
    }, {
      "value": "公安县",
      "label": "公安县",
      "code": "434318"
    }, {
      "value": "监利县",
      "label": "监利县",
      "code": "433331"
    }, {
      "value": "江陵县",
      "label": "江陵县",
      "code": "434105"
    }, {
      "value": "石首市",
      "label": "石首市",
      "code": "434401"
    }, {
      "value": "洪湖市",
      "label": "洪湖市",
      "code": "433201"
    }, {
      "value": "松滋市",
      "label": "松滋市",
      "code": "434212"
    }],
    "value": "荆州市",
    "label": "荆州市"
  }, {
    "children": [{
      "value": "黄州区",
      "label": "黄州区",
      "code": "438011"
    }, {
      "value": "团风县",
      "label": "团风县",
      "code": "438822"
    }, {
      "value": "红安县",
      "label": "红安县",
      "code": "438411"
    }, {
      "value": "罗田县",
      "label": "罗田县",
      "code": "438601"
    }, {
      "value": "英山县",
      "label": "英山县",
      "code": "438701"
    }, {
      "value": "浠水县",
      "label": "浠水县",
      "code": "438706"
    }, {
      "value": "蕲春县",
      "label": "蕲春县",
      "code": "435323"
    }, {
      "value": "黄梅县",
      "label": "黄梅县",
      "code": "435501"
    }, {
      "value": "麻城市",
      "label": "麻城市",
      "code": "438301"
    }, {
      "value": "武穴市",
      "label": "武穴市",
      "code": "435408"
    }],
    "value": "黄冈市",
    "label": "黄冈市"
  }, {
    "children": [{
      "value": "咸安区",
      "label": "咸安区",
      "code": "437001"
    }, {
      "value": "嘉鱼县",
      "label": "嘉鱼县",
      "code": "437213"
    }, {
      "value": "通城县",
      "label": "通城县",
      "code": "437401"
    }, {
      "value": "崇阳县",
      "label": "崇阳县",
      "code": "437501"
    }, {
      "value": "通山县",
      "label": "通山县",
      "code": "437632"
    }, {
      "value": "赤壁市",
      "label": "赤壁市",
      "code": "437336"
    }],
    "value": "咸宁市",
    "label": "咸宁市"
  }, {
    "children": [{
      "value": "曾都区",
      "label": "曾都区",
      "code": "441301"
    }, {
      "value": "随县",
      "label": "随县",
      "code": "431501"
    }, {
      "value": "广水市",
      "label": "广水市",
      "code": "432721"
    }],
    "value": "随州市",
    "label": "随州市"
  }, {
    "children": [{
      "value": "恩施市",
      "label": "恩施市",
      "code": "445001"
    }, {
      "value": "利川市",
      "label": "利川市",
      "code": "445401"
    }, {
      "value": "建始县",
      "label": "建始县",
      "code": "445309"
    }, {
      "value": "巴东县",
      "label": "巴东县",
      "code": "444318"
    }, {
      "value": "宣恩县",
      "label": "宣恩县",
      "code": "445502"
    }, {
      "value": "咸丰县",
      "label": "咸丰县",
      "code": "445601"
    }, {
      "value": "来凤县",
      "label": "来凤县",
      "code": "445701"
    }, {
      "value": "鹤峰县",
      "label": "鹤峰县",
      "code": "445801"
    }],
    "value": "恩施土家族苗族自治州",
    "label": "恩施土家族苗族自治州"
  }, {
    "children": [{
      "value": "仙桃市",
      "label": "仙桃市",
      "code": "433024"
    }, {
      "value": "潜江市",
      "label": "潜江市",
      "code": "433139"
    }, {
      "value": "天门市",
      "label": "天门市",
      "code": "431705"
    }, {
      "value": "神农架林区",
      "label": "神农架林区",
      "code": "442411"
    }],
    "value": "省直辖县",
    "label": "省直辖县"
  }],
  "value": "湖北省",
  "label": "湖北省"
}, {
  "children": [{
    "children": [{
      "value": "芙蓉区",
      "label": "芙蓉区",
      "code": "410001"
    }, {
      "value": "天心区",
      "label": "天心区",
      "code": "410002"
    }, {
      "value": "岳麓区",
      "label": "岳麓区",
      "code": "410205"
    }, {
      "value": "开福区",
      "label": "开福区",
      "code": "410003"
    }, {
      "value": "雨花区",
      "label": "雨花区",
      "code": "410007"
    }, {
      "value": "望城区",
      "label": "望城区",
      "code": "410201"
    }, {
      "value": "长沙县",
      "label": "长沙县",
      "code": "410142"
    }, {
      "value": "宁乡县",
      "label": "宁乡县",
      "code": "410614"
    }, {
      "value": "浏阳市",
      "label": "浏阳市",
      "code": "410318"
    }],
    "value": "长沙市",
    "label": "长沙市"
  }, {
    "children": [{
      "value": "荷塘区",
      "label": "荷塘区",
      "code": "412003"
    }, {
      "value": "芦淞区",
      "label": "芦淞区",
      "code": "412002"
    }, {
      "value": "石峰区",
      "label": "石峰区",
      "code": "412004"
    }, {
      "value": "天元区",
      "label": "天元区",
      "code": "412007"
    }, {
      "value": "株洲县",
      "label": "株洲县",
      "code": "412112"
    }, {
      "value": "攸县",
      "label": "攸县",
      "code": "412306"
    }, {
      "value": "茶陵县",
      "label": "茶陵县",
      "code": "412421"
    }, {
      "value": "炎陵县",
      "label": "炎陵县",
      "code": "412512"
    }, {
      "value": "醴陵市",
      "label": "醴陵市",
      "code": "412215"
    }],
    "value": "株洲市",
    "label": "株洲市"
  }, {
    "children": [{
      "value": "雨湖区",
      "label": "雨湖区",
      "code": "411101"
    }, {
      "value": "岳塘区",
      "label": "岳塘区",
      "code": "411101"
    }, {
      "value": "湘潭县",
      "label": "湘潭县",
      "code": "411208"
    }, {
      "value": "湘乡市",
      "label": "湘乡市",
      "code": "411411"
    }, {
      "value": "韶山市",
      "label": "韶山市",
      "code": "411302"
    }],
    "value": "湘潭市",
    "label": "湘潭市"
  }, {
    "children": [{
      "value": "珠晖区",
      "label": "珠晖区",
      "code": "421002"
    }, {
      "value": "雁峰区",
      "label": "雁峰区",
      "code": "421008"
    }, {
      "value": "石鼓区",
      "label": "石鼓区",
      "code": "421001"
    }, {
      "value": "蒸湘区",
      "label": "蒸湘区",
      "code": "421001"
    }, {
      "value": "南岳区",
      "label": "南岳区",
      "code": "421901"
    }, {
      "value": "衡阳县",
      "label": "衡阳县",
      "code": "421236"
    }, {
      "value": "衡南县",
      "label": "衡南县",
      "code": "421127"
    }, {
      "value": "衡山县",
      "label": "衡山县",
      "code": "421311"
    }, {
      "value": "衡东县",
      "label": "衡东县",
      "code": "421431"
    }, {
      "value": "祁东县",
      "label": "祁东县",
      "code": "421601"
    }, {
      "value": "耒阳市",
      "label": "耒阳市",
      "code": "421801"
    }, {
      "value": "常宁市",
      "label": "常宁市",
      "code": "421519"
    }],
    "value": "衡阳市",
    "label": "衡阳市"
  }, {
    "children": [{
      "value": "双清区",
      "label": "双清区",
      "code": "422002"
    }, {
      "value": "大祥区",
      "label": "大祥区",
      "code": "422001"
    }, {
      "value": "北塔区",
      "label": "北塔区",
      "code": "422006"
    }, {
      "value": "邵东县",
      "label": "邵东县",
      "code": "422802"
    }, {
      "value": "新邵县",
      "label": "新邵县",
      "code": "422918"
    }, {
      "value": "邵阳县",
      "label": "邵阳县",
      "code": "422115"
    }, {
      "value": "隆回县",
      "label": "隆回县",
      "code": "422203"
    }, {
      "value": "洞口县",
      "label": "洞口县",
      "code": "422312"
    }, {
      "value": "绥宁县",
      "label": "绥宁县",
      "code": "422607"
    }, {
      "value": "新宁县",
      "label": "新宁县",
      "code": "422707"
    }, {
      "value": "城步苗族自治县",
      "label": "城步苗族自治县",
      "code": "422511"
    }, {
      "value": "武冈市",
      "label": "武冈市",
      "code": "422407"
    }],
    "value": "邵阳市",
    "label": "邵阳市"
  }, {
    "children": [{
      "value": "岳阳楼区",
      "label": "岳阳楼区",
      "code": "414007"
    }, {
      "value": "云溪区",
      "label": "云溪区",
      "code": "414013"
    }, {
      "value": "君山区",
      "label": "君山区",
      "code": "414017"
    }, {
      "value": "岳阳县",
      "label": "岳阳县",
      "code": "414116"
    }, {
      "value": "华容县",
      "label": "华容县",
      "code": "414201"
    }, {
      "value": "湘阴县",
      "label": "湘阴县",
      "code": "414601"
    }, {
      "value": "平江县",
      "label": "平江县",
      "code": "414501"
    }, {
      "value": "汨罗市",
      "label": "汨罗市",
      "code": "414403"
    }, {
      "value": "临湘市",
      "label": "临湘市",
      "code": "414313"
    }],
    "value": "岳阳市",
    "label": "岳阳市"
  }, {
    "children": [{
      "value": "武陵区",
      "label": "武陵区",
      "code": "415008"
    }, {
      "value": "鼎城区",
      "label": "鼎城区",
      "code": "415108"
    }, {
      "value": "安乡县",
      "label": "安乡县",
      "code": "415605"
    }, {
      "value": "汉寿县",
      "label": "汉寿县",
      "code": "415908"
    }, {
      "value": "澧县",
      "label": "澧县",
      "code": "415501"
    }, {
      "value": "临澧县",
      "label": "临澧县",
      "code": "415201"
    }, {
      "value": "桃源县",
      "label": "桃源县",
      "code": "415723"
    }, {
      "value": "石门县",
      "label": "石门县",
      "code": "415301"
    }, {
      "value": "津市市",
      "label": "津市市",
      "code": "415401"
    }],
    "value": "常德市",
    "label": "常德市"
  }, {
    "children": [{
      "value": "永定区",
      "label": "永定区",
      "code": "427307"
    }, {
      "value": "武陵源区",
      "label": "武陵源区",
      "code": "427401"
    }, {
      "value": "慈利县",
      "label": "慈利县",
      "code": "427201"
    }, {
      "value": "桑植县",
      "label": "桑植县",
      "code": "427101"
    }],
    "value": "张家界市",
    "label": "张家界市"
  }, {
    "children": [{
      "value": "资阳区",
      "label": "资阳区",
      "code": "413052"
    }, {
      "value": "赫山区",
      "label": "赫山区",
      "code": "413059"
    }, {
      "value": "南县",
      "label": "南县",
      "code": "413221"
    }, {
      "value": "桃江县",
      "label": "桃江县",
      "code": "413405"
    }, {
      "value": "安化县",
      "label": "安化县",
      "code": "413517"
    }, {
      "value": "沅江市",
      "label": "沅江市",
      "code": "413113"
    }],
    "value": "益阳市",
    "label": "益阳市"
  }, {
    "children": [{
      "value": "北湖区",
      "label": "北湖区",
      "code": "423001"
    }, {
      "value": "苏仙区",
      "label": "苏仙区",
      "code": "423037"
    }, {
      "value": "桂阳县",
      "label": "桂阳县",
      "code": "424401"
    }, {
      "value": "宜章县",
      "label": "宜章县",
      "code": "424201"
    }, {
      "value": "永兴县",
      "label": "永兴县",
      "code": "423305"
    }, {
      "value": "嘉禾县",
      "label": "嘉禾县",
      "code": "424504"
    }, {
      "value": "临武县",
      "label": "临武县",
      "code": "424307"
    }, {
      "value": "汝城县",
      "label": "汝城县",
      "code": "424107"
    }, {
      "value": "桂东县",
      "label": "桂东县",
      "code": "423501"
    }, {
      "value": "安仁县",
      "label": "安仁县",
      "code": "423615"
    }, {
      "value": "资兴市",
      "label": "资兴市",
      "code": "423411"
    }],
    "value": "郴州市",
    "label": "郴州市"
  }, {
    "children": [{
      "value": "零陵区",
      "label": "零陵区",
      "code": "425129"
    }, {
      "value": "冷水滩区",
      "label": "冷水滩区",
      "code": "425001"
    }, {
      "value": "祁阳县",
      "label": "祁阳县",
      "code": "426185"
    }, {
      "value": "东安县",
      "label": "东安县",
      "code": "425913"
    }, {
      "value": "双牌县",
      "label": "双牌县",
      "code": "425212"
    }, {
      "value": "道县",
      "label": "道县",
      "code": "425306"
    }, {
      "value": "江永县",
      "label": "江永县",
      "code": "425401"
    }, {
      "value": "宁远县",
      "label": "宁远县",
      "code": "425601"
    }, {
      "value": "蓝山县",
      "label": "蓝山县",
      "code": "425801"
    }, {
      "value": "新田县",
      "label": "新田县",
      "code": "425701"
    }, {
      "value": "江华瑶族自治县",
      "label": "江华瑶族自治县",
      "code": "425501"
    }],
    "value": "永州市",
    "label": "永州市"
  }, {
    "children": [{
      "value": "鹤城区",
      "label": "鹤城区",
      "code": "418001"
    }, {
      "value": "中方县",
      "label": "中方县",
      "code": "418002"
    }, {
      "value": "沅陵县",
      "label": "沅陵县",
      "code": "419601"
    }, {
      "value": "辰溪县",
      "label": "辰溪县",
      "code": "419507"
    }, {
      "value": "溆浦县",
      "label": "溆浦县",
      "code": "419308"
    }, {
      "value": "会同县",
      "label": "会同县",
      "code": "418308"
    }, {
      "value": "麻阳苗族自治县",
      "label": "麻阳苗族自治县",
      "code": "419401"
    }, {
      "value": "新晃侗族自治县",
      "label": "新晃侗族自治县",
      "code": "419201"
    }, {
      "value": "芷江侗族自治县",
      "label": "芷江侗族自治县",
      "code": "419101"
    }, {
      "value": "靖州苗族侗族自治县",
      "label": "靖州苗族侗族自治县",
      "code": "418401"
    }, {
      "value": "通道侗族自治县",
      "label": "通道侗族自治县",
      "code": "418512"
    }, {
      "value": "洪江市",
      "label": "洪江市",
      "code": "418201"
    }],
    "value": "怀化市",
    "label": "怀化市"
  }, {
    "children": [{
      "value": "娄星区",
      "label": "娄星区",
      "code": "417001"
    }, {
      "value": "双峰县",
      "label": "双峰县",
      "code": "417719"
    }, {
      "value": "新化县",
      "label": "新化县",
      "code": "417622"
    }, {
      "value": "冷水江市",
      "label": "冷水江市",
      "code": "417502"
    }, {
      "value": "涟源市",
      "label": "涟源市",
      "code": "417101"
    }],
    "value": "娄底市",
    "label": "娄底市"
  }, {
    "children": [{
      "value": "吉首市",
      "label": "吉首市",
      "code": "416007"
    }, {
      "value": "泸溪县",
      "label": "泸溪县",
      "code": "416117"
    }, {
      "value": "凤凰县",
      "label": "凤凰县",
      "code": "416206"
    }, {
      "value": "花垣县",
      "label": "花垣县",
      "code": "416408"
    }, {
      "value": "保靖县",
      "label": "保靖县",
      "code": "416501"
    }, {
      "value": "古丈县",
      "label": "古丈县",
      "code": "416307"
    }, {
      "value": "永顺县",
      "label": "永顺县",
      "code": "416701"
    }, {
      "value": "龙山县",
      "label": "龙山县",
      "code": "416807"
    }],
    "value": "湘西土家族苗族自治州",
    "label": "湘西土家族苗族自治州"
  }],
  "value": "湖南省",
  "label": "湖南省"
}, {
  "children": [{
    "children": [{
      "value": "荔湾区",
      "label": "荔湾区",
      "code": "510141"
    }, {
      "value": "越秀区",
      "label": "越秀区",
      "code": "510081"
    }, {
      "value": "海珠区",
      "label": "海珠区",
      "code": "510261"
    }, {
      "value": "天河区",
      "label": "天河区",
      "code": "510095"
    }, {
      "value": "白云区",
      "label": "白云区",
      "code": "510431"
    }, {
      "value": "黄埔区",
      "label": "黄埔区",
      "code": "510531"
    }, {
      "value": "番禺区",
      "label": "番禺区",
      "code": "511451"
    }, {
      "value": "花都区",
      "label": "花都区",
      "code": "510851"
    }, {
      "value": "南沙区",
      "label": "南沙区",
      "code": "511458"
    }, {
      "value": "从化区",
      "label": "从化区",
      "code": "510901"
    }, {
      "value": "增城区",
      "label": "增城区",
      "code": "511301"
    }],
    "value": "广州市",
    "label": "广州市"
  }, {
    "children": [{
      "value": "武江区",
      "label": "武江区",
      "code": "512026"
    }, {
      "value": "浈江区",
      "label": "浈江区",
      "code": "512001"
    }, {
      "value": "曲江区",
      "label": "曲江区",
      "code": "512122"
    }, {
      "value": "始兴县",
      "label": "始兴县",
      "code": "512529"
    }, {
      "value": "仁化县",
      "label": "仁化县",
      "code": "512301"
    }, {
      "value": "翁源县",
      "label": "翁源县",
      "code": "512601"
    }, {
      "value": "乳源瑶族自治县",
      "label": "乳源瑶族自治县",
      "code": "512731"
    }, {
      "value": "新丰县",
      "label": "新丰县",
      "code": "511181"
    }, {
      "value": "乐昌市",
      "label": "乐昌市",
      "code": "512229"
    }, {
      "value": "南雄市",
      "label": "南雄市",
      "code": "512427"
    }],
    "value": "韶关市",
    "label": "韶关市"
  }, {
    "children": [{
      "value": "罗湖区",
      "label": "罗湖区",
      "code": "518001"
    }, {
      "value": "福田区",
      "label": "福田区",
      "code": "518034"
    }, {
      "value": "南山区",
      "label": "南山区",
      "code": "518052"
    }, {
      "value": "宝安区",
      "label": "宝安区",
      "code": "518103"
    }, {
      "value": "龙岗区",
      "label": "龙岗区",
      "code": "518117"
    }, {
      "value": "盐田区",
      "label": "盐田区",
      "code": "518081"
    }],
    "value": "深圳市",
    "label": "深圳市"
  }, {
    "children": [{
      "value": "香洲区",
      "label": "香洲区",
      "code": "519001"
    }, {
      "value": "斗门区",
      "label": "斗门区",
      "code": "519101"
    }, {
      "value": "金湾区",
      "label": "金湾区",
      "code": "519091"
    }],
    "value": "珠海市",
    "label": "珠海市"
  }, {
    "children": [{
      "value": "龙湖区",
      "label": "龙湖区",
      "code": "515041"
    }, {
      "value": "金平区",
      "label": "金平区",
      "code": "515061"
    }, {
      "value": "濠江区",
      "label": "濠江区",
      "code": "515073"
    }, {
      "value": "潮阳区",
      "label": "潮阳区",
      "code": "515101"
    }, {
      "value": "潮南区",
      "label": "潮南区",
      "code": "515152"
    }, {
      "value": "澄海区",
      "label": "澄海区",
      "code": "515821"
    }, {
      "value": "南澳县",
      "label": "南澳县",
      "code": "515901"
    }],
    "value": "汕头市",
    "label": "汕头市"
  }, {
    "children": [{
      "value": "禅城区",
      "label": "禅城区",
      "code": "528051"
    }, {
      "value": "南海区",
      "label": "南海区",
      "code": "528241"
    }, {
      "value": "顺德区",
      "label": "顺德区",
      "code": "528303"
    }, {
      "value": "三水区",
      "label": "三水区",
      "code": "528139"
    }, {
      "value": "高明区",
      "label": "高明区",
      "code": "528501"
    }],
    "value": "佛山市",
    "label": "佛山市"
  }, {
    "children": [{
      "value": "蓬江区",
      "label": "蓬江区",
      "code": "529095"
    }, {
      "value": "江海区",
      "label": "江海区",
      "code": "529081"
    }, {
      "value": "新会区",
      "label": "新会区",
      "code": "529159"
    }, {
      "value": "台山市",
      "label": "台山市",
      "code": "529211"
    }, {
      "value": "开平市",
      "label": "开平市",
      "code": "529321"
    }, {
      "value": "鹤山市",
      "label": "鹤山市",
      "code": "529201"
    }, {
      "value": "恩平市",
      "label": "恩平市",
      "code": "529467"
    }],
    "value": "江门市",
    "label": "江门市"
  }, {
    "children": [{
      "value": "赤坎区",
      "label": "赤坎区",
      "code": "524039"
    }, {
      "value": "霞山区",
      "label": "霞山区",
      "code": "524013"
    }, {
      "value": "坡头区",
      "label": "坡头区",
      "code": "524051"
    }, {
      "value": "麻章区",
      "label": "麻章区",
      "code": "524005"
    }, {
      "value": "遂溪县",
      "label": "遂溪县",
      "code": "524364"
    }, {
      "value": "徐闻县",
      "label": "徐闻县",
      "code": "524101"
    }, {
      "value": "廉江市",
      "label": "廉江市",
      "code": "524458"
    }, {
      "value": "雷州市",
      "label": "雷州市",
      "code": "524254"
    }, {
      "value": "吴川市",
      "label": "吴川市",
      "code": "524573"
    }],
    "value": "湛江市",
    "label": "湛江市"
  }, {
    "children": [{
      "value": "茂南区",
      "label": "茂南区",
      "code": "525011"
    }, {
      "value": "电白区",
      "label": "电白区",
      "code": "525401"
    }, {
      "value": "高州市",
      "label": "高州市",
      "code": "525201"
    }, {
      "value": "化州市",
      "label": "化州市",
      "code": "525136"
    }, {
      "value": "信宜市",
      "label": "信宜市",
      "code": "525327"
    }],
    "value": "茂名市",
    "label": "茂名市"
  }, {
    "children": [{
      "value": "端州区",
      "label": "端州区",
      "code": "526041"
    }, {
      "value": "鼎湖区",
      "label": "鼎湖区",
      "code": "526074"
    }, {
      "value": "高要区",
      "label": "高要区",
      "code": "526101"
    }, {
      "value": "广宁县",
      "label": "广宁县",
      "code": "526341"
    }, {
      "value": "怀集县",
      "label": "怀集县",
      "code": "526401"
    }, {
      "value": "封开县",
      "label": "封开县",
      "code": "526501"
    }, {
      "value": "德庆县",
      "label": "德庆县",
      "code": "526601"
    }, {
      "value": "四会市",
      "label": "四会市",
      "code": "526246"
    }],
    "value": "肇庆市",
    "label": "肇庆市"
  }, {
    "children": [{
      "value": "惠城区",
      "label": "惠城区",
      "code": "516002"
    }, {
      "value": "惠阳区",
      "label": "惠阳区",
      "code": "516227"
    }, {
      "value": "博罗县",
      "label": "博罗县",
      "code": "516121"
    }, {
      "value": "惠东县",
      "label": "惠东县",
      "code": "516343"
    }, {
      "value": "龙门县",
      "label": "龙门县",
      "code": "516801"
    }, {
      "value": "大亚湾区",
      "label": "大亚湾区",
      "code": "516081"
    }],
    "value": "惠州市",
    "label": "惠州市"
  }, {
    "children": [{
      "value": "梅江区",
      "label": "梅江区",
      "code": "514031"
    }, {
      "value": "梅县区",
      "label": "梅县区",
      "code": "514701"
    }, {
      "value": "大埔县",
      "label": "大埔县",
      "code": "514235"
    }, {
      "value": "丰顺县",
      "label": "丰顺县",
      "code": "514376"
    }, {
      "value": "五华县",
      "label": "五华县",
      "code": "514439"
    }, {
      "value": "平远县",
      "label": "平远县",
      "code": "514649"
    }, {
      "value": "蕉岭县",
      "label": "蕉岭县",
      "code": "514175"
    }, {
      "value": "兴宁市",
      "label": "兴宁市",
      "code": "514577"
    }],
    "value": "梅州市",
    "label": "梅州市"
  }, {
    "children": [{
      "value": "海丰县",
      "label": "海丰县",
      "code": "516466"
    }, {
      "value": "陆河县",
      "label": "陆河县",
      "code": "516721"
    }, {
      "value": "陆丰市",
      "label": "陆丰市",
      "code": "516513"
    }],
    "value": "汕尾市",
    "label": "汕尾市"
  }, {
    "children": [{
      "value": "源城区",
      "label": "源城区",
      "code": "517001"
    }, {
      "value": "紫金县",
      "label": "紫金县",
      "code": "517445"
    }, {
      "value": "龙川县",
      "label": "龙川县",
      "code": "517376"
    }, {
      "value": "连平县",
      "label": "连平县",
      "code": "517139"
    }, {
      "value": "和平县",
      "label": "和平县",
      "code": "517258"
    }, {
      "value": "东源县",
      "label": "东源县",
      "code": "517567"
    }],
    "value": "河源市",
    "label": "河源市"
  }, {
    "children": [{
      "value": "江城区",
      "label": "江城区",
      "code": "529501"
    }, {
      "value": "阳东区",
      "label": "阳东区",
      "code": "529901"
    }, {
      "value": "阳西县",
      "label": "阳西县",
      "code": "529801"
    }, {
      "value": "阳春市",
      "label": "阳春市",
      "code": "529601"
    }],
    "value": "阳江市",
    "label": "阳江市"
  }, {
    "children": [{
      "value": "清城区",
      "label": "清城区",
      "code": "511543"
    }, {
      "value": "清新区",
      "label": "清新区",
      "code": "511801"
    }, {
      "value": "佛冈县",
      "label": "佛冈县",
      "code": "511601"
    }, {
      "value": "阳山县",
      "label": "阳山县",
      "code": "513123"
    }, {
      "value": "连山壮族瑶族自治县",
      "label": "连山壮族瑶族自治县",
      "code": "513201"
    }, {
      "value": "连南瑶族自治县",
      "label": "连南瑶族自治县",
      "code": "513301"
    }, {
      "value": "英德市",
      "label": "英德市",
      "code": "513001"
    }, {
      "value": "连州市",
      "label": "连州市",
      "code": "513301"
    }],
    "value": "清远市",
    "label": "清远市"
  }, {
    "children": [{
      "value": "莞城街道",
      "label": "莞城街道",
      "code": "523001"
    }, {
      "value": "南城街道",
      "label": "南城街道",
      "code": "523073"
    }, {
      "value": "东城街道",
      "label": "东城街道",
      "code": "523122"
    }, {
      "value": "万江街道",
      "label": "万江街道",
      "code": "523039"
    }, {
      "value": "石龙镇",
      "label": "石龙镇",
      "code": "523326"
    }, {
      "value": "石排镇",
      "label": "石排镇",
      "code": "523331"
    }, {
      "value": "茶山镇",
      "label": "茶山镇",
      "code": "523378"
    }, {
      "value": "企石镇",
      "label": "企石镇",
      "code": "523551"
    }, {
      "value": "桥头镇",
      "label": "桥头镇",
      "code": "523539"
    }, {
      "value": "东坑镇",
      "label": "东坑镇",
      "code": "523451"
    }, {
      "value": "横沥镇",
      "label": "横沥镇",
      "code": "523461"
    }, {
      "value": "常平镇",
      "label": "常平镇",
      "code": "523571"
    }, {
      "value": "虎门镇",
      "label": "虎门镇",
      "code": "523899"
    }, {
      "value": "长安镇",
      "label": "长安镇",
      "code": "523843"
    }, {
      "value": "沙田镇",
      "label": "沙田镇",
      "code": "523981"
    }, {
      "value": "厚街镇",
      "label": "厚街镇",
      "code": "523961"
    }, {
      "value": "寮步镇",
      "label": "寮步镇",
      "code": "523431"
    }, {
      "value": "大岭山镇",
      "label": "大岭山镇",
      "code": "523820"
    }, {
      "value": "大朗镇",
      "label": "大朗镇",
      "code": "523771"
    }, {
      "value": "黄江镇",
      "label": "黄江镇",
      "code": "523751"
    }, {
      "value": "樟木头镇",
      "label": "樟木头镇",
      "code": "523622"
    }, {
      "value": "谢岗镇",
      "label": "谢岗镇",
      "code": "523591"
    }, {
      "value": "塘厦镇",
      "label": "塘厦镇",
      "code": "523711"
    }, {
      "value": "清溪镇",
      "label": "清溪镇",
      "code": "523661"
    }, {
      "value": "凤岗镇",
      "label": "凤岗镇",
      "code": "523691"
    }, {
      "value": "麻涌镇",
      "label": "麻涌镇",
      "code": "523133"
    }, {
      "value": "中堂镇",
      "label": "中堂镇",
      "code": "523221"
    }, {
      "value": "高埗镇",
      "label": "高埗镇",
      "code": "523275"
    }, {
      "value": "石碣镇",
      "label": "石碣镇",
      "code": "523291"
    }, {
      "value": "望牛墩镇",
      "label": "望牛墩镇",
      "code": "523208"
    }, {
      "value": "洪梅镇",
      "label": "洪梅镇",
      "code": "523161"
    }, {
      "value": "道滘镇",
      "label": "道滘镇",
      "code": "523171"
    }],
    "value": "东莞市",
    "label": "东莞市"
  }, {
    "children": [{
      "value": "石岐街道",
      "label": "石岐街道",
      "code": "528499"
    }, {
      "value": "东区街道",
      "label": "东区街道",
      "code": "528403"
    }, {
      "value": "西区街道",
      "label": "西区街道",
      "code": "528401"
    }, {
      "value": "南区街道",
      "label": "南区街道",
      "code": "528455"
    }, {
      "value": "五桂山街道",
      "label": "五桂山街道",
      "code": "528458"
    }, {
      "value": "火炬高技术产业开发区",
      "label": "火炬高技术产业开发区",
      "code": "528437"
    }, {
      "value": "黄圃镇",
      "label": "黄圃镇",
      "code": "528429"
    }, {
      "value": "南头镇",
      "label": "南头镇",
      "code": "528427"
    }, {
      "value": "东凤镇",
      "label": "东凤镇",
      "code": "528425"
    }, {
      "value": "阜沙镇",
      "label": "阜沙镇",
      "code": "528434"
    }, {
      "value": "小榄镇",
      "label": "小榄镇",
      "code": "528415"
    }, {
      "value": "东升镇",
      "label": "东升镇",
      "code": "528414"
    }, {
      "value": "古镇镇",
      "label": "古镇镇",
      "code": "5284321"
    }, {
      "value": "横栏镇",
      "label": "横栏镇",
      "code": "528478"
    }, {
      "value": "三角镇",
      "label": "三角镇",
      "code": "528445"
    }, {
      "value": "民众镇",
      "label": "民众镇",
      "code": "528437"
    }, {
      "value": "南朗镇",
      "label": "南朗镇",
      "code": "528449"
    }, {
      "value": "港口镇",
      "label": "港口镇",
      "code": "528447"
    }, {
      "value": "大涌镇",
      "label": "大涌镇",
      "code": "528476"
    }, {
      "value": "沙溪镇",
      "label": "沙溪镇",
      "code": "528471"
    }, {
      "value": "三乡镇",
      "label": "三乡镇",
      "code": "528463"
    }, {
      "value": "板芙镇",
      "label": "板芙镇",
      "code": "528459"
    }, {
      "value": "神湾镇",
      "label": "神湾镇",
      "code": "528462"
    }, {
      "value": "坦洲镇",
      "label": "坦洲镇",
      "code": "528467"
    }],
    "value": "中山市",
    "label": "中山市"
  }, {
    "children": [{
      "value": "湘桥区",
      "label": "湘桥区",
      "code": "521021"
    }, {
      "value": "潮安区",
      "label": "潮安区",
      "code": "521031"
    }, {
      "value": "饶平县",
      "label": "饶平县",
      "code": "515726"
    }],
    "value": "潮州市",
    "label": "潮州市"
  }, {
    "children": [{
      "value": "榕城区",
      "label": "榕城区",
      "code": "522001"
    }, {
      "value": "揭东区",
      "label": "揭东区",
      "code": "522031"
    }, {
      "value": "揭西县",
      "label": "揭西县",
      "code": "515401"
    }, {
      "value": "惠来县",
      "label": "惠来县",
      "code": "515201"
    }, {
      "value": "普宁市",
      "label": "普宁市",
      "code": "515321"
    }],
    "value": "揭阳市",
    "label": "揭阳市"
  }, {
    "children": [{
      "value": "云城区",
      "label": "云城区",
      "code": "527301"
    }, {
      "value": "云安区",
      "label": "云安区",
      "code": "527501"
    }, {
      "value": "新兴县",
      "label": "新兴县",
      "code": "527435"
    }, {
      "value": "郁南县",
      "label": "郁南县",
      "code": "527135"
    }, {
      "value": "罗定市",
      "label": "罗定市",
      "code": "527224"
    }],
    "value": "云浮市",
    "label": "云浮市"
  }],
  "value": "广东省",
  "label": "广东省"
}, {
  "children": [{
    "children": [{
      "value": "兴宁区",
      "label": "兴宁区",
      "code": "530001"
    }, {
      "value": "青秀区",
      "label": "青秀区",
      "code": "530021"
    }, {
      "value": "江南区",
      "label": "江南区",
      "code": "530031"
    }, {
      "value": "西乡塘区",
      "label": "西乡塘区",
      "code": "530003"
    }, {
      "value": "良庆区",
      "label": "良庆区",
      "code": "530221"
    }, {
      "value": "邕宁区",
      "label": "邕宁区",
      "code": "530201"
    }, {
      "value": "武鸣区",
      "label": "武鸣区",
      "code": "530101"
    }, {
      "value": "隆安县",
      "label": "隆安县",
      "code": "532712"
    }, {
      "value": "马山县",
      "label": "马山县",
      "code": "530613"
    }, {
      "value": "上林县",
      "label": "上林县",
      "code": "530512"
    }, {
      "value": "宾阳县",
      "label": "宾阳县",
      "code": "530401"
    }, {
      "value": "横县",
      "label": "横县",
      "code": "530314"
    }],
    "value": "南宁市",
    "label": "南宁市"
  }, {
    "children": [{
      "value": "城中区",
      "label": "城中区",
      "code": "545001"
    }, {
      "value": "鱼峰区",
      "label": "鱼峰区",
      "code": "545005"
    }, {
      "value": "柳南区",
      "label": "柳南区",
      "code": "545007"
    }, {
      "value": "柳北区",
      "label": "柳北区",
      "code": "545002"
    }, {
      "value": "柳江县",
      "label": "柳江县",
      "code": "545101"
    }, {
      "value": "柳城县",
      "label": "柳城县",
      "code": "545201"
    }, {
      "value": "鹿寨县",
      "label": "鹿寨县",
      "code": "545606"
    }, {
      "value": "融安县",
      "label": "融安县",
      "code": "545412"
    }, {
      "value": "融水苗族自治县",
      "label": "融水苗族自治县",
      "code": "545301"
    }, {
      "value": "三江侗族自治县",
      "label": "三江侗族自治县",
      "code": "545513"
    }],
    "value": "柳州市",
    "label": "柳州市"
  }, {
    "children": [{
      "value": "秀峰区",
      "label": "秀峰区",
      "code": "541001"
    }, {
      "value": "叠彩区",
      "label": "叠彩区",
      "code": "541001"
    }, {
      "value": "象山区",
      "label": "象山区",
      "code": "541002"
    }, {
      "value": "七星区",
      "label": "七星区",
      "code": "541004"
    }, {
      "value": "雁山区",
      "label": "雁山区",
      "code": "541006"
    }, {
      "value": "临桂区",
      "label": "临桂区",
      "code": "541199"
    }, {
      "value": "阳朔县",
      "label": "阳朔县",
      "code": "541901"
    }, {
      "value": "灵川县",
      "label": "灵川县",
      "code": "541201"
    }, {
      "value": "全州县",
      "label": "全州县",
      "code": "541501"
    }, {
      "value": "兴安县",
      "label": "兴安县",
      "code": "541301"
    }, {
      "value": "永福县",
      "label": "永福县",
      "code": "541801"
    }, {
      "value": "灌阳县",
      "label": "灌阳县",
      "code": "541601"
    }, {
      "value": "龙胜各族自治县",
      "label": "龙胜各族自治县",
      "code": "541701"
    }, {
      "value": "资源县",
      "label": "资源县",
      "code": "541401"
    }, {
      "value": "平乐县",
      "label": "平乐县",
      "code": "542406"
    }, {
      "value": "荔浦县",
      "label": "荔浦县",
      "code": "546601"
    }, {
      "value": "恭城瑶族自治县",
      "label": "恭城瑶族自治县",
      "code": "542501"
    }],
    "value": "桂林市",
    "label": "桂林市"
  }, {
    "children": [{
      "value": "万秀区",
      "label": "万秀区",
      "code": "543001"
    }, {
      "value": "长洲区",
      "label": "长洲区",
      "code": "543003"
    }, {
      "value": "龙圩区",
      "label": "龙圩区",
      "code": "543004"
    }, {
      "value": "苍梧县",
      "label": "苍梧县",
      "code": "543101"
    }, {
      "value": "藤县",
      "label": "藤县",
      "code": "543311"
    }, {
      "value": "蒙山县",
      "label": "蒙山县",
      "code": "546701"
    }, {
      "value": "岑溪市",
      "label": "岑溪市",
      "code": "543201"
    }],
    "value": "梧州市",
    "label": "梧州市"
  }, {
    "children": [{
      "value": "海城区",
      "label": "海城区",
      "code": "536001"
    }, {
      "value": "银海区",
      "label": "银海区",
      "code": "536004"
    }, {
      "value": "铁山港区",
      "label": "铁山港区",
      "code": "536017"
    }, {
      "value": "合浦县",
      "label": "合浦县",
      "code": "536101"
    }],
    "value": "北海市",
    "label": "北海市"
  }, {
    "children": [{
      "value": "港口区",
      "label": "港口区",
      "code": "538001"
    }, {
      "value": "防城区",
      "label": "防城区",
      "code": "538021"
    }, {
      "value": "上思县",
      "label": "上思县",
      "code": "535501"
    }, {
      "value": "东兴市",
      "label": "东兴市",
      "code": "538101"
    }],
    "value": "防城港市",
    "label": "防城港市"
  }, {
    "children": [{
      "value": "钦南区",
      "label": "钦南区",
      "code": "535015"
    }, {
      "value": "钦北区",
      "label": "钦北区",
      "code": "535022"
    }, {
      "value": "灵山县",
      "label": "灵山县",
      "code": "535401"
    }, {
      "value": "浦北县",
      "label": "浦北县",
      "code": "535301"
    }],
    "value": "钦州市",
    "label": "钦州市"
  }, {
    "children": [{
      "value": "港北区",
      "label": "港北区",
      "code": "537104"
    }, {
      "value": "港南区",
      "label": "港南区",
      "code": "537131"
    }, {
      "value": "覃塘区",
      "label": "覃塘区",
      "code": "537121"
    }, {
      "value": "平南县",
      "label": "平南县",
      "code": "537303"
    }, {
      "value": "桂平市",
      "label": "桂平市",
      "code": "537201"
    }],
    "value": "贵港市",
    "label": "贵港市"
  }, {
    "children": [{
      "value": "玉州区",
      "label": "玉州区",
      "code": "537001"
    }, {
      "value": "福绵区",
      "label": "福绵区",
      "code": "537001"
    }, {
      "value": "容县",
      "label": "容县",
      "code": "537501"
    }, {
      "value": "陆川县",
      "label": "陆川县",
      "code": "537701"
    }, {
      "value": "博白县",
      "label": "博白县",
      "code": "537605"
    }, {
      "value": "兴业县",
      "label": "兴业县",
      "code": "537816"
    }, {
      "value": "北流市",
      "label": "北流市",
      "code": "537401"
    }],
    "value": "玉林市",
    "label": "玉林市"
  }, {
    "children": [{
      "value": "右江区",
      "label": "右江区",
      "code": "533013"
    }, {
      "value": "田阳县",
      "label": "田阳县",
      "code": "533601"
    }, {
      "value": "田东县",
      "label": "田东县",
      "code": "531501"
    }, {
      "value": "平果县",
      "label": "平果县",
      "code": "531401"
    }, {
      "value": "德保县",
      "label": "德保县",
      "code": "533701"
    }, {
      "value": "那坡县",
      "label": "那坡县",
      "code": "533901"
    }, {
      "value": "凌云县",
      "label": "凌云县",
      "code": "533107"
    }, {
      "value": "乐业县",
      "label": "乐业县",
      "code": "533201"
    }, {
      "value": "田林县",
      "label": "田林县",
      "code": "533301"
    }, {
      "value": "西林县",
      "label": "西林县",
      "code": "533501"
    }, {
      "value": "隆林各族自治县",
      "label": "隆林各族自治县",
      "code": "533401"
    }, {
      "value": "靖西市",
      "label": "靖西市",
      "code": "533801"
    }],
    "value": "百色市",
    "label": "百色市"
  }, {
    "children": [{
      "value": "八步区",
      "label": "八步区",
      "code": "542828"
    }, {
      "value": "平桂管理区",
      "label": "平桂管理区",
      "code": "542827"
    }, {
      "value": "昭平县",
      "label": "昭平县",
      "code": "546801"
    }, {
      "value": "钟山县",
      "label": "钟山县",
      "code": "542601"
    }, {
      "value": "富川瑶族自治县",
      "label": "富川瑶族自治县",
      "code": "542701"
    }],
    "value": "贺州市",
    "label": "贺州市"
  }, {
    "children": [{
      "value": "金城江区",
      "label": "金城江区",
      "code": "547009"
    }, {
      "value": "南丹县",
      "label": "南丹县",
      "code": "547201"
    }, {
      "value": "天峨县",
      "label": "天峨县",
      "code": "547301"
    }, {
      "value": "凤山县",
      "label": "凤山县",
      "code": "547601"
    }, {
      "value": "东兰县",
      "label": "东兰县",
      "code": "547401"
    }, {
      "value": "罗城仫佬族自治县",
      "label": "罗城仫佬族自治县",
      "code": "546401"
    }, {
      "value": "环江毛南族自治县",
      "label": "环江毛南族自治县",
      "code": "547101"
    }, {
      "value": "巴马瑶族自治县",
      "label": "巴马瑶族自治县",
      "code": "547512"
    }, {
      "value": "都安瑶族自治县",
      "label": "都安瑶族自治县",
      "code": "530701"
    }, {
      "value": "大化瑶族自治县",
      "label": "大化瑶族自治县",
      "code": "530801"
    }, {
      "value": "宜州市",
      "label": "宜州市",
      "code": "546301"
    }],
    "value": "河池市",
    "label": "河池市"
  }, {
    "children": [{
      "value": "兴宾区",
      "label": "兴宾区",
      "code": "546138"
    }, {
      "value": "忻城县",
      "label": "忻城县",
      "code": "546211"
    }, {
      "value": "象州县",
      "label": "象州县",
      "code": "545803"
    }, {
      "value": "武宣县",
      "label": "武宣县",
      "code": "545901"
    }, {
      "value": "金秀瑶族自治县",
      "label": "金秀瑶族自治县",
      "code": "545709"
    }, {
      "value": "合山市",
      "label": "合山市",
      "code": "546501"
    }],
    "value": "来宾市",
    "label": "来宾市"
  }, {
    "children": [{
      "value": "江洲区",
      "label": "江洲区",
      "code": "532201"
    }, {
      "value": "扶绥县",
      "label": "扶绥县",
      "code": "532114"
    }, {
      "value": "宁明县",
      "label": "宁明县",
      "code": "532509"
    }, {
      "value": "龙州县",
      "label": "龙州县",
      "code": "532401"
    }, {
      "value": "大新县",
      "label": "大新县",
      "code": "532302"
    }, {
      "value": "天等县",
      "label": "天等县",
      "code": "532811"
    }, {
      "value": "凭祥市",
      "label": "凭祥市",
      "code": "532601"
    }],
    "value": "崇左市",
    "label": "崇左市"
  }],
  "value": "广西壮族自治区",
  "label": "广西壮族自治区"
}, {
  "children": [{
    "children": [{
      "value": "秀英区",
      "label": "秀英区",
      "code": "571157"
    }, {
      "value": "龙华区",
      "label": "龙华区",
      "code": "571153"
    }, {
      "value": "琼山区",
      "label": "琼山区",
      "code": "571101"
    }, {
      "value": "美兰区",
      "label": "美兰区",
      "code": "570203"
    }],
    "value": "海口市",
    "label": "海口市"
  }, {
    "children": [{
      "value": "海棠区",
      "label": "海棠区",
      "code": "572013"
    }, {
      "value": "吉阳区",
      "label": "吉阳区",
      "code": "572099"
    }, {
      "value": "天涯区",
      "label": "天涯区",
      "code": "572029"
    }, {
      "value": "崖州区",
      "label": "崖州区",
      "code": "572024"
    }],
    "value": "三亚市",
    "label": "三亚市"
  }, {
    "children": [{
      "value": "西沙群岛",
      "label": "西沙群岛",
      "code": "573199"
    }, {
      "value": "南沙群岛",
      "label": "南沙群岛",
      "code": "573199"
    }, {
      "value": "中沙群岛",
      "label": "中沙群岛",
      "code": "573199"
    }],
    "value": "三沙市",
    "label": "三沙市"
  }, {
    "children": [{
      "value": "那大镇",
      "label": "那大镇",
      "code": "571799"
    }, {
      "value": "和庆镇",
      "label": "和庆镇",
      "code": "571721"
    }, {
      "value": "南丰镇",
      "label": "南丰镇",
      "code": "571724"
    }, {
      "value": "大成镇",
      "label": "大成镇",
      "code": "571736"
    }, {
      "value": "雅星镇",
      "label": "雅星镇",
      "code": "571729"
    }, {
      "value": "兰洋镇",
      "label": "兰洋镇",
      "code": "571722"
    }, {
      "value": "光村镇",
      "label": "光村镇",
      "code": "571752"
    }, {
      "value": "木棠镇",
      "label": "木棠镇",
      "code": "571746"
    }, {
      "value": "海头镇",
      "label": "海头镇",
      "code": "571732"
    }, {
      "value": "峨蔓镇",
      "label": "峨蔓镇",
      "code": "571745"
    }, {
      "value": "三都镇",
      "label": "三都镇",
      "code": "571744"
    }, {
      "value": "王五镇",
      "label": "王五镇",
      "code": "571739"
    }, {
      "value": "白马井镇",
      "label": "白马井镇",
      "code": "571742"
    }, {
      "value": "中和镇",
      "label": "中和镇",
      "code": "571747"
    }, {
      "value": "排浦镇",
      "label": "排浦镇",
      "code": "571741"
    }, {
      "value": "东成镇",
      "label": "东成镇",
      "code": "571763"
    }, {
      "value": "新州镇",
      "label": "新州镇",
      "code": "571749"
    }],
    "value": "儋州市",
    "label": "儋州市"
  }, {
    "children": [{
      "value": "五指山市",
      "label": "五指山市",
      "code": "572213"
    }, {
      "value": "琼海市",
      "label": "琼海市",
      "code": "571433"
    }, {
      "value": "文昌市",
      "label": "文昌市",
      "code": "571325"
    }, {
      "value": "万宁市",
      "label": "万宁市",
      "code": "571525"
    }, {
      "value": "东方市",
      "label": "东方市",
      "code": "572622"
    }, {
      "value": "定安县",
      "label": "定安县",
      "code": "571221"
    }, {
      "value": "屯昌县",
      "label": "屯昌县",
      "code": "571623"
    }, {
      "value": "澄迈县",
      "label": "澄迈县",
      "code": "571932"
    }, {
      "value": "临高县",
      "label": "临高县",
      "code": "571837"
    }, {
      "value": "白沙黎族自治县",
      "label": "白沙黎族自治县",
      "code": "572818"
    }, {
      "value": "昌江黎族自治县",
      "label": "昌江黎族自治县",
      "code": "572725"
    }, {
      "value": "乐东黎族自治县",
      "label": "乐东黎族自治县",
      "code": "572534"
    }, {
      "value": "陵水黎族自治县",
      "label": "陵水黎族自治县",
      "code": "572401"
    }, {
      "value": "保亭黎族苗族自治县",
      "label": "保亭黎族苗族自治县",
      "code": "572313"
    }, {
      "value": "琼中黎族苗族自治县",
      "label": "琼中黎族苗族自治县",
      "code": "572929"
    }],
    "value": "省直辖县",
    "label": "省直辖县"
  }],
  "value": "海南省",
  "label": "海南省"
}, {
  "children": [{
    "children": [{
      "value": "万州区",
      "label": "万州区",
      "code": "404041"
    }, {
      "value": "涪陵区",
      "label": "涪陵区",
      "code": "408001"
    }, {
      "value": "渝中区",
      "label": "渝中区",
      "code": "400013"
    }, {
      "value": "大渡口区",
      "label": "大渡口区",
      "code": "400084"
    }, {
      "value": "江北区",
      "label": "江北区",
      "code": "400021"
    }, {
      "value": "沙坪坝区",
      "label": "沙坪坝区",
      "code": "400031"
    }, {
      "value": "九龙坡区",
      "label": "九龙坡区",
      "code": "400039"
    }, {
      "value": "南岸区",
      "label": "南岸区",
      "code": "400061"
    }, {
      "value": "北碚区",
      "label": "北碚区",
      "code": "400715"
    }, {
      "value": "綦江区",
      "label": "綦江区",
      "code": "400801"
    }, {
      "value": "大足区",
      "label": "大足区",
      "code": "400901"
    }, {
      "value": "渝北区",
      "label": "渝北区",
      "code": "401121"
    }, {
      "value": "巴南区",
      "label": "巴南区",
      "code": "401349"
    }, {
      "value": "黔江区",
      "label": "黔江区",
      "code": "409001"
    }, {
      "value": "长寿区",
      "label": "长寿区",
      "code": "401221"
    }, {
      "value": "江津区",
      "label": "江津区",
      "code": "402283"
    }, {
      "value": "合川区",
      "label": "合川区",
      "code": "401519"
    }, {
      "value": "永川区",
      "label": "永川区",
      "code": "402192"
    }, {
      "value": "南川区",
      "label": "南川区",
      "code": "408401"
    }, {
      "value": "璧山区",
      "label": "璧山区",
      "code": "402761"
    }, {
      "value": "铜梁区",
      "label": "铜梁区",
      "code": "402561"
    }, {
      "value": "潼南区",
      "label": "潼南区",
      "code": "402661"
    }, {
      "value": "荣昌区",
      "label": "荣昌区",
      "code": "402461"
    }],
    "value": "市辖区",
    "label": "市辖区"
  }, {
    "children": [{
      "value": "梁平县",
      "label": "梁平县",
      "code": "405218"
    }, {
      "value": "城口县",
      "label": "城口县",
      "code": "405901"
    }, {
      "value": "丰都县",
      "label": "丰都县",
      "code": "408201"
    }, {
      "value": "垫江县",
      "label": "垫江县",
      "code": "408322"
    }, {
      "value": "武隆县",
      "label": "武隆县",
      "code": "408538"
    }, {
      "value": "忠县",
      "label": "忠县",
      "code": "404301"
    }, {
      "value": "开县",
      "label": "开县",
      "code": "405426"
    }, {
      "value": "云阳县",
      "label": "云阳县",
      "code": "404508"
    }, {
      "value": "奉节县",
      "label": "奉节县",
      "code": "404611"
    }, {
      "value": "巫山县",
      "label": "巫山县",
      "code": "404706"
    }, {
      "value": "巫溪县",
      "label": "巫溪县",
      "code": "405804"
    }, {
      "value": "石柱土家族自治县",
      "label": "石柱土家族自治县",
      "code": "409101"
    }, {
      "value": "秀山土家族苗族自治县",
      "label": "秀山土家族苗族自治县",
      "code": "409901"
    }, {
      "value": "酉阳土家族苗族自治县",
      "label": "酉阳土家族苗族自治县",
      "code": "409811"
    }, {
      "value": "彭水苗族土家族自治县",
      "label": "彭水苗族土家族自治县",
      "code": "409601"
    }],
    "value": "辖县",
    "label": "辖县"
  }],
  "value": "重庆市",
  "label": "重庆市"
}, {
  "children": [{
    "children": [{
      "value": "锦江区",
      "label": "锦江区",
      "code": "610021"
    }, {
      "value": "青羊区",
      "label": "青羊区",
      "code": "610015"
    }, {
      "value": "金牛区",
      "label": "金牛区",
      "code": "610031"
    }, {
      "value": "武侯区",
      "label": "武侯区",
      "code": "610041"
    }, {
      "value": "成华区",
      "label": "成华区",
      "code": "610021"
    }, {
      "value": "龙泉驿区",
      "label": "龙泉驿区",
      "code": "610101"
    }, {
      "value": "青白江区",
      "label": "青白江区",
      "code": "610301"
    }, {
      "value": "新都区",
      "label": "新都区",
      "code": "610501"
    }, {
      "value": "温江区",
      "label": "温江区",
      "code": "611131"
    }, {
      "value": "双流区",
      "label": "双流区",
      "code": "610201"
    }, {
      "value": "金堂县",
      "label": "金堂县",
      "code": "610406"
    }, {
      "value": "郫县",
      "label": "郫县",
      "code": "611731"
    }, {
      "value": "大邑县",
      "label": "大邑县",
      "code": "611331"
    }, {
      "value": "蒲江县",
      "label": "蒲江县",
      "code": "611631"
    }, {
      "value": "新津县",
      "label": "新津县",
      "code": "611438"
    }, {
      "value": "都江堰市",
      "label": "都江堰市",
      "code": "611831"
    }, {
      "value": "彭州市",
      "label": "彭州市",
      "code": "611933"
    }, {
      "value": "邛崃市",
      "label": "邛崃市",
      "code": "611542"
    }, {
      "value": "崇州市",
      "label": "崇州市",
      "code": "611231"
    }],
    "value": "成都市",
    "label": "成都市"
  }, {
    "children": [{
      "value": "自流井区",
      "label": "自流井区",
      "code": "643001"
    }, {
      "value": "贡井区",
      "label": "贡井区",
      "code": "643021"
    }, {
      "value": "大安区",
      "label": "大安区",
      "code": "643011"
    }, {
      "value": "沿滩区",
      "label": "沿滩区",
      "code": "643031"
    }, {
      "value": "荣县",
      "label": "荣县",
      "code": "643101"
    }, {
      "value": "富顺县",
      "label": "富顺县",
      "code": "643201"
    }],
    "value": "自贡市",
    "label": "自贡市"
  }, {
    "children": [{
      "value": "东区",
      "label": "东区",
      "code": "617001"
    }, {
      "value": "西区",
      "label": "西区",
      "code": "617017"
    }, {
      "value": "仁和区",
      "label": "仁和区",
      "code": "617061"
    }, {
      "value": "米易县",
      "label": "米易县",
      "code": "617201"
    }, {
      "value": "盐边县",
      "label": "盐边县",
      "code": "617101"
    }],
    "value": "攀枝花市",
    "label": "攀枝花市"
  }, {
    "children": [{
      "value": "江阳区",
      "label": "江阳区",
      "code": "646009"
    }, {
      "value": "纳溪区",
      "label": "纳溪区",
      "code": "646301"
    }, {
      "value": "龙马潭区",
      "label": "龙马潭区",
      "code": "646606"
    }, {
      "value": "泸县",
      "label": "泸县",
      "code": "646107"
    }, {
      "value": "合江县",
      "label": "合江县",
      "code": "646205"
    }, {
      "value": "叙永县",
      "label": "叙永县",
      "code": "646418"
    }, {
      "value": "古蔺县",
      "label": "古蔺县",
      "code": "646524"
    }],
    "value": "泸州市",
    "label": "泸州市"
  }, {
    "children": [{
      "value": "旌阳区",
      "label": "旌阳区",
      "code": "618006"
    }, {
      "value": "中江县",
      "label": "中江县",
      "code": "618108"
    }, {
      "value": "罗江县",
      "label": "罗江县",
      "code": "618507"
    }, {
      "value": "广汉市",
      "label": "广汉市",
      "code": "618301"
    }, {
      "value": "什邡市",
      "label": "什邡市",
      "code": "618401"
    }, {
      "value": "绵竹市",
      "label": "绵竹市",
      "code": "618209"
    }],
    "value": "德阳市",
    "label": "德阳市"
  }, {
    "children": [{
      "value": "涪城区",
      "label": "涪城区",
      "code": "621001"
    }, {
      "value": "游仙区",
      "label": "游仙区",
      "code": "621001"
    }, {
      "value": "三台县",
      "label": "三台县",
      "code": "621109"
    }, {
      "value": "盐亭县",
      "label": "盐亭县",
      "code": "621601"
    }, {
      "value": "安县",
      "label": "安县",
      "code": "622658"
    }, {
      "value": "梓潼县",
      "label": "梓潼县",
      "code": "622157"
    }, {
      "value": "北川羌族自治县",
      "label": "北川羌族自治县",
      "code": "622754"
    }, {
      "value": "平武县",
      "label": "平武县",
      "code": "622555"
    }, {
      "value": "江油市",
      "label": "江油市",
      "code": "621701"
    }],
    "value": "绵阳市",
    "label": "绵阳市"
  }, {
    "children": [{
      "value": "利州区",
      "label": "利州区",
      "code": "628017"
    }, {
      "value": "元坝区",
      "label": "元坝区",
      "code": "628025"
    }, {
      "value": "朝天区",
      "label": "朝天区",
      "code": "628015"
    }, {
      "value": "旺苍县",
      "label": "旺苍县",
      "code": "628201"
    }, {
      "value": "青川县",
      "label": "青川县",
      "code": "628101"
    }, {
      "value": "剑阁县",
      "label": "剑阁县",
      "code": "628316"
    }, {
      "value": "苍溪县",
      "label": "苍溪县",
      "code": "628422"
    }],
    "value": "广元市",
    "label": "广元市"
  }, {
    "children": [{
      "value": "船山区",
      "label": "船山区",
      "code": "629001"
    }, {
      "value": "安居区",
      "label": "安居区",
      "code": "629006"
    }, {
      "value": "蓬溪县",
      "label": "蓬溪县",
      "code": "629101"
    }, {
      "value": "射洪县",
      "label": "射洪县",
      "code": "629201"
    }, {
      "value": "大英县",
      "label": "大英县",
      "code": "629301"
    }],
    "value": "遂宁市",
    "label": "遂宁市"
  }, {
    "children": [{
      "value": "市中区",
      "label": "市中区",
      "code": "641001"
    }, {
      "value": "东兴区",
      "label": "东兴区",
      "code": "641101"
    }, {
      "value": "威远县",
      "label": "威远县",
      "code": "642456"
    }, {
      "value": "资中县",
      "label": "资中县",
      "code": "641201"
    }, {
      "value": "隆昌县",
      "label": "隆昌县",
      "code": "642151"
    }],
    "value": "内江市",
    "label": "内江市"
  }, {
    "children": [{
      "value": "市中区",
      "label": "市中区",
      "code": "614001"
    }, {
      "value": "沙湾区",
      "label": "沙湾区",
      "code": "614901"
    }, {
      "value": "五通桥区",
      "label": "五通桥区",
      "code": "614801"
    }, {
      "value": "金口河区",
      "label": "金口河区",
      "code": "614701"
    }, {
      "value": "犍为县",
      "label": "犍为县",
      "code": "614401"
    }, {
      "value": "井研县",
      "label": "井研县",
      "code": "613101"
    }, {
      "value": "夹江县",
      "label": "夹江县",
      "code": "614101"
    }, {
      "value": "沐川县",
      "label": "沐川县",
      "code": "614501"
    }, {
      "value": "峨边彝族自治县",
      "label": "峨边彝族自治县",
      "code": "614301"
    }, {
      "value": "马边彝族自治县",
      "label": "马边彝族自治县",
      "code": "614601"
    }, {
      "value": "峨眉山市",
      "label": "峨眉山市",
      "code": "614201"
    }],
    "value": "乐山市",
    "label": "乐山市"
  }, {
    "children": [{
      "value": "顺庆区",
      "label": "顺庆区",
      "code": "637001"
    }, {
      "value": "高坪区",
      "label": "高坪区",
      "code": "637101"
    }, {
      "value": "嘉陵区",
      "label": "嘉陵区",
      "code": "637901"
    }, {
      "value": "南部县",
      "label": "南部县",
      "code": "637315"
    }, {
      "value": "营山县",
      "label": "营山县",
      "code": "637716"
    }, {
      "value": "蓬安县",
      "label": "蓬安县",
      "code": "637801"
    }, {
      "value": "仪陇县",
      "label": "仪陇县",
      "code": "637601"
    }, {
      "value": "西充县",
      "label": "西充县",
      "code": "637227"
    }, {
      "value": "阆中市",
      "label": "阆中市",
      "code": "637445"
    }],
    "value": "南充市",
    "label": "南充市"
  }, {
    "children": [{
      "value": "东坡区",
      "label": "东坡区",
      "code": "620032"
    }, {
      "value": "彭山区",
      "label": "彭山区",
      "code": "620801"
    }, {
      "value": "仁寿县",
      "label": "仁寿县",
      "code": "620587"
    }, {
      "value": "洪雅县",
      "label": "洪雅县",
      "code": "620365"
    }, {
      "value": "丹棱县",
      "label": "丹棱县",
      "code": "620201"
    }, {
      "value": "青神县",
      "label": "青神县",
      "code": "620461"
    }],
    "value": "眉山市",
    "label": "眉山市"
  }, {
    "children": [{
      "value": "翠屏区",
      "label": "翠屏区",
      "code": "644001"
    }, {
      "value": "南溪区",
      "label": "南溪区",
      "code": "644101"
    }, {
      "value": "宜宾县",
      "label": "宜宾县",
      "code": "644601"
    }, {
      "value": "江安县",
      "label": "江安县",
      "code": "644201"
    }, {
      "value": "长宁县",
      "label": "长宁县",
      "code": "644301"
    }, {
      "value": "高县",
      "label": "高县",
      "code": "645151"
    }, {
      "value": "珙县",
      "label": "珙县",
      "code": "644501"
    }, {
      "value": "筠连县",
      "label": "筠连县",
      "code": "645251"
    }, {
      "value": "兴文县",
      "label": "兴文县",
      "code": "644401"
    }, {
      "value": "屏山县",
      "label": "屏山县",
      "code": "645351"
    }],
    "value": "宜宾市",
    "label": "宜宾市"
  }, {
    "children": [{
      "value": "广安区",
      "label": "广安区",
      "code": "638021"
    }, {
      "value": "前锋区",
      "label": "前锋区",
      "code": "638019"
    }, {
      "value": "岳池县",
      "label": "岳池县",
      "code": "638308"
    }, {
      "value": "武胜县",
      "label": "武胜县",
      "code": "638411"
    }, {
      "value": "邻水县",
      "label": "邻水县",
      "code": "638501"
    }, {
      "value": "华蓥市",
      "label": "华蓥市",
      "code": "638601"
    }],
    "value": "广安市",
    "label": "广安市"
  }, {
    "children": [{
      "value": "通川区",
      "label": "通川区",
      "code": "635001"
    }, {
      "value": "达川区",
      "label": "达川区",
      "code": "636401"
    }, {
      "value": "宣汉县",
      "label": "宣汉县",
      "code": "636151"
    }, {
      "value": "开江县",
      "label": "开江县",
      "code": "636258"
    }, {
      "value": "大竹县",
      "label": "大竹县",
      "code": "635103"
    }, {
      "value": "渠县",
      "label": "渠县",
      "code": "635222"
    }, {
      "value": "万源市",
      "label": "万源市",
      "code": "636365"
    }],
    "value": "达州市",
    "label": "达州市"
  }, {
    "children": [{
      "value": "雨城区",
      "label": "雨城区",
      "code": "625001"
    }, {
      "value": "名山区",
      "label": "名山区",
      "code": "625101"
    }, {
      "value": "荥经县",
      "label": "荥经县",
      "code": "625201"
    }, {
      "value": "汉源县",
      "label": "汉源县",
      "code": "625301"
    }, {
      "value": "石棉县",
      "label": "石棉县",
      "code": "625401"
    }, {
      "value": "天全县",
      "label": "天全县",
      "code": "625501"
    }, {
      "value": "芦山县",
      "label": "芦山县",
      "code": "625601"
    }, {
      "value": "宝兴县",
      "label": "宝兴县",
      "code": "625701"
    }],
    "value": "雅安市",
    "label": "雅安市"
  }, {
    "children": [{
      "value": "巴州区",
      "label": "巴州区",
      "code": "636001"
    }, {
      "value": "恩阳区",
      "label": "恩阳区",
      "code": "636063"
    }, {
      "value": "通江县",
      "label": "通江县",
      "code": "636701"
    }, {
      "value": "南江县",
      "label": "南江县",
      "code": "636611"
    }, {
      "value": "平昌县",
      "label": "平昌县",
      "code": "636401"
    }],
    "value": "巴中市",
    "label": "巴中市"
  }, {
    "children": [{
      "value": "雁江区",
      "label": "雁江区",
      "code": "641321"
    }, {
      "value": "安岳县",
      "label": "安岳县",
      "code": "642364"
    }, {
      "value": "乐至县",
      "label": "乐至县",
      "code": "641501"
    }, {
      "value": "简阳市",
      "label": "简阳市",
      "code": "641406"
    }],
    "value": "资阳市",
    "label": "资阳市"
  }, {
    "children": [{
      "value": "马尔康市",
      "label": "马尔康市",
      "code": "624001"
    }, {
      "value": "汶川县",
      "label": "汶川县",
      "code": "623002"
    }, {
      "value": "理县",
      "label": "理县",
      "code": "623103"
    }, {
      "value": "茂县",
      "label": "茂县",
      "code": "623201"
    }, {
      "value": "松潘县",
      "label": "松潘县",
      "code": "623301"
    }, {
      "value": "九寨沟县",
      "label": "九寨沟县",
      "code": "623401"
    }, {
      "value": "金川县",
      "label": "金川县",
      "code": "624101"
    }, {
      "value": "小金县",
      "label": "小金县",
      "code": "624202"
    }, {
      "value": "黑水县",
      "label": "黑水县",
      "code": "623501"
    }, {
      "value": "壤塘县",
      "label": "壤塘县",
      "code": "624301"
    }, {
      "value": "阿坝县",
      "label": "阿坝县",
      "code": "624601"
    }, {
      "value": "若尔盖县",
      "label": "若尔盖县",
      "code": "624501"
    }, {
      "value": "红原县",
      "label": "红原县",
      "code": "624401"
    }],
    "value": "阿坝藏族羌族自治州",
    "label": "阿坝藏族羌族自治州"
  }, {
    "children": [{
      "value": "康定市",
      "label": "康定市",
      "code": "626001"
    }, {
      "value": "泸定县",
      "label": "泸定县",
      "code": "626101"
    }, {
      "value": "丹巴县",
      "label": "丹巴县",
      "code": "626301"
    }, {
      "value": "九龙县",
      "label": "九龙县",
      "code": "626201"
    }, {
      "value": "雅江县",
      "label": "雅江县",
      "code": "627451"
    }, {
      "value": "道孚县",
      "label": "道孚县",
      "code": "626401"
    }, {
      "value": "炉霍县",
      "label": "炉霍县",
      "code": "626501"
    }, {
      "value": "甘孜县",
      "label": "甘孜县",
      "code": "626801"
    }, {
      "value": "新龙县",
      "label": "新龙县",
      "code": "626801"
    }, {
      "value": "德格县",
      "label": "德格县",
      "code": "627251"
    }, {
      "value": "白玉县",
      "label": "白玉县",
      "code": "627151"
    }, {
      "value": "石渠县",
      "label": "石渠县",
      "code": "627351"
    }, {
      "value": "色达县",
      "label": "色达县",
      "code": "627861"
    }, {
      "value": "理塘县",
      "label": "理塘县",
      "code": "627551"
    }, {
      "value": "巴塘县",
      "label": "巴塘县",
      "code": "627651"
    }, {
      "value": "乡城县",
      "label": "乡城县",
      "code": "627851"
    }, {
      "value": "稻城县",
      "label": "稻城县",
      "code": "627751"
    }, {
      "value": "得荣县",
      "label": "得荣县",
      "code": "627951"
    }],
    "value": "甘孜藏族自治州",
    "label": "甘孜藏族自治州"
  }, {
    "children": [{
      "value": "西昌市",
      "label": "西昌市",
      "code": "615013"
    }, {
      "value": "木里藏族自治县",
      "label": "木里藏族自治县",
      "code": "615801"
    }, {
      "value": "盐源县",
      "label": "盐源县",
      "code": "615701"
    }, {
      "value": "德昌县",
      "label": "德昌县",
      "code": "615516"
    }, {
      "value": "会理县",
      "label": "会理县",
      "code": "615121"
    }, {
      "value": "会东县",
      "label": "会东县",
      "code": "615201"
    }, {
      "value": "宁南县",
      "label": "宁南县",
      "code": "615401"
    }, {
      "value": "普格县",
      "label": "普格县",
      "code": "615301"
    }, {
      "value": "布拖县",
      "label": "布拖县",
      "code": "616351"
    }, {
      "value": "金阳县",
      "label": "金阳县",
      "code": "616251"
    }, {
      "value": "昭觉县",
      "label": "昭觉县",
      "code": "616154"
    }, {
      "value": "喜德县",
      "label": "喜德县",
      "code": "616751"
    }, {
      "value": "冕宁县",
      "label": "冕宁县",
      "code": "615613"
    }, {
      "value": "越西县",
      "label": "越西县",
      "code": "616651"
    }, {
      "value": "甘洛县",
      "label": "甘洛县",
      "code": "616851"
    }, {
      "value": "美姑县",
      "label": "美姑县",
      "code": "616451"
    }, {
      "value": "雷波县",
      "label": "雷波县",
      "code": "616565"
    }],
    "value": "凉山彝族自治州",
    "label": "凉山彝族自治州"
  }],
  "value": "四川省",
  "label": "四川省"
}, {
  "children": [{
    "children": [{
      "value": "南明区",
      "label": "南明区",
      "code": "550002"
    }, {
      "value": "云岩区",
      "label": "云岩区",
      "code": "550003"
    }, {
      "value": "花溪区",
      "label": "花溪区",
      "code": "550025"
    }, {
      "value": "乌当区",
      "label": "乌当区",
      "code": "550018"
    }, {
      "value": "白云区",
      "label": "白云区",
      "code": "550014"
    }, {
      "value": "观山湖区",
      "label": "观山湖区",
      "code": "550081"
    }, {
      "value": "开阳县",
      "label": "开阳县",
      "code": "550301"
    }, {
      "value": "息烽县",
      "label": "息烽县",
      "code": "551104"
    }, {
      "value": "修文县",
      "label": "修文县",
      "code": "550215"
    }, {
      "value": "清镇市",
      "label": "清镇市",
      "code": "551406"
    }],
    "value": "贵阳市",
    "label": "贵阳市"
  }, {
    "children": [{
      "value": "钟山区",
      "label": "钟山区",
      "code": "553028"
    }, {
      "value": "六枝特区",
      "label": "六枝特区",
      "code": "553401"
    }, {
      "value": "水城县",
      "label": "水城县",
      "code": "553001"
    }, {
      "value": "盘县",
      "label": "盘县",
      "code": "553511"
    }],
    "value": "六盘水市",
    "label": "六盘水市"
  }, {
    "children": [{
      "value": "红花岗区",
      "label": "红花岗区",
      "code": "563001"
    }, {
      "value": "汇川区",
      "label": "汇川区",
      "code": "563124"
    }, {
      "value": "遵义县",
      "label": "遵义县",
      "code": "563124"
    }, {
      "value": "桐梓县",
      "label": "桐梓县",
      "code": "563207"
    }, {
      "value": "绥阳县",
      "label": "绥阳县",
      "code": "563313"
    }, {
      "value": "正安县",
      "label": "正安县",
      "code": "563407"
    }, {
      "value": "道真仡佬族苗族自治县",
      "label": "道真仡佬族苗族自治县",
      "code": "563501"
    }, {
      "value": "务川仡佬族苗族自治县",
      "label": "务川仡佬族苗族自治县",
      "code": "564311"
    }, {
      "value": "凤冈县",
      "label": "凤冈县",
      "code": "564201"
    }, {
      "value": "湄潭县",
      "label": "湄潭县",
      "code": "564101"
    }, {
      "value": "余庆县",
      "label": "余庆县",
      "code": "564401"
    }, {
      "value": "习水县",
      "label": "习水县",
      "code": "564601"
    }, {
      "value": "赤水市",
      "label": "赤水市",
      "code": "564701"
    }, {
      "value": "仁怀市",
      "label": "仁怀市",
      "code": "564501"
    }],
    "value": "遵义市",
    "label": "遵义市"
  }, {
    "children": [{
      "value": "西秀区",
      "label": "西秀区",
      "code": "561009"
    }, {
      "value": "平坝区",
      "label": "平坝区",
      "code": "561101"
    }, {
      "value": "普定县",
      "label": "普定县",
      "code": "562105"
    }, {
      "value": "镇宁布依族苗族自治县",
      "label": "镇宁布依族苗族自治县",
      "code": "561204"
    }, {
      "value": "关岭布依族苗族自治县",
      "label": "关岭布依族苗族自治县",
      "code": "561305"
    }, {
      "value": "紫云苗族布依族自治县",
      "label": "紫云苗族布依族自治县",
      "code": "550801"
    }],
    "value": "安顺市",
    "label": "安顺市"
  }, {
    "children": [{
      "value": "七星关区",
      "label": "七星关区",
      "code": "551701"
    }, {
      "value": "大方县",
      "label": "大方县",
      "code": "551601"
    }, {
      "value": "黔西县",
      "label": "黔西县",
      "code": "551501"
    }, {
      "value": "金沙县",
      "label": "金沙县",
      "code": "551801"
    }, {
      "value": "织金县",
      "label": "织金县",
      "code": "552101"
    }, {
      "value": "纳雍县",
      "label": "纳雍县",
      "code": "553301"
    }, {
      "value": "威宁彝族回族苗族自治县",
      "label": "威宁彝族回族苗族自治县",
      "code": "553101"
    }, {
      "value": "赫章县",
      "label": "赫章县",
      "code": "553201"
    }],
    "value": "毕节市",
    "label": "毕节市"
  }, {
    "children": [{
      "value": "碧江区",
      "label": "碧江区",
      "code": "554301"
    }, {
      "value": "万山区",
      "label": "万山区",
      "code": "554201"
    }, {
      "value": "江口县",
      "label": "江口县",
      "code": "554401"
    }, {
      "value": "玉屏侗族自治县",
      "label": "玉屏侗族自治县",
      "code": "554001"
    }, {
      "value": "石阡县",
      "label": "石阡县",
      "code": "555101"
    }, {
      "value": "思南县",
      "label": "思南县",
      "code": "565101"
    }, {
      "value": "印江土家族苗族自治县",
      "label": "印江土家族苗族自治县",
      "code": "555201"
    }, {
      "value": "德江县",
      "label": "德江县",
      "code": "565201"
    }, {
      "value": "沿河土家族自治县",
      "label": "沿河土家族自治县",
      "code": "565301"
    }, {
      "value": "松桃苗族自治县",
      "label": "松桃苗族自治县",
      "code": "554101"
    }],
    "value": "铜仁市",
    "label": "铜仁市"
  }, {
    "children": [{
      "value": "兴义市",
      "label": "兴义市",
      "code": "562401"
    }, {
      "value": "兴仁县",
      "label": "兴仁县",
      "code": "562301"
    }, {
      "value": "普安县",
      "label": "普安县",
      "code": "561501"
    }, {
      "value": "晴隆县",
      "label": "晴隆县",
      "code": "561401"
    }, {
      "value": "贞丰县",
      "label": "贞丰县",
      "code": "562201"
    }, {
      "value": "望谟县",
      "label": "望谟县",
      "code": "552302"
    }, {
      "value": "册亨县",
      "label": "册亨县",
      "code": "552205"
    }, {
      "value": "安龙县",
      "label": "安龙县",
      "code": "552401"
    }],
    "value": "黔西南布依族苗族自治州",
    "label": "黔西南布依族苗族自治州"
  }, {
    "children": [{
      "value": "凯里市",
      "label": "凯里市",
      "code": "556001"
    }, {
      "value": "黄平县",
      "label": "黄平县",
      "code": "556109"
    }, {
      "value": "施秉县",
      "label": "施秉县",
      "code": "556201"
    }, {
      "value": "三穗县",
      "label": "三穗县",
      "code": "556501"
    }, {
      "value": "镇远县",
      "label": "镇远县",
      "code": "557701"
    }, {
      "value": "岑巩县",
      "label": "岑巩县",
      "code": "557801"
    }, {
      "value": "天柱县",
      "label": "天柱县",
      "code": "556601"
    }, {
      "value": "锦屏县",
      "label": "锦屏县",
      "code": "556701"
    }, {
      "value": "剑河县",
      "label": "剑河县",
      "code": "556401"
    }, {
      "value": "台江县",
      "label": "台江县",
      "code": "556304"
    }, {
      "value": "黎平县",
      "label": "黎平县",
      "code": "557301"
    }, {
      "value": "榕江县",
      "label": "榕江县",
      "code": "557201"
    }, {
      "value": "从江县",
      "label": "从江县",
      "code": "557401"
    }, {
      "value": "雷山县",
      "label": "雷山县",
      "code": "557104"
    }, {
      "value": "麻江县",
      "label": "麻江县",
      "code": "557601"
    }, {
      "value": "丹寨县",
      "label": "丹寨县",
      "code": "557501"
    }],
    "value": "黔东南苗族侗族自治州",
    "label": "黔东南苗族侗族自治州"
  }, {
    "children": [{
      "value": "都匀市",
      "label": "都匀市",
      "code": "558001"
    }, {
      "value": "福泉市",
      "label": "福泉市",
      "code": "550501"
    }, {
      "value": "荔波县",
      "label": "荔波县",
      "code": "558401"
    }, {
      "value": "贵定县",
      "label": "贵定县",
      "code": "551303"
    }, {
      "value": "瓮安县",
      "label": "瓮安县",
      "code": "550407"
    }, {
      "value": "独山县",
      "label": "独山县",
      "code": "558201"
    }, {
      "value": "平塘县",
      "label": "平塘县",
      "code": "558301"
    }, {
      "value": "罗甸县",
      "label": "罗甸县",
      "code": "550101"
    }, {
      "value": "长顺县",
      "label": "长顺县",
      "code": "550701"
    }, {
      "value": "龙里县",
      "label": "龙里县",
      "code": "551201"
    }, {
      "value": "惠水县",
      "label": "惠水县",
      "code": "550601"
    }, {
      "value": "三都水族自治县",
      "label": "三都水族自治县",
      "code": "558104"
    }],
    "value": "黔南布依族苗族自治州",
    "label": "黔南布依族苗族自治州"
  }],
  "value": "贵州省",
  "label": "贵州省"
}, {
  "children": [{
    "children": [{
      "value": "五华区",
      "label": "五华区",
      "code": "650031"
    }, {
      "value": "盘龙区",
      "label": "盘龙区",
      "code": "650225"
    }, {
      "value": "官渡区",
      "label": "官渡区",
      "code": "650216"
    }, {
      "value": "西山区",
      "label": "西山区",
      "code": "650034"
    }, {
      "value": "东川区",
      "label": "东川区",
      "code": "654101"
    }, {
      "value": "呈贡区",
      "label": "呈贡区",
      "code": "650501"
    }, {
      "value": "晋宁县",
      "label": "晋宁县",
      "code": "650601"
    }, {
      "value": "富民县",
      "label": "富民县",
      "code": "650401"
    }, {
      "value": "宜良县",
      "label": "宜良县",
      "code": "652101"
    }, {
      "value": "石林彝族自治县",
      "label": "石林彝族自治县",
      "code": "652201"
    }, {
      "value": "嵩明县",
      "label": "嵩明县",
      "code": "651709"
    }, {
      "value": "禄劝彝族苗族自治县",
      "label": "禄劝彝族苗族自治县",
      "code": "651501"
    }, {
      "value": "寻甸回族彝族自治县",
      "label": "寻甸回族彝族自治县",
      "code": "655216"
    }, {
      "value": "安宁市",
      "label": "安宁市",
      "code": "650301"
    }],
    "value": "昆明市",
    "label": "昆明市"
  }, {
    "children": [{
      "value": "麒麟区",
      "label": "麒麟区",
      "code": "655001"
    }, {
      "value": "马龙县",
      "label": "马龙县",
      "code": "655101"
    }, {
      "value": "陆良县",
      "label": "陆良县",
      "code": "655601"
    }, {
      "value": "师宗县",
      "label": "师宗县",
      "code": "655701"
    }, {
      "value": "罗平县",
      "label": "罗平县",
      "code": "655813"
    }, {
      "value": "富源县",
      "label": "富源县",
      "code": "655502"
    }, {
      "value": "会泽县",
      "label": "会泽县",
      "code": "654211"
    }, {
      "value": "沾益县",
      "label": "沾益县",
      "code": "655338"
    }, {
      "value": "宣威市",
      "label": "宣威市",
      "code": "655401"
    }],
    "value": "曲靖市",
    "label": "曲靖市"
  }, {
    "children": [{
      "value": "红塔区",
      "label": "红塔区",
      "code": "653102"
    }, {
      "value": "江川区",
      "label": "江川区",
      "code": "652601"
    }, {
      "value": "澄江县",
      "label": "澄江县",
      "code": "652501"
    }, {
      "value": "通海县",
      "label": "通海县",
      "code": "652701"
    }, {
      "value": "华宁县",
      "label": "华宁县",
      "code": "652801"
    }, {
      "value": "易门县",
      "label": "易门县",
      "code": "651101"
    }, {
      "value": "峨山彝族自治县",
      "label": "峨山彝族自治县",
      "code": "653201"
    }, {
      "value": "新平彝族傣族自治县",
      "label": "新平彝族傣族自治县",
      "code": "653408"
    }, {
      "value": "元江哈尼族彝族傣族自治县",
      "label": "元江哈尼族彝族傣族自治县",
      "code": "653308"
    }],
    "value": "玉溪市",
    "label": "玉溪市"
  }, {
    "children": [{
      "value": "隆阳区",
      "label": "隆阳区",
      "code": "678017"
    }, {
      "value": "施甸县",
      "label": "施甸县",
      "code": "678201"
    }, {
      "value": "龙陵县",
      "label": "龙陵县",
      "code": "678301"
    }, {
      "value": "昌宁县",
      "label": "昌宁县",
      "code": "678113"
    }, {
      "value": "腾冲市",
      "label": "腾冲市",
      "code": "679101"
    }],
    "value": "保山市",
    "label": "保山市"
  }, {
    "children": [{
      "value": "昭阳区",
      "label": "昭阳区",
      "code": "657001"
    }, {
      "value": "鲁甸县",
      "label": "鲁甸县",
      "code": "657103"
    }, {
      "value": "巧家县",
      "label": "巧家县",
      "code": "654601"
    }, {
      "value": "盐津县",
      "label": "盐津县",
      "code": "657501"
    }, {
      "value": "大关县",
      "label": "大关县",
      "code": "657404"
    }, {
      "value": "永善县",
      "label": "永善县",
      "code": "657301"
    }, {
      "value": "绥江县",
      "label": "绥江县",
      "code": "657701"
    }, {
      "value": "镇雄县",
      "label": "镇雄县",
      "code": "657201"
    }, {
      "value": "彝良县",
      "label": "彝良县",
      "code": "657601"
    }, {
      "value": "威信县",
      "label": "威信县",
      "code": "657911"
    }, {
      "value": "水富县",
      "label": "水富县",
      "code": "657801"
    }],
    "value": "昭通市",
    "label": "昭通市"
  }, {
    "children": [{
      "value": "古城区",
      "label": "古城区",
      "code": "674101"
    }, {
      "value": "玉龙纳西族自治县",
      "label": "玉龙纳西族自治县",
      "code": "674101"
    }, {
      "value": "永胜县",
      "label": "永胜县",
      "code": "674201"
    }, {
      "value": "华坪县",
      "label": "华坪县",
      "code": "674801"
    }, {
      "value": "宁蒗彝族自治县",
      "label": "宁蒗彝族自治县",
      "code": "674301"
    }],
    "value": "丽江市",
    "label": "丽江市"
  }, {
    "children": [{
      "value": "思茅区",
      "label": "思茅区",
      "code": "665001"
    }, {
      "value": "宁洱哈尼族彝族自治县",
      "label": "宁洱哈尼族彝族自治县",
      "code": "665101"
    }, {
      "value": "墨江哈尼族自治县",
      "label": "墨江哈尼族自治县",
      "code": "654801"
    }, {
      "value": "景东彝族自治县",
      "label": "景东彝族自治县",
      "code": "676201"
    }, {
      "value": "景谷傣族彝族自治县",
      "label": "景谷傣族彝族自治县",
      "code": "666409"
    }, {
      "value": "镇沅彝族哈尼族拉祜族自治县",
      "label": "镇沅彝族哈尼族拉祜族自治县",
      "code": "666503"
    }, {
      "value": "江城哈尼族彝族自治县",
      "label": "江城哈尼族彝族自治县",
      "code": "665902"
    }, {
      "value": "孟连傣族拉祜族佤族自治县",
      "label": "孟连傣族拉祜族佤族自治县",
      "code": "665805"
    }, {
      "value": "澜沧拉祜族自治县",
      "label": "澜沧拉祜族自治县",
      "code": "665601"
    }, {
      "value": "西盟佤族自治县",
      "label": "西盟佤族自治县",
      "code": "665701"
    }],
    "value": "普洱市",
    "label": "普洱市"
  }, {
    "children": [{
      "value": "临翔区",
      "label": "临翔区",
      "code": "677001"
    }, {
      "value": "凤庆县",
      "label": "凤庆县",
      "code": "675901"
    }, {
      "value": "云县",
      "label": "云县",
      "code": "675806"
    }, {
      "value": "永德县",
      "label": "永德县",
      "code": "677601"
    }, {
      "value": "镇康县",
      "label": "镇康县",
      "code": "677706"
    }, {
      "value": "双江拉祜族佤族布朗族傣族自治县",
      "label": "双江拉祜族佤族布朗族傣族自治县",
      "code": "677303"
    }, {
      "value": "耿马傣族佤族自治县",
      "label": "耿马傣族佤族自治县",
      "code": "677506"
    }, {
      "value": "沧源佤族自治县",
      "label": "沧源佤族自治县",
      "code": "677401"
    }],
    "value": "临沧市",
    "label": "临沧市"
  }, {
    "children": [{
      "value": "楚雄市",
      "label": "楚雄市",
      "code": "675001"
    }, {
      "value": "双柏县",
      "label": "双柏县",
      "code": "675101"
    }, {
      "value": "牟定县",
      "label": "牟定县",
      "code": "675501"
    }, {
      "value": "南华县",
      "label": "南华县",
      "code": "675201"
    }, {
      "value": "姚安县",
      "label": "姚安县",
      "code": "675301"
    }, {
      "value": "大姚县",
      "label": "大姚县",
      "code": "675401"
    }, {
      "value": "永仁县",
      "label": "永仁县",
      "code": "651401"
    }, {
      "value": "元谋县",
      "label": "元谋县",
      "code": "651302"
    }, {
      "value": "武定县",
      "label": "武定县",
      "code": "651601"
    }, {
      "value": "禄丰县",
      "label": "禄丰县",
      "code": "651201"
    }],
    "value": "楚雄彝族自治州",
    "label": "楚雄彝族自治州"
  }, {
    "children": [{
      "value": "个旧市",
      "label": "个旧市",
      "code": "661001"
    }, {
      "value": "开远市",
      "label": "开远市",
      "code": "661601"
    }, {
      "value": "蒙自市",
      "label": "蒙自市",
      "code": "661101"
    }, {
      "value": "弥勒市",
      "label": "弥勒市",
      "code": "652399"
    }, {
      "value": "屏边苗族自治县",
      "label": "屏边苗族自治县",
      "code": "661201"
    }, {
      "value": "建水县",
      "label": "建水县",
      "code": "654301"
    }, {
      "value": "石屏县",
      "label": "石屏县",
      "code": "662201"
    }, {
      "value": "泸西县",
      "label": "泸西县",
      "code": "652401"
    }, {
      "value": "元阳县",
      "label": "元阳县",
      "code": "662403"
    }, {
      "value": "红河县",
      "label": "红河县",
      "code": "654404"
    }, {
      "value": "金平苗族瑶族傣族自治县",
      "label": "金平苗族瑶族傣族自治县",
      "code": "661501"
    }, {
      "value": "绿春县",
      "label": "绿春县",
      "code": "662501"
    }, {
      "value": "河口瑶族自治县",
      "label": "河口瑶族自治县",
      "code": "661301"
    }],
    "value": "红河哈尼族彝族自治州",
    "label": "红河哈尼族彝族自治州"
  }, {
    "children": [{
      "value": "文山市",
      "label": "文山市",
      "code": "663001"
    }, {
      "value": "砚山县",
      "label": "砚山县",
      "code": "663111"
    }, {
      "value": "西畴县",
      "label": "西畴县",
      "code": "663501"
    }, {
      "value": "麻栗坡县",
      "label": "麻栗坡县",
      "code": "663603"
    }, {
      "value": "马关县",
      "label": "马关县",
      "code": "663711"
    }, {
      "value": "丘北县",
      "label": "丘北县",
      "code": "663201"
    }, {
      "value": "广南县",
      "label": "广南县",
      "code": "663313"
    }, {
      "value": "富宁县",
      "label": "富宁县",
      "code": "663414"
    }],
    "value": "文山壮族苗族自治州",
    "label": "文山壮族苗族自治州"
  }, {
    "children": [{
      "value": "景洪市",
      "label": "景洪市",
      "code": "666101"
    }, {
      "value": "勐海县",
      "label": "勐海县",
      "code": "666201"
    }, {
      "value": "勐腊县",
      "label": "勐腊县",
      "code": "666301"
    }],
    "value": "西双版纳傣族自治州",
    "label": "西双版纳傣族自治州"
  }, {
    "children": [{
      "value": "大理市",
      "label": "大理市",
      "code": "671001"
    }, {
      "value": "漾濞彝族自治县",
      "label": "漾濞彝族自治县",
      "code": "672501"
    }, {
      "value": "祥云县",
      "label": "祥云县",
      "code": "672101"
    }, {
      "value": "宾川县",
      "label": "宾川县",
      "code": "671601"
    }, {
      "value": "弥渡县",
      "label": "弥渡县",
      "code": "675601"
    }, {
      "value": "南涧彝族自治县",
      "label": "南涧彝族自治县",
      "code": "675701"
    }, {
      "value": "巍山彝族回族自治县",
      "label": "巍山彝族回族自治县",
      "code": "672401"
    }, {
      "value": "永平县",
      "label": "永平县",
      "code": "672601"
    }, {
      "value": "云龙县",
      "label": "云龙县",
      "code": "672701"
    }, {
      "value": "洱源县",
      "label": "洱源县",
      "code": "671201"
    }, {
      "value": "剑川县",
      "label": "剑川县",
      "code": "671301"
    }, {
      "value": "鹤庆县",
      "label": "鹤庆县",
      "code": "671501"
    }],
    "value": "大理白族自治州",
    "label": "大理白族自治州"
  }, {
    "children": [{
      "value": "瑞丽市",
      "label": "瑞丽市",
      "code": "678501"
    }, {
      "value": "芒市",
      "label": "芒市",
      "code": "678401"
    }, {
      "value": "梁河县",
      "label": "梁河县",
      "code": "679201"
    }, {
      "value": "盈江县",
      "label": "盈江县",
      "code": "679301"
    }, {
      "value": "陇川县",
      "label": "陇川县",
      "code": "678701"
    }],
    "value": "德宏傣族景颇族自治州",
    "label": "德宏傣族景颇族自治州"
  }, {
    "children": [{
      "value": "泸水县",
      "label": "泸水县",
      "code": "673201"
    }, {
      "value": "福贡县",
      "label": "福贡县",
      "code": "673401"
    }, {
      "value": "贡山独龙族怒族自治县",
      "label": "贡山独龙族怒族自治县",
      "code": "673501"
    }, {
      "value": "兰坪白族普米族自治县",
      "label": "兰坪白族普米族自治县",
      "code": "671401"
    }],
    "value": "怒江傈僳族自治州",
    "label": "怒江傈僳族自治州"
  }, {
    "children": [{
      "value": "香格里拉市",
      "label": "香格里拉市",
      "code": "674401"
    }, {
      "value": "德钦县",
      "label": "德钦县",
      "code": "674501"
    }, {
      "value": "维西傈僳族自治县",
      "label": "维西傈僳族自治县",
      "code": "674601"
    }],
    "value": "迪庆藏族自治州",
    "label": "迪庆藏族自治州"
  }],
  "value": "云南省",
  "label": "云南省"
}, {
  "children": [{
    "children": [{
      "value": "城关区",
      "label": "城关区",
      "code": "730031"
    }, {
      "value": "堆龙德庆区",
      "label": "堆龙德庆区",
      "code": "851401"
    }, {
      "value": "林周县",
      "label": "林周县",
      "code": "851601"
    }, {
      "value": "当雄县",
      "label": "当雄县",
      "code": "851501"
    }, {
      "value": "尼木县",
      "label": "尼木县",
      "code": "851301"
    }, {
      "value": "曲水县",
      "label": "曲水县",
      "code": "850601"
    }, {
      "value": "达孜县",
      "label": "达孜县",
      "code": "850101"
    }, {
      "value": "墨竹工卡县",
      "label": "墨竹工卡县",
      "code": "850201"
    }],
    "value": "拉萨市",
    "label": "拉萨市"
  }, {
    "children": [{
      "value": "桑珠孜区",
      "label": "桑珠孜区",
      "code": "857001"
    }, {
      "value": "南木林县",
      "label": "南木林县",
      "code": "857101"
    }, {
      "value": "江孜县",
      "label": "江孜县",
      "code": "857401"
    }, {
      "value": "定日县",
      "label": "定日县",
      "code": "858201"
    }, {
      "value": "萨迦县",
      "label": "萨迦县",
      "code": "857801"
    }, {
      "value": "拉孜县",
      "label": "拉孜县",
      "code": "858101"
    }, {
      "value": "昂仁县",
      "label": "昂仁县",
      "code": "858501"
    }, {
      "value": "谢通门县",
      "label": "谢通门县",
      "code": "858901"
    }, {
      "value": "白朗县",
      "label": "白朗县",
      "code": "857301"
    }, {
      "value": "仁布县",
      "label": "仁布县",
      "code": "857201"
    }, {
      "value": "康马县",
      "label": "康马县",
      "code": "857501"
    }, {
      "value": "定结县",
      "label": "定结县",
      "code": "857901"
    }, {
      "value": "仲巴县",
      "label": "仲巴县",
      "code": "858801"
    }, {
      "value": "亚东县",
      "label": "亚东县",
      "code": "857601"
    }, {
      "value": "吉隆县",
      "label": "吉隆县",
      "code": "858701"
    }, {
      "value": "聂拉木县",
      "label": "聂拉木县",
      "code": "858301"
    }, {
      "value": "萨嘎县",
      "label": "萨嘎县",
      "code": "858601"
    }, {
      "value": "岗巴县",
      "label": "岗巴县",
      "code": "857701"
    }],
    "value": "日喀则市",
    "label": "日喀则市"
  }, {
    "children": [{
      "value": "卡若区",
      "label": "卡若区",
      "code": "854001"
    }, {
      "value": "江达县",
      "label": "江达县",
      "code": "854101"
    }, {
      "value": "贡觉县",
      "label": "贡觉县",
      "code": "854201"
    }, {
      "value": "类乌齐县",
      "label": "类乌齐县",
      "code": "855601"
    }, {
      "value": "丁青县",
      "label": "丁青县",
      "code": "855701"
    }, {
      "value": "察雅县",
      "label": "察雅县",
      "code": "854301"
    }, {
      "value": "八宿县",
      "label": "八宿县",
      "code": "854601"
    }, {
      "value": "左贡县",
      "label": "左贡县",
      "code": "854401"
    }, {
      "value": "芒康县",
      "label": "芒康县",
      "code": "854501"
    }, {
      "value": "洛隆县",
      "label": "洛隆县",
      "code": "855401"
    }, {
      "value": "边坝县",
      "label": "边坝县",
      "code": "855501"
    }],
    "value": "昌都市",
    "label": "昌都市"
  }, {
    "children": [{
      "value": "巴宜区",
      "label": "巴宜区",
      "code": "860101"
    }, {
      "value": "工布江达县",
      "label": "工布江达县",
      "code": "860201"
    }, {
      "value": "米林县",
      "label": "米林县",
      "code": "860501"
    }, {
      "value": "墨脱县",
      "label": "墨脱县",
      "code": "860701"
    }, {
      "value": "波密县",
      "label": "波密县",
      "code": "860301"
    }, {
      "value": "察隅县",
      "label": "察隅县",
      "code": "860601"
    }, {
      "value": "朗县",
      "label": "朗县",
      "code": "860401"
    }],
    "value": "林芝市",
    "label": "林芝市"
  }, {
    "children": [{
      "value": "乃东县",
      "label": "乃东县",
      "code": "856101"
    }, {
      "value": "扎囊县",
      "label": "扎囊县",
      "code": "850801"
    }, {
      "value": "贡嘎县",
      "label": "贡嘎县",
      "code": "850701"
    }, {
      "value": "桑日县",
      "label": "桑日县",
      "code": "856201"
    }, {
      "value": "琼结县",
      "label": "琼结县",
      "code": "856801"
    }, {
      "value": "曲松县",
      "label": "曲松县",
      "code": "856301"
    }, {
      "value": "措美县",
      "label": "措美县",
      "code": "856901"
    }, {
      "value": "洛扎县",
      "label": "洛扎县",
      "code": "851201"
    }, {
      "value": "加查县",
      "label": "加查县",
      "code": "856401"
    }, {
      "value": "隆子县",
      "label": "隆子县",
      "code": "856601"
    }, {
      "value": "错那县",
      "label": "错那县",
      "code": "856701"
    }, {
      "value": "浪卡子县",
      "label": "浪卡子县",
      "code": "851101"
    }],
    "value": "山南地区",
    "label": "山南地区"
  }, {
    "children": [{
      "value": "那曲县",
      "label": "那曲县",
      "code": "852001"
    }, {
      "value": "嘉黎县",
      "label": "嘉黎县",
      "code": "852401"
    }, {
      "value": "比如县",
      "label": "比如县",
      "code": "852301"
    }, {
      "value": "聂荣县",
      "label": "聂荣县",
      "code": "853501"
    }, {
      "value": "安多县",
      "label": "安多县",
      "code": "853401"
    }, {
      "value": "申扎县",
      "label": "申扎县",
      "code": "853101"
    }, {
      "value": "索县",
      "label": "索县",
      "code": "852201"
    }, {
      "value": "班戈县",
      "label": "班戈县",
      "code": "852501"
    }, {
      "value": "巴青县",
      "label": "巴青县",
      "code": "852101"
    }, {
      "value": "尼玛县",
      "label": "尼玛县",
      "code": "853301"
    }, {
      "value": "双湖县",
      "label": "双湖县",
      "code": "853301"
    }],
    "value": "那曲地区",
    "label": "那曲地区"
  }, {
    "children": [{
      "value": "普兰县",
      "label": "普兰县",
      "code": "859501"
    }, {
      "value": "札达县",
      "label": "札达县",
      "code": "859601"
    }, {
      "value": "噶尔县",
      "label": "噶尔县",
      "code": "859401"
    }, {
      "value": "日土县",
      "label": "日土县",
      "code": "859701"
    }, {
      "value": "革吉县",
      "label": "革吉县",
      "code": "859101"
    }, {
      "value": "改则县",
      "label": "改则县",
      "code": "859201"
    }, {
      "value": "措勤县",
      "label": "措勤县",
      "code": "859301"
    }],
    "value": "阿里地区",
    "label": "阿里地区"
  }],
  "value": "西藏自治区",
  "label": "西藏自治区"
}, {
  "children": [{
    "children": [{
      "value": "新城区",
      "label": "新城区",
      "code": "710016"
    }, {
      "value": "碑林区",
      "label": "碑林区",
      "code": "710068"
    }, {
      "value": "莲湖区",
      "label": "莲湖区",
      "code": "710082"
    }, {
      "value": "灞桥区",
      "label": "灞桥区",
      "code": "710043"
    }, {
      "value": "未央区",
      "label": "未央区",
      "code": "710021"
    }, {
      "value": "雁塔区",
      "label": "雁塔区",
      "code": "710043"
    }, {
      "value": "阎良区",
      "label": "阎良区",
      "code": "710089"
    }, {
      "value": "临潼区",
      "label": "临潼区",
      "code": "710601"
    }, {
      "value": "长安区",
      "label": "长安区",
      "code": "710116"
    }, {
      "value": "高陵区",
      "label": "高陵区",
      "code": "710201"
    }, {
      "value": "蓝田县",
      "label": "蓝田县",
      "code": "710523"
    }, {
      "value": "周至县",
      "label": "周至县",
      "code": "710401"
    }, {
      "value": "户县",
      "label": "户县",
      "code": "710301"
    }],
    "value": "西安市",
    "label": "西安市"
  }, {
    "children": [{
      "value": "王益区",
      "label": "王益区",
      "code": "727001"
    }, {
      "value": "印台区",
      "label": "印台区",
      "code": "727017"
    }, {
      "value": "耀州区",
      "label": "耀州区",
      "code": "727107"
    }, {
      "value": "宜君县",
      "label": "宜君县",
      "code": "727201"
    }],
    "value": "铜川市",
    "label": "铜川市"
  }, {
    "children": [{
      "value": "渭滨区",
      "label": "渭滨区",
      "code": "721006"
    }, {
      "value": "金台区",
      "label": "金台区",
      "code": "721001"
    }, {
      "value": "陈仓区",
      "label": "陈仓区",
      "code": "721319"
    }, {
      "value": "凤翔县",
      "label": "凤翔县",
      "code": "721401"
    }, {
      "value": "岐山县",
      "label": "岐山县",
      "code": "722401"
    }, {
      "value": "扶风县",
      "label": "扶风县",
      "code": "722201"
    }, {
      "value": "眉县",
      "label": "眉县",
      "code": "722304"
    }, {
      "value": "陇县",
      "label": "陇县",
      "code": "721201"
    }, {
      "value": "千阳县",
      "label": "千阳县",
      "code": "721101"
    }, {
      "value": "麟游县",
      "label": "麟游县",
      "code": "721501"
    }, {
      "value": "凤县",
      "label": "凤县",
      "code": "721701"
    }, {
      "value": "太白县",
      "label": "太白县",
      "code": "721601"
    }],
    "value": "宝鸡市",
    "label": "宝鸡市"
  }, {
    "children": [{
      "value": "秦都区",
      "label": "秦都区",
      "code": "712001"
    }, {
      "value": "杨陵区",
      "label": "杨陵区",
      "code": "712101"
    }, {
      "value": "渭城区",
      "label": "渭城区",
      "code": "712042"
    }, {
      "value": "三原县",
      "label": "三原县",
      "code": "713801"
    }, {
      "value": "泾阳县",
      "label": "泾阳县",
      "code": "713704"
    }, {
      "value": "乾县",
      "label": "乾县",
      "code": "713301"
    }, {
      "value": "礼泉县",
      "label": "礼泉县",
      "code": "713201"
    }, {
      "value": "永寿县",
      "label": "永寿县",
      "code": "713401"
    }, {
      "value": "彬县",
      "label": "彬县",
      "code": "713501"
    }, {
      "value": "长武县",
      "label": "长武县",
      "code": "713601"
    }, {
      "value": "旬邑县",
      "label": "旬邑县",
      "code": "711301"
    }, {
      "value": "淳化县",
      "label": "淳化县",
      "code": "711204"
    }, {
      "value": "武功县",
      "label": "武功县",
      "code": "712201"
    }, {
      "value": "兴平市",
      "label": "兴平市",
      "code": "713101"
    }],
    "value": "咸阳市",
    "label": "咸阳市"
  }, {
    "children": [{
      "value": "临渭区",
      "label": "临渭区",
      "code": "714001"
    }, {
      "value": "华州区",
      "label": "华州区",
      "code": "714101"
    }, {
      "value": "潼关县",
      "label": "潼关县",
      "code": "714301"
    }, {
      "value": "大荔县",
      "label": "大荔县",
      "code": "715101"
    }, {
      "value": "合阳县",
      "label": "合阳县",
      "code": "715301"
    }, {
      "value": "澄城县",
      "label": "澄城县",
      "code": "715201"
    }, {
      "value": "蒲城县",
      "label": "蒲城县",
      "code": "715515"
    }, {
      "value": "白水县",
      "label": "白水县",
      "code": "715601"
    }, {
      "value": "富平县",
      "label": "富平县",
      "code": "711701"
    }, {
      "value": "韩城市",
      "label": "韩城市",
      "code": "715401"
    }, {
      "value": "华阴市",
      "label": "华阴市",
      "code": "714201"
    }],
    "value": "渭南市",
    "label": "渭南市"
  }, {
    "children": [{
      "value": "宝塔区",
      "label": "宝塔区",
      "code": "716006"
    }, {
      "value": "延长县",
      "label": "延长县",
      "code": "717103"
    }, {
      "value": "延川县",
      "label": "延川县",
      "code": "717201"
    }, {
      "value": "子长县",
      "label": "子长县",
      "code": "717301"
    }, {
      "value": "安塞县",
      "label": "安塞县",
      "code": "717401"
    }, {
      "value": "志丹县",
      "label": "志丹县",
      "code": "717501"
    }, {
      "value": "吴起县",
      "label": "吴起县",
      "code": "717601"
    }, {
      "value": "甘泉县",
      "label": "甘泉县",
      "code": "716102"
    }, {
      "value": "富县",
      "label": "富县",
      "code": "727501"
    }, {
      "value": "洛川县",
      "label": "洛川县",
      "code": "727401"
    }, {
      "value": "宜川县",
      "label": "宜川县",
      "code": "716201"
    }, {
      "value": "黄龙县",
      "label": "黄龙县",
      "code": "715701"
    }, {
      "value": "黄陵县",
      "label": "黄陵县",
      "code": "727301"
    }],
    "value": "延安市",
    "label": "延安市"
  }, {
    "children": [{
      "value": "汉台区",
      "label": "汉台区",
      "code": "723001"
    }, {
      "value": "南郑县",
      "label": "南郑县",
      "code": "723101"
    }, {
      "value": "城固县",
      "label": "城固县",
      "code": "723201"
    }, {
      "value": "洋县",
      "label": "洋县",
      "code": "723301"
    }, {
      "value": "西乡县",
      "label": "西乡县",
      "code": "723501"
    }, {
      "value": "勉县",
      "label": "勉县",
      "code": "724201"
    }, {
      "value": "宁强县",
      "label": "宁强县",
      "code": "724401"
    }, {
      "value": "略阳县",
      "label": "略阳县",
      "code": "724312"
    }, {
      "value": "镇巴县",
      "label": "镇巴县",
      "code": "723601"
    }, {
      "value": "留坝县",
      "label": "留坝县",
      "code": "724101"
    }, {
      "value": "佛坪县",
      "label": "佛坪县",
      "code": "723401"
    }],
    "value": "汉中市",
    "label": "汉中市"
  }, {
    "children": [{
      "value": "榆阳区",
      "label": "榆阳区",
      "code": "719007"
    }, {
      "value": "横山区",
      "label": "横山区",
      "code": "719201"
    }, {
      "value": "神木县",
      "label": "神木县",
      "code": "719301"
    }, {
      "value": "府谷县",
      "label": "府谷县",
      "code": "719401"
    }, {
      "value": "靖边县",
      "label": "靖边县",
      "code": "718501"
    }, {
      "value": "定边县",
      "label": "定边县",
      "code": "718611"
    }, {
      "value": "绥德县",
      "label": "绥德县",
      "code": "718002"
    }, {
      "value": "米脂县",
      "label": "米脂县",
      "code": "718101"
    }, {
      "value": "佳县",
      "label": "佳县",
      "code": "719202"
    }, {
      "value": "吴堡县",
      "label": "吴堡县",
      "code": "718201"
    }, {
      "value": "清涧县",
      "label": "清涧县",
      "code": "718302"
    }, {
      "value": "子洲县",
      "label": "子洲县",
      "code": "718408"
    }],
    "value": "榆林市",
    "label": "榆林市"
  }, {
    "children": [{
      "value": "汉滨区",
      "label": "汉滨区",
      "code": "725001"
    }, {
      "value": "汉阴县",
      "label": "汉阴县",
      "code": "725101"
    }, {
      "value": "石泉县",
      "label": "石泉县",
      "code": "725221"
    }, {
      "value": "宁陕县",
      "label": "宁陕县",
      "code": "711601"
    }, {
      "value": "紫阳县",
      "label": "紫阳县",
      "code": "725309"
    }, {
      "value": "岚皋县",
      "label": "岚皋县",
      "code": "725401"
    }, {
      "value": "平利县",
      "label": "平利县",
      "code": "725501"
    }, {
      "value": "镇坪县",
      "label": "镇坪县",
      "code": "725605"
    }, {
      "value": "旬阳县",
      "label": "旬阳县",
      "code": "752701"
    }, {
      "value": "白河县",
      "label": "白河县",
      "code": "725802"
    }],
    "value": "安康市",
    "label": "安康市"
  }, {
    "children": [{
      "value": "商州区",
      "label": "商州区",
      "code": "726009"
    }, {
      "value": "洛南县",
      "label": "洛南县",
      "code": "726104"
    }, {
      "value": "丹凤县",
      "label": "丹凤县",
      "code": "726205"
    }, {
      "value": "商南县",
      "label": "商南县",
      "code": "726309"
    }, {
      "value": "山阳县",
      "label": "山阳县",
      "code": "726403"
    }, {
      "value": "镇安县",
      "label": "镇安县",
      "code": "711503"
    }, {
      "value": "柞水县",
      "label": "柞水县",
      "code": "711404"
    }],
    "value": "商洛市",
    "label": "商洛市"
  }],
  "value": "陕西省",
  "label": "陕西省"
}, {
  "children": [{
    "children": [{
      "value": "城关区",
      "label": "城关区",
      "code": "730001"
    }, {
      "value": "七里河区",
      "label": "七里河区",
      "code": "730059"
    }, {
      "value": "西固区",
      "label": "西固区",
      "code": "730094"
    }, {
      "value": "安宁区",
      "label": "安宁区",
      "code": "730071"
    }, {
      "value": "红古区",
      "label": "红古区",
      "code": "730088"
    }, {
      "value": "永登县",
      "label": "永登县",
      "code": "730317"
    }, {
      "value": "皋兰县",
      "label": "皋兰县",
      "code": "730201"
    }, {
      "value": "榆中县",
      "label": "榆中县",
      "code": "730112"
    }],
    "value": "兰州市",
    "label": "兰州市"
  }, {
    "value": "嘉峪关市",
    "label": "嘉峪关市"
  }, {
    "children": [{
      "value": "金川区",
      "label": "金川区",
      "code": "737102"
    }, {
      "value": "永昌县",
      "label": "永昌县",
      "code": "737201"
    }],
    "value": "金昌市",
    "label": "金昌市"
  }, {
    "children": [{
      "value": "白银区",
      "label": "白银区",
      "code": "730911"
    }, {
      "value": "平川区",
      "label": "平川区",
      "code": "730913"
    }, {
      "value": "靖远县",
      "label": "靖远县",
      "code": "730605"
    }, {
      "value": "会宁县",
      "label": "会宁县",
      "code": "730701"
    }, {
      "value": "景泰县",
      "label": "景泰县",
      "code": "730401"
    }],
    "value": "白银市",
    "label": "白银市"
  }, {
    "children": [{
      "value": "秦州区",
      "label": "秦州区",
      "code": "741012"
    }, {
      "value": "麦积区",
      "label": "麦积区",
      "code": "741028"
    }, {
      "value": "清水县",
      "label": "清水县",
      "code": "741401"
    }, {
      "value": "秦安县",
      "label": "秦安县",
      "code": "741601"
    }, {
      "value": "甘谷县",
      "label": "甘谷县",
      "code": "741201"
    }, {
      "value": "武山县",
      "label": "武山县",
      "code": "741306"
    }, {
      "value": "张家川回族自治县",
      "label": "张家川回族自治县",
      "code": "741501"
    }],
    "value": "天水市",
    "label": "天水市"
  }, {
    "children": [{
      "value": "凉州区",
      "label": "凉州区",
      "code": "733001"
    }, {
      "value": "民勤县",
      "label": "民勤县",
      "code": "733301"
    }, {
      "value": "古浪县",
      "label": "古浪县",
      "code": "733104"
    }, {
      "value": "天祝藏族自治县",
      "label": "天祝藏族自治县",
      "code": "733202"
    }],
    "value": "武威市",
    "label": "武威市"
  }, {
    "children": [{
      "value": "甘州区",
      "label": "甘州区",
      "code": "734001"
    }, {
      "value": "肃南裕固族自治县",
      "label": "肃南裕固族自治县",
      "code": "734401"
    }, {
      "value": "民乐县",
      "label": "民乐县",
      "code": "734501"
    }, {
      "value": "临泽县",
      "label": "临泽县",
      "code": "734201"
    }, {
      "value": "高台县",
      "label": "高台县",
      "code": "734308"
    }, {
      "value": "山丹县",
      "label": "山丹县",
      "code": "734101"
    }],
    "value": "张掖市",
    "label": "张掖市"
  }, {
    "children": [{
      "value": "崆峒区",
      "label": "崆峒区",
      "code": "744001"
    }, {
      "value": "泾川县",
      "label": "泾川县",
      "code": "744301"
    }, {
      "value": "灵台县",
      "label": "灵台县",
      "code": "744408"
    }, {
      "value": "崇信县",
      "label": "崇信县",
      "code": "744201"
    }, {
      "value": "华亭县",
      "label": "华亭县",
      "code": "744101"
    }, {
      "value": "庄浪县",
      "label": "庄浪县",
      "code": "744601"
    }, {
      "value": "静宁县",
      "label": "静宁县",
      "code": "743401"
    }],
    "value": "平凉市",
    "label": "平凉市"
  }, {
    "children": [{
      "value": "肃州区",
      "label": "肃州区",
      "code": "735001"
    }, {
      "value": "金塔县",
      "label": "金塔县",
      "code": "735305"
    }, {
      "value": "瓜州县",
      "label": "瓜州县",
      "code": "736101"
    }, {
      "value": "肃北蒙古族自治县",
      "label": "肃北蒙古族自治县",
      "code": "736301"
    }, {
      "value": "阿克塞哈萨克族自治县",
      "label": "阿克塞哈萨克族自治县",
      "code": "736401"
    }, {
      "value": "玉门市",
      "label": "玉门市",
      "code": "735201"
    }, {
      "value": "敦煌市",
      "label": "敦煌市",
      "code": "736201"
    }],
    "value": "酒泉市",
    "label": "酒泉市"
  }, {
    "children": [{
      "value": "西峰区",
      "label": "西峰区",
      "code": "745001"
    }, {
      "value": "庆城县",
      "label": "庆城县",
      "code": "745101"
    }, {
      "value": "环县",
      "label": "环县",
      "code": "745711"
    }, {
      "value": "华池县",
      "label": "华池县",
      "code": "745601"
    }, {
      "value": "合水县",
      "label": "合水县",
      "code": "745401"
    }, {
      "value": "正宁县",
      "label": "正宁县",
      "code": "745307"
    }, {
      "value": "宁县",
      "label": "宁县",
      "code": "745205"
    }, {
      "value": "镇原县",
      "label": "镇原县",
      "code": "744501"
    }],
    "value": "庆阳市",
    "label": "庆阳市"
  }, {
    "children": [{
      "value": "安定区",
      "label": "安定区",
      "code": "743019"
    }, {
      "value": "通渭县",
      "label": "通渭县",
      "code": "743301"
    }, {
      "value": "陇西县",
      "label": "陇西县",
      "code": "748101"
    }, {
      "value": "渭源县",
      "label": "渭源县",
      "code": "748211"
    }, {
      "value": "临洮县",
      "label": "临洮县",
      "code": "730501"
    }, {
      "value": "漳县",
      "label": "漳县",
      "code": "748301"
    }, {
      "value": "岷县",
      "label": "岷县",
      "code": "748401"
    }],
    "value": "定西市",
    "label": "定西市"
  }, {
    "children": [{
      "value": "武都区",
      "label": "武都区",
      "code": "746001"
    }, {
      "value": "成县",
      "label": "成县",
      "code": "742508"
    }, {
      "value": "文县",
      "label": "文县",
      "code": "746401"
    }, {
      "value": "宕昌县",
      "label": "宕昌县",
      "code": "748508"
    }, {
      "value": "康县",
      "label": "康县",
      "code": "746511"
    }, {
      "value": "西和县",
      "label": "西和县",
      "code": "742107"
    }, {
      "value": "礼县",
      "label": "礼县",
      "code": "742213"
    }, {
      "value": "徽县",
      "label": "徽县",
      "code": "742313"
    }, {
      "value": "两当县",
      "label": "两当县",
      "code": "742403"
    }],
    "value": "陇南市",
    "label": "陇南市"
  }, {
    "children": [{
      "value": "临夏市",
      "label": "临夏市",
      "code": "731101"
    }, {
      "value": "临夏县",
      "label": "临夏县",
      "code": "731101"
    }, {
      "value": "康乐县",
      "label": "康乐县",
      "code": "731501"
    }, {
      "value": "永靖县",
      "label": "永靖县",
      "code": "731603"
    }, {
      "value": "广河县",
      "label": "广河县",
      "code": "731303"
    }, {
      "value": "和政县",
      "label": "和政县",
      "code": "731201"
    }, {
      "value": "东乡族自治县",
      "label": "东乡族自治县",
      "code": "731401"
    }, {
      "value": "积石山保安族东乡族撒拉族自治县",
      "label": "积石山保安族东乡族撒拉族自治县",
      "code": "731701"
    }],
    "value": "临夏回族自治州",
    "label": "临夏回族自治州"
  }, {
    "children": [{
      "value": "合作市",
      "label": "合作市",
      "code": "747001"
    }, {
      "value": "临潭县",
      "label": "临潭县",
      "code": "747501"
    }, {
      "value": "卓尼县",
      "label": "卓尼县",
      "code": "747601"
    }, {
      "value": "舟曲县",
      "label": "舟曲县",
      "code": "746301"
    }, {
      "value": "迭部县",
      "label": "迭部县",
      "code": "747405"
    }, {
      "value": "玛曲县",
      "label": "玛曲县",
      "code": "747301"
    }, {
      "value": "碌曲县",
      "label": "碌曲县",
      "code": "747201"
    }, {
      "value": "夏河县",
      "label": "夏河县",
      "code": "747101"
    }],
    "value": "甘南藏族自治州",
    "label": "甘南藏族自治州"
  }],
  "value": "甘肃省",
  "label": "甘肃省"
}, {
  "children": [{
    "children": [{
      "value": "城东区",
      "label": "城东区",
      "code": "810006"
    }, {
      "value": "城中区",
      "label": "城中区",
      "code": "810001"
    }, {
      "value": "城西区",
      "label": "城西区",
      "code": "810012"
    }, {
      "value": "城北区",
      "label": "城北区",
      "code": "810018"
    }, {
      "value": "大通回族土族自治县",
      "label": "大通回族土族自治县",
      "code": "810102"
    }, {
      "value": "湟中县",
      "label": "湟中县",
      "code": "811606"
    }, {
      "value": "湟源县",
      "label": "湟源县",
      "code": "812101"
    }],
    "value": "西宁市",
    "label": "西宁市"
  }, {
    "children": [{
      "value": "乐都区",
      "label": "乐都区",
      "code": "810701"
    }, {
      "value": "平安区",
      "label": "平安区",
      "code": "810601"
    }, {
      "value": "民和回族土族自治县",
      "label": "民和回族土族自治县",
      "code": "810801"
    }, {
      "value": "互助土族自治县",
      "label": "互助土族自治县",
      "code": "810501"
    }, {
      "value": "化隆回族自治县",
      "label": "化隆回族自治县",
      "code": "810901"
    }, {
      "value": "循化撒拉族自治县",
      "label": "循化撒拉族自治县",
      "code": "811101"
    }],
    "value": "海东市",
    "label": "海东市"
  }, {
    "children": [{
      "value": "门源回族自治县",
      "label": "门源回族自治县",
      "code": "810301"
    }, {
      "value": "祁连县",
      "label": "祁连县",
      "code": "810401"
    }, {
      "value": "海晏县",
      "label": "海晏县",
      "code": "810201"
    }, {
      "value": "刚察县",
      "label": "刚察县",
      "code": "812301"
    }],
    "value": "海北藏族自治州",
    "label": "海北藏族自治州"
  }, {
    "children": [{
      "value": "同仁县",
      "label": "同仁县",
      "code": "811301"
    }, {
      "value": "尖扎县",
      "label": "尖扎县",
      "code": "811201"
    }, {
      "value": "泽库县",
      "label": "泽库县",
      "code": "811401"
    }, {
      "value": "河南蒙古族自治县",
      "label": "河南蒙古族自治县",
      "code": "811501"
    }],
    "value": "黄南藏族自治州",
    "label": "黄南藏族自治州"
  }, {
    "children": [{
      "value": "共和县",
      "label": "共和县",
      "code": "813001"
    }, {
      "value": "同德县",
      "label": "同德县",
      "code": "813201"
    }, {
      "value": "贵德县",
      "label": "贵德县",
      "code": "811701"
    }, {
      "value": "兴海县",
      "label": "兴海县",
      "code": "813301"
    }, {
      "value": "贵南县",
      "label": "贵南县",
      "code": "813101"
    }],
    "value": "海南藏族自治州",
    "label": "海南藏族自治州"
  }, {
    "children": [{
      "value": "玛沁县",
      "label": "玛沁县",
      "code": "814001"
    }, {
      "value": "班玛县",
      "label": "班玛县",
      "code": "814301"
    }, {
      "value": "甘德县",
      "label": "甘德县",
      "code": "814101"
    }, {
      "value": "达日县",
      "label": "达日县",
      "code": "814201"
    }, {
      "value": "久治县",
      "label": "久治县",
      "code": "624701"
    }, {
      "value": "玛多县",
      "label": "玛多县",
      "code": "813501"
    }],
    "value": "果洛藏族自治州",
    "label": "果洛藏族自治州"
  }, {
    "children": [{
      "value": "玉树市",
      "label": "玉树市",
      "code": "815001"
    }, {
      "value": "杂多县",
      "label": "杂多县",
      "code": "815301"
    }, {
      "value": "称多县",
      "label": "称多县",
      "code": "815101"
    }, {
      "value": "治多县",
      "label": "治多县",
      "code": "815401"
    }, {
      "value": "囊谦县",
      "label": "囊谦县",
      "code": "815201"
    }, {
      "value": "曲麻莱县",
      "label": "曲麻莱县",
      "code": "815501"
    }],
    "value": "玉树藏族自治州",
    "label": "玉树藏族自治州"
  }, {
    "children": [{
      "value": "格尔木市",
      "label": "格尔木市",
      "code": "816001"
    }, {
      "value": "德令哈市",
      "label": "德令哈市",
      "code": "817001"
    }, {
      "value": "乌兰县",
      "label": "乌兰县",
      "code": "817101"
    }, {
      "value": "都兰县",
      "label": "都兰县",
      "code": "816101"
    }, {
      "value": "天峻县",
      "label": "天峻县",
      "code": "817201"
    }],
    "value": "海西蒙古族藏族自治州",
    "label": "海西蒙古族藏族自治州"
  }],
  "value": "青海省",
  "label": "青海省"
}, {
  "children": [{
    "children": [{
      "value": "兴庆区",
      "label": "兴庆区",
      "code": "750004"
    }, {
      "value": "西夏区",
      "label": "西夏区",
      "code": "750021"
    }, {
      "value": "金凤区",
      "label": "金凤区",
      "code": "750011"
    }, {
      "value": "永宁县",
      "label": "永宁县",
      "code": "750101"
    }, {
      "value": "贺兰县",
      "label": "贺兰县",
      "code": "750204"
    }, {
      "value": "灵武市",
      "label": "灵武市",
      "code": "750405"
    }],
    "value": "银川市",
    "label": "银川市"
  }, {
    "children": [{
      "value": "大武口区",
      "label": "大武口区",
      "code": "753001"
    }, {
      "value": "惠农区",
      "label": "惠农区",
      "code": "753202"
    }, {
      "value": "平罗县",
      "label": "平罗县",
      "code": "753401"
    }],
    "value": "石嘴山市",
    "label": "石嘴山市"
  }, {
    "children": [{
      "value": "利通区",
      "label": "利通区",
      "code": "751101"
    }, {
      "value": "红寺堡区",
      "label": "红寺堡区",
      "code": "751901"
    }, {
      "value": "盐池县",
      "label": "盐池县",
      "code": "751501"
    }, {
      "value": "同心县",
      "label": "同心县",
      "code": "751303"
    }, {
      "value": "青铜峡市",
      "label": "青铜峡市",
      "code": "751601"
    }],
    "value": "吴忠市",
    "label": "吴忠市"
  }, {
    "children": [{
      "value": "原州区",
      "label": "原州区",
      "code": "756025"
    }, {
      "value": "西吉县",
      "label": "西吉县",
      "code": "756213"
    }, {
      "value": "隆德县",
      "label": "隆德县",
      "code": "756303"
    }, {
      "value": "泾源县",
      "label": "泾源县",
      "code": "756401"
    }, {
      "value": "彭阳县",
      "label": "彭阳县",
      "code": "756504"
    }],
    "value": "固原市",
    "label": "固原市"
  }, {
    "children": [{
      "value": "沙坡头区",
      "label": "沙坡头区",
      "code": "755001"
    }, {
      "value": "中宁县",
      "label": "中宁县",
      "code": "755103"
    }, {
      "value": "海原县",
      "label": "海原县",
      "code": "755217"
    }],
    "value": "中卫市",
    "label": "中卫市"
  }],
  "value": "宁夏回族自治区",
  "label": "宁夏回族自治区"
}, {
  "children": [{
    "children": [{
      "value": "天山区",
      "label": "天山区",
      "code": "830001"
    }, {
      "value": "沙依巴克区",
      "label": "沙依巴克区",
      "code": "830006"
    }, {
      "value": "新市区",
      "label": "新市区",
      "code": "830026"
    }, {
      "value": "水磨沟区",
      "label": "水磨沟区",
      "code": "830063"
    }, {
      "value": "头屯河区",
      "label": "头屯河区",
      "code": "830023"
    }, {
      "value": "达坂城区",
      "label": "达坂城区",
      "code": "830039"
    }, {
      "value": "米东区",
      "label": "米东区",
      "code": "831401"
    }, {
      "value": "乌鲁木齐县",
      "label": "乌鲁木齐县",
      "code": "830074"
    }],
    "value": "乌鲁木齐市",
    "label": "乌鲁木齐市"
  }, {
    "children": [{
      "value": "独山子区",
      "label": "独山子区",
      "code": "833601"
    }, {
      "value": "克拉玛依区",
      "label": "克拉玛依区",
      "code": "834001"
    }, {
      "value": "白碱滩区",
      "label": "白碱滩区",
      "code": "834008"
    }, {
      "value": "乌尔禾区",
      "label": "乌尔禾区",
      "code": "834011"
    }],
    "value": "克拉玛依市",
    "label": "克拉玛依市"
  }, {
    "children": [{
      "value": "高昌区",
      "label": "高昌区",
      "code": "838001"
    }, {
      "value": "鄯善县",
      "label": "鄯善县",
      "code": "838201"
    }, {
      "value": "托克逊县",
      "label": "托克逊县",
      "code": "838101"
    }],
    "value": "吐鲁番市",
    "label": "吐鲁番市"
  }, {
    "children": [{
      "value": "哈密市",
      "label": "哈密市",
      "code": "839001"
    }, {
      "value": "巴里坤哈萨克自治县",
      "label": "巴里坤哈萨克自治县",
      "code": "839201"
    }, {
      "value": "伊吾县",
      "label": "伊吾县",
      "code": "839301"
    }],
    "value": "哈密地区",
    "label": "哈密地区"
  }, {
    "children": [{
      "value": "昌吉市",
      "label": "昌吉市",
      "code": "831116"
    }, {
      "value": "阜康市",
      "label": "阜康市",
      "code": "831501"
    }, {
      "value": "呼图壁县",
      "label": "呼图壁县",
      "code": "831201"
    }, {
      "value": "玛纳斯县",
      "label": "玛纳斯县",
      "code": "832201"
    }, {
      "value": "奇台县",
      "label": "奇台县",
      "code": "831801"
    }, {
      "value": "吉木萨尔县",
      "label": "吉木萨尔县",
      "code": "831701"
    }, {
      "value": "木垒哈萨克自治县",
      "label": "木垒哈萨克自治县",
      "code": "831901"
    }],
    "value": "昌吉回族自治州",
    "label": "昌吉回族自治州"
  }, {
    "children": [{
      "value": "博乐市",
      "label": "博乐市",
      "code": "833401"
    }, {
      "value": "阿拉山口市",
      "label": "阿拉山口市",
      "code": "833418"
    }, {
      "value": "精河县",
      "label": "精河县",
      "code": "833302"
    }, {
      "value": "温泉县",
      "label": "温泉县",
      "code": "833501"
    }],
    "value": "博尔塔拉蒙古自治州",
    "label": "博尔塔拉蒙古自治州"
  }, {
    "children": [{
      "value": "库尔勒市",
      "label": "库尔勒市",
      "code": "841001"
    }, {
      "value": "轮台县",
      "label": "轮台县",
      "code": "841601"
    }, {
      "value": "尉犁县",
      "label": "尉犁县",
      "code": "841501"
    }, {
      "value": "若羌县",
      "label": "若羌县",
      "code": "841801"
    }, {
      "value": "且末县",
      "label": "且末县",
      "code": "841901"
    }, {
      "value": "焉耆回族自治县",
      "label": "焉耆回族自治县",
      "code": "841101"
    }, {
      "value": "和静县",
      "label": "和静县",
      "code": "841305"
    }, {
      "value": "和硕县",
      "label": "和硕县",
      "code": "841201"
    }, {
      "value": "博湖县",
      "label": "博湖县",
      "code": "841401"
    }],
    "value": "巴音郭楞蒙古自治州",
    "label": "巴音郭楞蒙古自治州"
  }, {
    "children": [{
      "value": "阿克苏市",
      "label": "阿克苏市",
      "code": "843001"
    }, {
      "value": "温宿县",
      "label": "温宿县",
      "code": "843101"
    }, {
      "value": "库车县",
      "label": "库车县",
      "code": "842001"
    }, {
      "value": "沙雅县",
      "label": "沙雅县",
      "code": "842201"
    }, {
      "value": "新和县",
      "label": "新和县",
      "code": "842101"
    }, {
      "value": "拜城县",
      "label": "拜城县",
      "code": "842301"
    }, {
      "value": "乌什县",
      "label": "乌什县",
      "code": "843401"
    }, {
      "value": "阿瓦提县",
      "label": "阿瓦提县",
      "code": "843201"
    }, {
      "value": "柯坪县",
      "label": "柯坪县",
      "code": "843601"
    }],
    "value": "阿克苏地区",
    "label": "阿克苏地区"
  }, {
    "children": [{
      "value": "阿图什市",
      "label": "阿图什市",
      "code": "845351"
    }, {
      "value": "阿克陶县",
      "label": "阿克陶县",
      "code": "845551"
    }, {
      "value": "阿合奇县",
      "label": "阿合奇县",
      "code": "843501"
    }, {
      "value": "乌恰县",
      "label": "乌恰县",
      "code": "845451"
    }],
    "value": "克孜勒苏柯尔克孜自治州",
    "label": "克孜勒苏柯尔克孜自治州"
  }, {
    "children": [{
      "value": "喀什市",
      "label": "喀什市",
      "code": "844001"
    }, {
      "value": "疏附县",
      "label": "疏附县",
      "code": "844101"
    }, {
      "value": "疏勒县",
      "label": "疏勒县",
      "code": "844207"
    }, {
      "value": "英吉沙县",
      "label": "英吉沙县",
      "code": "844502"
    }, {
      "value": "泽普县",
      "label": "泽普县",
      "code": "844801"
    }, {
      "value": "莎车县",
      "label": "莎车县",
      "code": "844701"
    }, {
      "value": "叶城县",
      "label": "叶城县",
      "code": "844901"
    }, {
      "value": "麦盖提县",
      "label": "麦盖提县",
      "code": "844601"
    }, {
      "value": "岳普湖县",
      "label": "岳普湖县",
      "code": "844403"
    }, {
      "value": "伽师县",
      "label": "伽师县",
      "code": "844313"
    }, {
      "value": "巴楚县",
      "label": "巴楚县",
      "code": "843812"
    }, {
      "value": "塔什库尔干塔吉克自治县",
      "label": "塔什库尔干塔吉克自治县",
      "code": "845251"
    }],
    "value": "喀什地区",
    "label": "喀什地区"
  }, {
    "children": [{
      "value": "和田市",
      "label": "和田市",
      "code": "848001"
    }, {
      "value": "和田县",
      "label": "和田县",
      "code": "848007"
    }, {
      "value": "墨玉县",
      "label": "墨玉县",
      "code": "848109"
    }, {
      "value": "皮山县",
      "label": "皮山县",
      "code": "845151"
    }, {
      "value": "洛浦县",
      "label": "洛浦县",
      "code": "848201"
    }, {
      "value": "策勒县",
      "label": "策勒县",
      "code": "848301"
    }, {
      "value": "于田县",
      "label": "于田县",
      "code": "848403"
    }, {
      "value": "民丰县",
      "label": "民丰县",
      "code": "848501"
    }],
    "value": "和田地区",
    "label": "和田地区"
  }, {
    "children": [{
      "value": "伊宁市",
      "label": "伊宁市",
      "code": "835001"
    }, {
      "value": "奎屯市",
      "label": "奎屯市",
      "code": "833201"
    }, {
      "value": "霍尔果斯市",
      "label": "霍尔果斯市",
      "code": "835001"
    }, {
      "value": "伊宁县",
      "label": "伊宁县",
      "code": "835101"
    }, {
      "value": "察布查尔锡伯自治县",
      "label": "察布查尔锡伯自治县",
      "code": "835301"
    }, {
      "value": "霍城县",
      "label": "霍城县",
      "code": "835201"
    }, {
      "value": "巩留县",
      "label": "巩留县",
      "code": "835406"
    }, {
      "value": "新源县",
      "label": "新源县",
      "code": "835814"
    }, {
      "value": "昭苏县",
      "label": "昭苏县",
      "code": "835501"
    }, {
      "value": "特克斯县",
      "label": "特克斯县",
      "code": "835501"
    }, {
      "value": "尼勒克县",
      "label": "尼勒克县",
      "code": "835701"
    }],
    "value": "伊犁哈萨克自治州",
    "label": "伊犁哈萨克自治州"
  }, {
    "children": [{
      "value": "塔城市",
      "label": "塔城市",
      "code": "834701"
    }, {
      "value": "乌苏市",
      "label": "乌苏市",
      "code": "833011"
    }, {
      "value": "额敏县",
      "label": "额敏县",
      "code": "834601"
    }, {
      "value": "沙湾县",
      "label": "沙湾县",
      "code": "832101"
    }, {
      "value": "托里县",
      "label": "托里县",
      "code": "834505"
    }, {
      "value": "裕民县",
      "label": "裕民县",
      "code": "834801"
    }, {
      "value": "和布克赛尔蒙古自治县",
      "label": "和布克赛尔蒙古自治县",
      "code": "834401"
    }],
    "value": "塔城地区",
    "label": "塔城地区"
  }, {
    "children": [{
      "value": "阿勒泰市",
      "label": "阿勒泰市",
      "code": "836501"
    }, {
      "value": "布尔津县",
      "label": "布尔津县",
      "code": "836601"
    }, {
      "value": "富蕴县",
      "label": "富蕴县",
      "code": "836101"
    }, {
      "value": "福海县",
      "label": "福海县",
      "code": "836401"
    }, {
      "value": "哈巴河县",
      "label": "哈巴河县",
      "code": "836701"
    }, {
      "value": "青河县",
      "label": "青河县",
      "code": "836201"
    }, {
      "value": "吉木乃县",
      "label": "吉木乃县",
      "code": "836801"
    }],
    "value": "阿勒泰地区",
    "label": "阿勒泰地区"
  }, {
    "children": [{
      "value": "石河子市",
      "label": "石河子市",
      "code": "832001"
    }, {
      "value": "阿拉尔市",
      "label": "阿拉尔市",
      "code": "843301"
    }, {
      "value": "图木舒克市",
      "label": "图木舒克市",
      "code": "843901"
    }, {
      "value": "五家渠市",
      "label": "五家渠市",
      "code": "831301"
    }, {
      "value": "北屯市",
      "label": "北屯市",
      "code": "836001"
    }, {
      "value": "铁门关市",
      "label": "铁门关市",
      "code": "836001"
    }, {
      "value": "双河市",
      "label": "双河市",
      "code": "833408"
    }, {
      "value": "可克达拉市",
      "label": "可克达拉市",
      "code": "835201"
    }],
    "value": "自治区直辖县",
    "label": "自治区直辖县"
  }],
  "value": "新疆维吾尔自治区",
  "label": "新疆维吾尔自治区"
}, {
  "value": "台湾省",
  "label": "台湾省"
}, {
  "children": [{
    "children": [{
      "value": "北区",
      "label": "北区",
      "code": "999077"
    }, {
      "value": "东区",
      "label": "东区",
      "code": "999077"
    }, {
      "value": "南区",
      "label": "南区",
      "code": "999077"
    }, {
      "value": "油尖旺区",
      "label": "油尖旺区",
      "code": "999077"
    }, {
      "value": "深水埗区",
      "label": "深水埗区",
      "code": "999077"
    }, {
      "value": "九龙城区",
      "label": "九龙城区",
      "code": "999077"
    }, {
      "value": "黄大仙区",
      "label": "黄大仙区",
      "code": "999077"
    }, {
      "value": "观塘区",
      "label": "观塘区",
      "code": "999077"
    }, {
      "value": "中西区",
      "label": "中西区",
      "code": "999077"
    }, {
      "value": "湾仔区",
      "label": "湾仔区",
      "code": "999077"
    }, {
      "value": "大埔区",
      "label": "大埔区",
      "code": "999077"
    }, {
      "value": "沙田区",
      "label": "沙田区",
      "code": "999077"
    }, {
      "value": "西贡区",
      "label": "西贡区",
      "code": "999077"
    }, {
      "value": "荃湾区",
      "label": "荃湾区",
      "code": "999077"
    }, {
      "value": "屯门区",
      "label": "屯门区",
      "code": "999077"
    }, {
      "value": "元朗区",
      "label": "元朗区",
      "code": "999077"
    }, {
      "value": "葵青区",
      "label": "葵青区",
      "code": "999077"
    }, {
      "value": "离岛区",
      "label": "离岛区",
      "code": "999077"
    }],
    "value": "市辖区",
    "label": "市辖区"
  }],
  "value": "香港特别行政区",
  "label": "香港特别行政区"
}, {
  "value": "澳门特别行政区",
  "label": "澳门特别行政区"
}];

export default regionData;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/address/src/city-data.js
// module id = 1495
// module chunks = 2